(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var FAQ;

window.Backbone = require('backbone');

window.Backbone.$ = window.$;

FAQ = require('../../modules/faq/frontend/faq');



},{"../../modules/faq/frontend/faq":10,"backbone":68}],2:[function(require,module,exports){
(function (process){
/*global setImmediate: false, setTimeout: false, console: false */
(function () {

    var async = {};

    // global on the server, window in the browser
    var root, previous_async;

    root = this;
    if (root != null) {
      previous_async = root.async;
    }

    async.noConflict = function () {
        root.async = previous_async;
        return async;
    };

    function only_once(fn) {
        var called = false;
        return function() {
            if (called) throw new Error("Callback was already called.");
            called = true;
            fn.apply(root, arguments);
        }
    }

    //// cross-browser compatiblity functions ////

    var _each = function (arr, iterator) {
        if (arr.forEach) {
            return arr.forEach(iterator);
        }
        for (var i = 0; i < arr.length; i += 1) {
            iterator(arr[i], i, arr);
        }
    };

    var _map = function (arr, iterator) {
        if (arr.map) {
            return arr.map(iterator);
        }
        var results = [];
        _each(arr, function (x, i, a) {
            results.push(iterator(x, i, a));
        });
        return results;
    };

    var _reduce = function (arr, iterator, memo) {
        if (arr.reduce) {
            return arr.reduce(iterator, memo);
        }
        _each(arr, function (x, i, a) {
            memo = iterator(memo, x, i, a);
        });
        return memo;
    };

    var _keys = function (obj) {
        if (Object.keys) {
            return Object.keys(obj);
        }
        var keys = [];
        for (var k in obj) {
            if (obj.hasOwnProperty(k)) {
                keys.push(k);
            }
        }
        return keys;
    };

    //// exported async module functions ////

    //// nextTick implementation with browser-compatible fallback ////
    if (typeof process === 'undefined' || !(process.nextTick)) {
        if (typeof setImmediate === 'function') {
            async.setImmediate = setImmediate;
            async.nextTick = setImmediate;
        }
        else {
            async.nextTick = function (fn) {
                setTimeout(fn, 0);
            };
            async.setImmediate = async.nextTick;
        }
    }
    else {
        async.nextTick = process.nextTick;
        if (typeof setImmediate !== 'undefined') {
            async.setImmediate = setImmediate;
        }
        else {
            async.setImmediate = async.nextTick;
        }
    }

    async.each = function (arr, iterator, callback) {
        callback = callback || function () {};
        if (!arr.length) {
            return callback();
        }
        var completed = 0;
        _each(arr, function (x) {
            iterator(x, only_once(function (err) {
                if (err) {
                    callback(err);
                    callback = function () {};
                }
                else {
                    completed += 1;
                    if (completed >= arr.length) {
                        callback(null);
                    }
                }
            }));
        });
    };
    async.forEach = async.each;

    async.eachSeries = function (arr, iterator, callback) {
        callback = callback || function () {};
        if (!arr.length) {
            return callback();
        }
        var completed = 0;
        var iterate = function () {
            iterator(arr[completed], function (err) {
                if (err) {
                    callback(err);
                    callback = function () {};
                }
                else {
                    completed += 1;
                    if (completed >= arr.length) {
                        callback(null);
                    }
                    else {
                        iterate();
                    }
                }
            });
        };
        iterate();
    };
    async.forEachSeries = async.eachSeries;

    async.eachLimit = function (arr, limit, iterator, callback) {
        var fn = _eachLimit(limit);
        fn.apply(null, [arr, iterator, callback]);
    };
    async.forEachLimit = async.eachLimit;

    var _eachLimit = function (limit) {

        return function (arr, iterator, callback) {
            callback = callback || function () {};
            if (!arr.length || limit <= 0) {
                return callback();
            }
            var completed = 0;
            var started = 0;
            var running = 0;

            (function replenish () {
                if (completed >= arr.length) {
                    return callback();
                }

                while (running < limit && started < arr.length) {
                    started += 1;
                    running += 1;
                    iterator(arr[started - 1], function (err) {
                        if (err) {
                            callback(err);
                            callback = function () {};
                        }
                        else {
                            completed += 1;
                            running -= 1;
                            if (completed >= arr.length) {
                                callback();
                            }
                            else {
                                replenish();
                            }
                        }
                    });
                }
            })();
        };
    };


    var doParallel = function (fn) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            return fn.apply(null, [async.each].concat(args));
        };
    };
    var doParallelLimit = function(limit, fn) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            return fn.apply(null, [_eachLimit(limit)].concat(args));
        };
    };
    var doSeries = function (fn) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            return fn.apply(null, [async.eachSeries].concat(args));
        };
    };


    var _asyncMap = function (eachfn, arr, iterator, callback) {
        var results = [];
        arr = _map(arr, function (x, i) {
            return {index: i, value: x};
        });
        eachfn(arr, function (x, callback) {
            iterator(x.value, function (err, v) {
                results[x.index] = v;
                callback(err);
            });
        }, function (err) {
            callback(err, results);
        });
    };
    async.map = doParallel(_asyncMap);
    async.mapSeries = doSeries(_asyncMap);
    async.mapLimit = function (arr, limit, iterator, callback) {
        return _mapLimit(limit)(arr, iterator, callback);
    };

    var _mapLimit = function(limit) {
        return doParallelLimit(limit, _asyncMap);
    };

    // reduce only has a series version, as doing reduce in parallel won't
    // work in many situations.
    async.reduce = function (arr, memo, iterator, callback) {
        async.eachSeries(arr, function (x, callback) {
            iterator(memo, x, function (err, v) {
                memo = v;
                callback(err);
            });
        }, function (err) {
            callback(err, memo);
        });
    };
    // inject alias
    async.inject = async.reduce;
    // foldl alias
    async.foldl = async.reduce;

    async.reduceRight = function (arr, memo, iterator, callback) {
        var reversed = _map(arr, function (x) {
            return x;
        }).reverse();
        async.reduce(reversed, memo, iterator, callback);
    };
    // foldr alias
    async.foldr = async.reduceRight;

    var _filter = function (eachfn, arr, iterator, callback) {
        var results = [];
        arr = _map(arr, function (x, i) {
            return {index: i, value: x};
        });
        eachfn(arr, function (x, callback) {
            iterator(x.value, function (v) {
                if (v) {
                    results.push(x);
                }
                callback();
            });
        }, function (err) {
            callback(_map(results.sort(function (a, b) {
                return a.index - b.index;
            }), function (x) {
                return x.value;
            }));
        });
    };
    async.filter = doParallel(_filter);
    async.filterSeries = doSeries(_filter);
    // select alias
    async.select = async.filter;
    async.selectSeries = async.filterSeries;

    var _reject = function (eachfn, arr, iterator, callback) {
        var results = [];
        arr = _map(arr, function (x, i) {
            return {index: i, value: x};
        });
        eachfn(arr, function (x, callback) {
            iterator(x.value, function (v) {
                if (!v) {
                    results.push(x);
                }
                callback();
            });
        }, function (err) {
            callback(_map(results.sort(function (a, b) {
                return a.index - b.index;
            }), function (x) {
                return x.value;
            }));
        });
    };
    async.reject = doParallel(_reject);
    async.rejectSeries = doSeries(_reject);

    var _detect = function (eachfn, arr, iterator, main_callback) {
        eachfn(arr, function (x, callback) {
            iterator(x, function (result) {
                if (result) {
                    main_callback(x);
                    main_callback = function () {};
                }
                else {
                    callback();
                }
            });
        }, function (err) {
            main_callback();
        });
    };
    async.detect = doParallel(_detect);
    async.detectSeries = doSeries(_detect);

    async.some = function (arr, iterator, main_callback) {
        async.each(arr, function (x, callback) {
            iterator(x, function (v) {
                if (v) {
                    main_callback(true);
                    main_callback = function () {};
                }
                callback();
            });
        }, function (err) {
            main_callback(false);
        });
    };
    // any alias
    async.any = async.some;

    async.every = function (arr, iterator, main_callback) {
        async.each(arr, function (x, callback) {
            iterator(x, function (v) {
                if (!v) {
                    main_callback(false);
                    main_callback = function () {};
                }
                callback();
            });
        }, function (err) {
            main_callback(true);
        });
    };
    // all alias
    async.all = async.every;

    async.sortBy = function (arr, iterator, callback) {
        async.map(arr, function (x, callback) {
            iterator(x, function (err, criteria) {
                if (err) {
                    callback(err);
                }
                else {
                    callback(null, {value: x, criteria: criteria});
                }
            });
        }, function (err, results) {
            if (err) {
                return callback(err);
            }
            else {
                var fn = function (left, right) {
                    var a = left.criteria, b = right.criteria;
                    return a < b ? -1 : a > b ? 1 : 0;
                };
                callback(null, _map(results.sort(fn), function (x) {
                    return x.value;
                }));
            }
        });
    };

    async.auto = function (tasks, callback) {
        callback = callback || function () {};
        var keys = _keys(tasks);
        if (!keys.length) {
            return callback(null);
        }

        var results = {};

        var listeners = [];
        var addListener = function (fn) {
            listeners.unshift(fn);
        };
        var removeListener = function (fn) {
            for (var i = 0; i < listeners.length; i += 1) {
                if (listeners[i] === fn) {
                    listeners.splice(i, 1);
                    return;
                }
            }
        };
        var taskComplete = function () {
            _each(listeners.slice(0), function (fn) {
                fn();
            });
        };

        addListener(function () {
            if (_keys(results).length === keys.length) {
                callback(null, results);
                callback = function () {};
            }
        });

        _each(keys, function (k) {
            var task = (tasks[k] instanceof Function) ? [tasks[k]]: tasks[k];
            var taskCallback = function (err) {
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length <= 1) {
                    args = args[0];
                }
                if (err) {
                    var safeResults = {};
                    _each(_keys(results), function(rkey) {
                        safeResults[rkey] = results[rkey];
                    });
                    safeResults[k] = args;
                    callback(err, safeResults);
                    // stop subsequent errors hitting callback multiple times
                    callback = function () {};
                }
                else {
                    results[k] = args;
                    async.setImmediate(taskComplete);
                }
            };
            var requires = task.slice(0, Math.abs(task.length - 1)) || [];
            var ready = function () {
                return _reduce(requires, function (a, x) {
                    return (a && results.hasOwnProperty(x));
                }, true) && !results.hasOwnProperty(k);
            };
            if (ready()) {
                task[task.length - 1](taskCallback, results);
            }
            else {
                var listener = function () {
                    if (ready()) {
                        removeListener(listener);
                        task[task.length - 1](taskCallback, results);
                    }
                };
                addListener(listener);
            }
        });
    };

    async.waterfall = function (tasks, callback) {
        callback = callback || function () {};
        if (tasks.constructor !== Array) {
          var err = new Error('First argument to waterfall must be an array of functions');
          return callback(err);
        }
        if (!tasks.length) {
            return callback();
        }
        var wrapIterator = function (iterator) {
            return function (err) {
                if (err) {
                    callback.apply(null, arguments);
                    callback = function () {};
                }
                else {
                    var args = Array.prototype.slice.call(arguments, 1);
                    var next = iterator.next();
                    if (next) {
                        args.push(wrapIterator(next));
                    }
                    else {
                        args.push(callback);
                    }
                    async.setImmediate(function () {
                        iterator.apply(null, args);
                    });
                }
            };
        };
        wrapIterator(async.iterator(tasks))();
    };

    var _parallel = function(eachfn, tasks, callback) {
        callback = callback || function () {};
        if (tasks.constructor === Array) {
            eachfn.map(tasks, function (fn, callback) {
                if (fn) {
                    fn(function (err) {
                        var args = Array.prototype.slice.call(arguments, 1);
                        if (args.length <= 1) {
                            args = args[0];
                        }
                        callback.call(null, err, args);
                    });
                }
            }, callback);
        }
        else {
            var results = {};
            eachfn.each(_keys(tasks), function (k, callback) {
                tasks[k](function (err) {
                    var args = Array.prototype.slice.call(arguments, 1);
                    if (args.length <= 1) {
                        args = args[0];
                    }
                    results[k] = args;
                    callback(err);
                });
            }, function (err) {
                callback(err, results);
            });
        }
    };

    async.parallel = function (tasks, callback) {
        _parallel({ map: async.map, each: async.each }, tasks, callback);
    };

    async.parallelLimit = function(tasks, limit, callback) {
        _parallel({ map: _mapLimit(limit), each: _eachLimit(limit) }, tasks, callback);
    };

    async.series = function (tasks, callback) {
        callback = callback || function () {};
        if (tasks.constructor === Array) {
            async.mapSeries(tasks, function (fn, callback) {
                if (fn) {
                    fn(function (err) {
                        var args = Array.prototype.slice.call(arguments, 1);
                        if (args.length <= 1) {
                            args = args[0];
                        }
                        callback.call(null, err, args);
                    });
                }
            }, callback);
        }
        else {
            var results = {};
            async.eachSeries(_keys(tasks), function (k, callback) {
                tasks[k](function (err) {
                    var args = Array.prototype.slice.call(arguments, 1);
                    if (args.length <= 1) {
                        args = args[0];
                    }
                    results[k] = args;
                    callback(err);
                });
            }, function (err) {
                callback(err, results);
            });
        }
    };

    async.iterator = function (tasks) {
        var makeCallback = function (index) {
            var fn = function () {
                if (tasks.length) {
                    tasks[index].apply(null, arguments);
                }
                return fn.next();
            };
            fn.next = function () {
                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
            };
            return fn;
        };
        return makeCallback(0);
    };

    async.apply = function (fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function () {
            return fn.apply(
                null, args.concat(Array.prototype.slice.call(arguments))
            );
        };
    };

    var _concat = function (eachfn, arr, fn, callback) {
        var r = [];
        eachfn(arr, function (x, cb) {
            fn(x, function (err, y) {
                r = r.concat(y || []);
                cb(err);
            });
        }, function (err) {
            callback(err, r);
        });
    };
    async.concat = doParallel(_concat);
    async.concatSeries = doSeries(_concat);

    async.whilst = function (test, iterator, callback) {
        if (test()) {
            iterator(function (err) {
                if (err) {
                    return callback(err);
                }
                async.whilst(test, iterator, callback);
            });
        }
        else {
            callback();
        }
    };

    async.doWhilst = function (iterator, test, callback) {
        iterator(function (err) {
            if (err) {
                return callback(err);
            }
            if (test()) {
                async.doWhilst(iterator, test, callback);
            }
            else {
                callback();
            }
        });
    };

    async.until = function (test, iterator, callback) {
        if (!test()) {
            iterator(function (err) {
                if (err) {
                    return callback(err);
                }
                async.until(test, iterator, callback);
            });
        }
        else {
            callback();
        }
    };

    async.doUntil = function (iterator, test, callback) {
        iterator(function (err) {
            if (err) {
                return callback(err);
            }
            if (!test()) {
                async.doUntil(iterator, test, callback);
            }
            else {
                callback();
            }
        });
    };

    async.queue = function (worker, concurrency) {
        if (concurrency === undefined) {
            concurrency = 1;
        }
        function _insert(q, data, pos, callback) {
          if(data.constructor !== Array) {
              data = [data];
          }
          _each(data, function(task) {
              var item = {
                  data: task,
                  callback: typeof callback === 'function' ? callback : null
              };

              if (pos) {
                q.tasks.unshift(item);
              } else {
                q.tasks.push(item);
              }

              if (q.saturated && q.tasks.length === concurrency) {
                  q.saturated();
              }
              async.setImmediate(q.process);
          });
        }

        var workers = 0;
        var q = {
            tasks: [],
            concurrency: concurrency,
            saturated: null,
            empty: null,
            drain: null,
            push: function (data, callback) {
              _insert(q, data, false, callback);
            },
            unshift: function (data, callback) {
              _insert(q, data, true, callback);
            },
            process: function () {
                if (workers < q.concurrency && q.tasks.length) {
                    var task = q.tasks.shift();
                    if (q.empty && q.tasks.length === 0) {
                        q.empty();
                    }
                    workers += 1;
                    var next = function () {
                        workers -= 1;
                        if (task.callback) {
                            task.callback.apply(task, arguments);
                        }
                        if (q.drain && q.tasks.length + workers === 0) {
                            q.drain();
                        }
                        q.process();
                    };
                    var cb = only_once(next);
                    worker(task.data, cb);
                }
            },
            length: function () {
                return q.tasks.length;
            },
            running: function () {
                return workers;
            }
        };
        return q;
    };

    async.cargo = function (worker, payload) {
        var working     = false,
            tasks       = [];

        var cargo = {
            tasks: tasks,
            payload: payload,
            saturated: null,
            empty: null,
            drain: null,
            push: function (data, callback) {
                if(data.constructor !== Array) {
                    data = [data];
                }
                _each(data, function(task) {
                    tasks.push({
                        data: task,
                        callback: typeof callback === 'function' ? callback : null
                    });
                    if (cargo.saturated && tasks.length === payload) {
                        cargo.saturated();
                    }
                });
                async.setImmediate(cargo.process);
            },
            process: function process() {
                if (working) return;
                if (tasks.length === 0) {
                    if(cargo.drain) cargo.drain();
                    return;
                }

                var ts = typeof payload === 'number'
                            ? tasks.splice(0, payload)
                            : tasks.splice(0);

                var ds = _map(ts, function (task) {
                    return task.data;
                });

                if(cargo.empty) cargo.empty();
                working = true;
                worker(ds, function () {
                    working = false;

                    var args = arguments;
                    _each(ts, function (data) {
                        if (data.callback) {
                            data.callback.apply(null, args);
                        }
                    });

                    process();
                });
            },
            length: function () {
                return tasks.length;
            },
            running: function () {
                return working;
            }
        };
        return cargo;
    };

    var _console_fn = function (name) {
        return function (fn) {
            var args = Array.prototype.slice.call(arguments, 1);
            fn.apply(null, args.concat([function (err) {
                var args = Array.prototype.slice.call(arguments, 1);
                if (typeof console !== 'undefined') {
                    if (err) {
                        if (console.error) {
                            console.error(err);
                        }
                    }
                    else if (console[name]) {
                        _each(args, function (x) {
                            console[name](x);
                        });
                    }
                }
            }]));
        };
    };
    async.log = _console_fn('log');
    async.dir = _console_fn('dir');
    /*async.info = _console_fn('info');
    async.warn = _console_fn('warn');
    async.error = _console_fn('error');*/

    async.memoize = function (fn, hasher) {
        var memo = {};
        var queues = {};
        hasher = hasher || function (x) {
            return x;
        };
        var memoized = function () {
            var args = Array.prototype.slice.call(arguments);
            var callback = args.pop();
            var key = hasher.apply(null, args);
            if (key in memo) {
                callback.apply(null, memo[key]);
            }
            else if (key in queues) {
                queues[key].push(callback);
            }
            else {
                queues[key] = [callback];
                fn.apply(null, args.concat([function () {
                    memo[key] = arguments;
                    var q = queues[key];
                    delete queues[key];
                    for (var i = 0, l = q.length; i < l; i++) {
                      q[i].apply(null, arguments);
                    }
                }]));
            }
        };
        memoized.memo = memo;
        memoized.unmemoized = fn;
        return memoized;
    };

    async.unmemoize = function (fn) {
      return function () {
        return (fn.unmemoized || fn).apply(null, arguments);
      };
    };

    async.times = function (count, iterator, callback) {
        var counter = [];
        for (var i = 0; i < count; i++) {
            counter.push(i);
        }
        return async.map(counter, iterator, callback);
    };

    async.timesSeries = function (count, iterator, callback) {
        var counter = [];
        for (var i = 0; i < count; i++) {
            counter.push(i);
        }
        return async.mapSeries(counter, iterator, callback);
    };

    async.compose = function (/* functions... */) {
        var fns = Array.prototype.reverse.call(arguments);
        return function () {
            var that = this;
            var args = Array.prototype.slice.call(arguments);
            var callback = args.pop();
            async.reduce(fns, args, function (newargs, fn, cb) {
                fn.apply(that, newargs.concat([function () {
                    var err = arguments[0];
                    var nextargs = Array.prototype.slice.call(arguments, 1);
                    cb(err, nextargs);
                }]))
            },
            function (err, results) {
                callback.apply(that, [err].concat(results));
            });
        };
    };

    var _applyEach = function (eachfn, fns /*args...*/) {
        var go = function () {
            var that = this;
            var args = Array.prototype.slice.call(arguments);
            var callback = args.pop();
            return eachfn(fns, function (fn, cb) {
                fn.apply(that, args.concat([cb]));
            },
            callback);
        };
        if (arguments.length > 2) {
            var args = Array.prototype.slice.call(arguments, 2);
            return go.apply(this, args);
        }
        else {
            return go;
        }
    };
    async.applyEach = doParallel(_applyEach);
    async.applyEachSeries = doSeries(_applyEach);

    async.forever = function (fn, callback) {
        function next(err) {
            if (err) {
                if (callback) {
                    return callback(err);
                }
                throw err;
            }
            fn(next);
        }
        next();
    };

    // AMD / RequireJS
    if (typeof define !== 'undefined' && define.amd) {
        define([], function () {
            return async;
        });
    }
    // Node.js
    else if (typeof module !== 'undefined' && module.exports) {
        module.exports = async;
    }
    // included directly via <script> tag
    else {
        root.async = async;
    }

}());
}).call(this,require('_process'))

},{"_process":69}],3:[function(require,module,exports){
/*
 *	jQuery dotdotdot 1.6.12
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */

(function( $, undef )
{
	if ( $.fn.dotdotdot )
	{
		return;
	}

	$.fn.dotdotdot = function( o )
	{
		if ( this.length == 0 )
		{
			$.fn.dotdotdot.debug( 'No element found for "' + this.selector + '".' );
			return this;
		}
		if ( this.length > 1 )
		{
			return this.each(
				function()
				{
					$(this).dotdotdot( o );
				}
			);
		}


		var $dot = this;

		if ( $dot.data( 'dotdotdot' ) )
		{
			$dot.trigger( 'destroy.dot' );
		}

		$dot.data( 'dotdotdot-style', $dot.attr( 'style' ) || '' );
		$dot.css( 'word-wrap', 'break-word' );
		if ($dot.css( 'white-space' ) === 'nowrap')
		{
			$dot.css( 'white-space', 'normal' );
		}

		$dot.bind_events = function()
		{
			$dot.bind(
				'update.dot',
				function( e, c )
				{
					e.preventDefault();
					e.stopPropagation();

					opts.maxHeight = ( typeof opts.height == 'number' )
						? opts.height
						: getTrueInnerHeight( $dot );

					opts.maxHeight += opts.tolerance;

					if ( typeof c != 'undefined' )
					{
						if ( typeof c == 'string' || c instanceof HTMLElement )
						{
					 		c = $('<div />').append( c ).contents();
						}
						if ( c instanceof $ )
						{
							orgContent = c;
						}
					}

					$inr = $dot.wrapInner( '<div class="dotdotdot" />' ).children();
					$inr.contents()
						.detach()
						.end()
						.append( orgContent.clone( true ) )
						.find( 'br' ).replaceWith( '  <br />  ' ).end()
						.css({
							'height'	: 'auto',
							'width'		: 'auto',
							'border'	: 'none',
							'padding'	: 0,
							'margin'	: 0
						});

					var after = false,
						trunc = false;

					if ( conf.afterElement )
					{
						after = conf.afterElement.clone( true );
					    after.show();
						conf.afterElement.detach();
					}

					if ( test( $inr, opts ) )
					{
						if ( opts.wrap == 'children' )
						{
							trunc = children( $inr, opts, after );
						}
						else
						{
							trunc = ellipsis( $inr, $dot, $inr, opts, after );
						}
					}
					$inr.replaceWith( $inr.contents() );
					$inr = null;

					if ( $.isFunction( opts.callback ) )
					{
						opts.callback.call( $dot[ 0 ], trunc, orgContent );
					}

					conf.isTruncated = trunc;
					return trunc;
				}

			).bind(
				'isTruncated.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], conf.isTruncated );
					}
					return conf.isTruncated;
				}

			).bind(
				'originalContent.dot',
				function( e, fn )
				{
					e.preventDefault();
					e.stopPropagation();

					if ( typeof fn == 'function' )
					{
						fn.call( $dot[ 0 ], orgContent );
					}
					return orgContent;
				}

			).bind(
				'destroy.dot',
				function( e )
				{
					e.preventDefault();
					e.stopPropagation();

					$dot.unwatch()
						.unbind_events()
						.contents()
						.detach()
						.end()
						.append( orgContent )
						.attr( 'style', $dot.data( 'dotdotdot-style' ) || '' )
						.data( 'dotdotdot', false );
				}
			);
			return $dot;
		};	//	/bind_events

		$dot.unbind_events = function()
		{
			$dot.unbind('.dot');
			return $dot;
		};	//	/unbind_events

		$dot.watch = function()
		{
			$dot.unwatch();
			if ( opts.watch == 'window' )
			{
				var $window = $(window),
					_wWidth = $window.width(),
					_wHeight = $window.height();

				$window.bind(
					'resize.dot' + conf.dotId,
					function()
					{
						if ( _wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix )
						{
							_wWidth = $window.width();
							_wHeight = $window.height();

							if ( watchInt )
							{
								clearInterval( watchInt );
							}
							watchInt = setTimeout(
								function()
								{
									$dot.trigger( 'update.dot' );
								}, 10
							);
						}
					}
				);
			}
			else
			{
				watchOrg = getSizes( $dot );
				watchInt = setInterval(
					function()
					{
						var watchNew = getSizes( $dot );
						if ( watchOrg.width  != watchNew.width ||
							 watchOrg.height != watchNew.height )
						{
							$dot.trigger( 'update.dot' );
							watchOrg = getSizes( $dot );
						}
					}, 100
				);
			}
			return $dot;
		};
		$dot.unwatch = function()
		{
			$(window).unbind( 'resize.dot' + conf.dotId );
			if ( watchInt )
			{
				clearInterval( watchInt );
			}
			return $dot;
		};

		var	orgContent	= $dot.contents(),
			opts 		= $.extend( true, {}, $.fn.dotdotdot.defaults, o ),
			conf		= {},
			watchOrg	= {},
			watchInt	= null,
			$inr		= null;


		if ( !( opts.lastCharacter.remove instanceof Array ) )
		{
			opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
		}
		if ( !( opts.lastCharacter.noEllipsis instanceof Array ) )
		{
			opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
		}


		conf.afterElement	= getElement( opts.after, $dot );
		conf.isTruncated	= false;
		conf.dotId			= dotId++;


		$dot.data( 'dotdotdot', true )
			.bind_events()
			.trigger( 'update.dot' );

		if ( opts.watch )
		{
			$dot.watch();
		}

		return $dot;
	};


	//	public
	$.fn.dotdotdot.defaults = {
		'ellipsis'			: '... ',
		'wrap'				: 'word',
		'fallbackToLetter'	: true,
		'lastCharacter'		: {},
		'tolerance'			: 0,
		'callback'			: null,
		'after'				: null,
		'height'			: null,
		'watch'				: false,
		'windowResizeFix'	: true
	};
	$.fn.dotdotdot.defaultArrays = {
		'lastCharacter'		: {
			'remove'			: [ ' ', '\u3000', ',', ';', '.', '!', '?' ],
			'noEllipsis'		: []
		}
	};
	$.fn.dotdotdot.debug = function( msg ) {};


	//	private
	var dotId = 1;

	function children( $elem, o, after )
	{
		var $elements 	= $elem.children(),
			isTruncated	= false;

		$elem.empty();

		for ( var a = 0, l = $elements.length; a < l; a++ )
		{
			var $e = $elements.eq( a );
			$elem.append( $e );
			if ( after )
			{
				$elem.append( after );
			}
			if ( test( $elem, o ) )
			{
				$e.remove();
				isTruncated = true;
				break;
			}
			else
			{
				if ( after )
				{
					after.detach();
				}
			}
		}
		return isTruncated;
	}
	function ellipsis( $elem, $d, $i, o, after )
	{
		var isTruncated	= false;

		//	Don't put the ellipsis directly inside these elements
		var notx = 'table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';

		//	Don't remove these elements even if they are after the ellipsis
		var noty = 'script';

		$elem
			.contents()
			.detach()
			.each(
				function()
				{

					var e	= this,
						$e	= $(e);

					if ( typeof e == 'undefined' || ( e.nodeType == 3 && $.trim( e.data ).length == 0 ) )
					{
						return true;
					}
					else if ( $e.is( noty ) )
					{
						$elem.append( $e );
					}
					else if ( isTruncated )
					{
						return true;
					}
					else
					{
						$elem.append( $e );
						if ( after )
						{
							$elem[ $elem.is( notx ) ? 'after' : 'append' ]( after );
						}
						if ( test( $i, o ) )
						{
							if ( e.nodeType == 3 ) // node is TEXT
							{
								isTruncated = ellipsisElement( $e, $d, $i, o, after );
							}
							else
							{
								isTruncated = ellipsis( $e, $d, $i, o, after );
							}

							if ( !isTruncated )
							{
								$e.detach();
								isTruncated = true;
							}
						}

						if ( !isTruncated )
						{
							if ( after )
							{
								after.detach();
							}
						}
					}
				}
			);

		return isTruncated;
	}
	function ellipsisElement( $e, $d, $i, o, after )
	{
		var e = $e[ 0 ];

		if ( !e )
		{
			return false;
		}

		var txt			= getTextContent( e ),
			space		= ( txt.indexOf(' ') !== -1 ) ? ' ' : '\u3000',
			separator	= ( o.wrap == 'letter' ) ? '' : space,
			textArr		= txt.split( separator ),
			position 	= -1,
			midPos		= -1,
			startPos	= 0,
			endPos		= textArr.length - 1;


		//	Only one word
		if ( o.fallbackToLetter && startPos == 0 && endPos == 0 )
		{
			separator	= '';
			textArr		= txt.split( separator );
			endPos		= textArr.length - 1;
		}

		while ( startPos <= endPos && !( startPos == 0 && endPos == 0 ) )
		{
			var m = Math.floor( ( startPos + endPos ) / 2 );
			if ( m == midPos )
			{
				break;
			}
			midPos = m;

			setTextContent( e, textArr.slice( 0, midPos + 1 ).join( separator ) + o.ellipsis );

			if ( !test( $i, o ) )
			{
				position = midPos;
				startPos = midPos;
			}
			else
			{
				endPos = midPos;

				//	Fallback to letter
				if (o.fallbackToLetter && startPos == 0 && endPos == 0 )
				{
					separator	= '';
					textArr		= textArr[ 0 ].split( separator );
					position	= -1;
					midPos		= -1;
					startPos	= 0;
					endPos		= textArr.length - 1;
				}
			}
		}

		if ( position != -1 && !( textArr.length == 1 && textArr[ 0 ].length == 0 ) )
		{
			txt = addEllipsis( textArr.slice( 0, position + 1 ).join( separator ), o );
			setTextContent( e, txt );
		}
		else
		{
			var $w = $e.parent();
			$e.detach();

			var afterLength = ( after && after.closest($w).length ) ? after.length : 0;

			if ( $w.contents().length > afterLength )
			{
				e = findLastTextNode( $w.contents().eq( -1 - afterLength ), $d );
			}
			else
			{
				e = findLastTextNode( $w, $d, true );
				if ( !afterLength )
				{
					$w.detach();
				}
			}
			if ( e )
			{
				txt = addEllipsis( getTextContent( e ), o );
				setTextContent( e, txt );
				if ( afterLength && after )
				{
					$(e).parent().append( after );
				}
			}
		}

		return true;
	}
	function test( $i, o )
	{
		return $i.innerHeight() > o.maxHeight;
	}
	function addEllipsis( txt, o )
	{
		while( $.inArray( txt.slice( -1 ), o.lastCharacter.remove ) > -1 )
		{
			txt = txt.slice( 0, -1 );
		}
		if ( $.inArray( txt.slice( -1 ), o.lastCharacter.noEllipsis ) < 0 )
		{
			txt += o.ellipsis;
		}
		return txt;
	}
	function getSizes( $d )
	{
		return {
			'width'	: $d.innerWidth(),
			'height': $d.innerHeight()
		};
	}
	function setTextContent( e, content )
	{
		if ( e.innerText )
		{
			e.innerText = content;
		}
		else if ( e.nodeValue )
		{
			e.nodeValue = content;
		}
		else if (e.textContent)
		{
			e.textContent = content;
		}

	}
	function getTextContent( e )
	{
		if ( e.innerText )
		{
			return e.innerText;
		}
		else if ( e.nodeValue )
		{
			return e.nodeValue;
		}
		else if ( e.textContent )
		{
			return e.textContent;
		}
		else
		{
			return "";
		}
	}
	function getPrevNode( n )
	{
		do
		{
			n = n.previousSibling;
		}
		while ( n && n.nodeType !== 1 && n.nodeType !== 3 );

		return n;
	}
	function findLastTextNode( $el, $top, excludeCurrent )
	{
		var e = $el && $el[ 0 ], p;
		if ( e )
		{
			if ( !excludeCurrent )
			{
				if ( e.nodeType === 3 )
				{
					return e;
				}
				if ( $.trim( $el.text() ) )
				{
					return findLastTextNode( $el.contents().last(), $top );
				}
			}
			p = getPrevNode( e );
			while ( !p )
			{
				$el = $el.parent();
				if ( $el.is( $top ) || !$el.length )
				{
					return false;
				}
				p = getPrevNode( $el[0] );
			}
			if ( p )
			{
				return findLastTextNode( $(p), $top );
			}
		}
		return false;
	}
	function getElement( e, $i )
	{
		if ( !e )
		{
			return false;
		}
		if ( typeof e === 'string' )
		{
			e = $(e, $i);
			return ( e.length )
				? e
				: false;
		}
		return !e.jquery
			? false
			: e;
	}
	function getTrueInnerHeight( $el )
	{
		var h = $el.innerHeight(),
			a = [ 'paddingTop', 'paddingBottom' ];

		for ( var z = 0, l = a.length; z < l; z++ )
		{
			var m = parseInt( $el.css( a[ z ] ), 10 );
			if ( isNaN( m ) )
			{
				m = 0;
			}
			h -= m;
		}
		return h;
	}


	//	override jQuery.html
	var _orgHtml = $.fn.html;
	$.fn.html = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			return this.trigger( 'update', [ str ] );
		}
		return _orgHtml.apply( this, arguments );
	};


	//	override jQuery.text
	var _orgText = $.fn.text;
	$.fn.text = function( str )
	{
		if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
		{
			str = $( '<div />' ).text( str ).html();
			return this.trigger( 'update', [ str ] );
		}
		return _orgText.apply( this, arguments );
	};


})( jQuery );
},{}],4:[function(require,module,exports){
var PresentersBase;

PresentersBase = {
  getI18n: function(I18nScope) {
    var scope;
    scope = I18nScope;
    if (scope != null) {
      return I18n.scoped(scope);
    } else {
      return I18n;
    }
  },
  toHashWithHelpers: function(hash, I18nScope) {
    var presenterHash;
    presenterHash = _.clone(hash);
    return I18n.mixin(presenterHash, this.getI18n(I18nScope));
  }
};

module.exports = PresentersBase;



},{}],5:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("item",c,p,1),c,p,0,9,82,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("text",c,p,1),c,p,0,19,72,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div>");t.b("\n" + i);t.b("<a href=\"#");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("text",c,p,0)));t.b("\n" + i);t.b("</a>");t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#item}}\n{{#text}}\n<div>\n<a href=\"#{{id}}\">\n    {{{text}}}\n</a>\n</div>\n{{/text}}\n{{/item}}\n", Hogan);
},{"hogan.js":71}],6:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"autoSuggestion-list\">");t.b("\n" + i);if(!t.s(t.f("isV2",c,p,1),c,p,1,0,0,"")){t.b("    <ul id=\"suggestion-list\">");t.b("\n" + i);t.b("    </ul>");t.b("\n" + i);};if(t.s(t.f("isV2",c,p,1),c,p,0,109,229,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"search-result-header\">");t.b(t.v(t.f("searchQuery",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    <ul id=\"suggestion-list\" class=\"unstyled\">");t.b("\n" + i);t.b("    </ul>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"autoSuggestion-list\">\n  {{^isV2}}\n    <ul id=\"suggestion-list\">\n    </ul>\n  {{/isV2}}\n  {{#isV2}}\n    <div class=\"search-result-header\">{{searchQuery}}</div>\n    <ul id=\"suggestion-list\" class=\"unstyled\">\n    </ul>\n  {{/isV2}}\n</div>\n", Hogan);
},{"hogan.js":71}],7:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("show",c,p,1),c,p,0,9,283,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"breadcrumb\">");t.b("\n" + i);if(t.s(t.f("levels",c,p,1),c,p,0,48,264,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("isCurrentLevel",c,p,1),c,p,1,0,0,"")){t.b("      <a searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b(t.v(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <span>&gt;</span>");t.b("\n" + i);};if(t.s(t.f("isCurrentLevel",c,p,1),c,p,0,209,242,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <span>");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#show}}\n<div class=\"breadcrumb\">\n  {{#levels}}\n    {{^isCurrentLevel}}\n      <a searchId={{searchId}} href=\"#{{searchId}}\">{{text}}</a>\n      <span>&gt;</span>\n    {{/isCurrentLevel}}\n    {{#isCurrentLevel}}\n      <span>{{text}}</span>\n    {{/isCurrentLevel}}\n  {{/levels}}\n</div>\n{{/show}}", Hogan);
},{"hogan.js":71}],8:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"faq-answers\" data-bhw=\"faq___");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b("\n" + i);t.b("  <h4 class=\"article\">");t.b(t.t(t.f("heading",c,p,0)));t.b("</h4>");t.b("\n" + i);t.b("  <div class=\"answer article-text-container\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("text",c,p,0)));t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"rating\">");t.b("\n" + i);t.b("    <div class=\"ratings\">");t.b("\n" + i);t.b("      <span>");if(t.s(t.f("translate",c,p,1),c,p,0,242,265,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.helptext");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("        <a data-bhw=\"faq___");t.b(t.v(t.f("searchId",c,p,0)));t.b("___yes\" >");if(t.s(t.f("translate",c,p,1),c,p,0,349,367,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.yes");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("        |");t.b("\n" + i);t.b("        <a data-bhw=\"faq___");t.b(t.v(t.f("searchId",c,p,0)));t.b("___no\">");if(t.s(t.f("translate",c,p,1),c,p,0,456,473,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.no");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"thanks\" style=\"display:none\">");if(t.s(t.f("translate",c,p,1),c,p,0,562,583,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.thanks");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"faq-answers\" data-bhw=\"faq___{{searchId}}\">\n  <h4 class=\"article\">{{{heading}}}</h4>\n  <div class=\"answer article-text-container\">\n    {{{text}}}\n  </div>\n  <div class=\"rating\">\n    <div class=\"ratings\">\n      <span>{{#translate}}js.modules.faq.helptext{{/translate}}</span>\n        <a data-bhw=\"faq___{{searchId}}___yes\" >{{#translate}}js.modules.faq.yes{{/translate}}</a>\n        |\n        <a data-bhw=\"faq___{{searchId}}___no\">{{#translate}}js.modules.faq.no{{/translate}}</a>\n    </div>\n    <div class=\"thanks\" style=\"display:none\">{{#translate}}js.modules.faq.thanks{{/translate}}</div>\n  </div>\n</div>", Hogan);
},{"hogan.js":71}],9:[function(require,module,exports){
var Backbone, FAQAppRouter,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQAppRouter = (function(superClass) {
  extend(FAQAppRouter, superClass);

  function FAQAppRouter() {
    return FAQAppRouter.__super__.constructor.apply(this, arguments);
  }

  FAQAppRouter.prototype.routes = {
    '': 'renderFaq',
    ':id': 'renderFaq'
  };

  FAQAppRouter.prototype.renderFaq = function(id) {
    if (id == null) {
      id = "home";
    }
    return Groupon.FAQ.ViewManager.render(id);
  };

  return FAQAppRouter;

})(Backbone.Router);

module.exports = FAQAppRouter;



},{"backbone":68}],10:[function(require,module,exports){
var FAQ, FAQAppRouter, FAQMainView, FAQViewManagerView, SharedFooterUSMainView, SharedUtilsHelper;

FAQMainView = require('./views/main');

FAQViewManagerView = require('./views/viewmanager');

FAQAppRouter = require('./Approuter');

SharedUtilsHelper = require('../../shared/frontend/helpers/utils');

SharedFooterUSMainView = require('../../shared/frontend/views/footer/US/main_view');

Date.now = Date.now || function() {
  return +(new Date);
};

if (!(typeof String.prototype.trim === 'function')) {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

FAQ = {
  createFaqNameSpace: function() {
    var base;
    if (window.Groupon == null) {
      window.Groupon = {};
    }
    if ((base = window.Groupon).FAQ == null) {
      base.FAQ = {};
    }
    return _.extend(window, SharedUtilsHelper);
  }
};

$(document).ready(function() {
  var footer, ref;
  FAQ.createFaqNameSpace();
  if (checkIfIsUSByCountry((ref = window.country) != null ? ref.name : void 0)) {
    footer = new SharedFooterUSMainView();
    footer.render();
    $("#footer-content").html(footer.el);
    toggleCallUs(0);
  }
  if (isCMSEnabled()) {
    Groupon.FAQ.ViewManager = new FAQViewManagerView();
    Groupon.FAQ.Router = new FAQAppRouter();
    Backbone.history.start({
      root: window.FAQBASEURL
    });
  }
  $('.help-wizard-menu').on('click', function() {
    window.location.href = window.SUPPORTBASEURL + "?fromFaq=true";
    return false;
  });
  $('.faqs-menu').on('click', function() {
    redirectToFaq();
    return false;
  });
  return Groupon.Performance.pageReady();
});



},{"../../shared/frontend/helpers/utils":36,"../../shared/frontend/views/footer/US/main_view":38,"./Approuter":9,"./views/main":19,"./views/viewmanager":24}],11:[function(require,module,exports){
var Backbone, FAQContentModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQContentModel = (function(superClass) {
  extend(FAQContentModel, superClass);

  function FAQContentModel() {
    return FAQContentModel.__super__.constructor.apply(this, arguments);
  }

  FAQContentModel.prototype.initialize = function() {
    this.baseUrl = window.FAQBASEURL + "/topics";
    this.container = $('#content-container');
    this.spinner = $('.g-spinner');
    return this.errorContainer = $('#error-container');
  };

  FAQContentModel.prototype.setUrl = function(queryParams) {
    var articleId, topicId;
    switch (queryParams != null ? queryParams.category : void 0) {
      case "topic":
        topicId = encodeURIComponent(queryParams.topicId);
        return this.url = this.baseUrl + "/" + topicId + "/articles?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
      case "article":
        topicId = encodeURIComponent(queryParams.topicId);
        articleId = encodeURIComponent(queryParams.articleId);
        return this.url = this.baseUrl + "/" + topicId + "/articles/" + articleId + "?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
    }
  };

  FAQContentModel.prototype.fetchContent = function(queryParams, sucessCallback, errorCallback) {
    this.setUrl(queryParams);
    this.container.empty();
    this.errorContainer.empty();
    this.spinner.show();
    this.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          stopTimer("t_fs");
          _this.spinner.hide();
          return sucessCallback(response);
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          stopTimer("t_fs");
          _this.spinner.hide();
          return errorCallback(queryParams);
        };
      })(this)
    });
    return startTimer("t_fs");
  };

  return FAQContentModel;

})(Backbone.Model);

module.exports = FAQContentModel;



},{"backbone":68}],12:[function(require,module,exports){
var Backbone, FAQHomeModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQHomeModel = (function(superClass) {
  extend(FAQHomeModel, superClass);

  function FAQHomeModel() {
    return FAQHomeModel.__super__.constructor.apply(this, arguments);
  }

  FAQHomeModel.prototype.initialize = function() {
    return this.url = window.FAQBASEURL + "/home?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return FAQHomeModel;

})(Backbone.Model);

module.exports = FAQHomeModel;



},{"backbone":68}],13:[function(require,module,exports){
var Backbone, FAQSearchModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQSearchModel = (function(superClass) {
  extend(FAQSearchModel, superClass);

  function FAQSearchModel() {
    return FAQSearchModel.__super__.constructor.apply(this, arguments);
  }

  FAQSearchModel.prototype.initialize = function() {
    return this.baseUrl = window.FAQBASEURL + "/search";
  };

  FAQSearchModel.prototype.setUrl = function(searchText) {
    searchText = encodeURIComponent(searchText);
    return this.url = this.baseUrl + "?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS + "&search_text=" + searchText;
  };

  return FAQSearchModel;

})(Backbone.Model);

module.exports = FAQSearchModel;



},{"backbone":68}],14:[function(require,module,exports){
var Backbone, FAQArticleView, FaqDetailedarticleTemplate, FaqSummarizedarticleTemplate, Hogan, SharedUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedUtilsHelper = require('../../../shared/frontend/helpers/utils');

Hogan = require('../../../../node_modules/hogan.js/web/builds/2.0.0/hogan-2.0.0');

Backbone = require('backbone');

Backbone.$ = $;

FaqDetailedarticleTemplate = require('../../detailedarticle.html.mustache');

FaqSummarizedarticleTemplate = require('../../summarizedarticle.html.mustache');

FAQArticleView = (function(superClass) {
  extend(FAQArticleView, superClass);

  function FAQArticleView() {
    return FAQArticleView.__super__.constructor.apply(this, arguments);
  }

  FAQArticleView.VIEWID = 2;

  FAQArticleView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.deatiledArticleTemplate = FaqDetailedarticleTemplate;
    this.summarizedArticleTemplate = FaqSummarizedarticleTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.summarized = this.options.summarized ? true : false;
    this.container = this.options.container;
    this.contentModel = this.options.contentModel;
    this.truncationLimit = 200;
    return this.errorContainer = this.options.errorContainer;
  };

  FAQArticleView.prototype.events = {
    "click .rating": "handleRatingClicked"
  };

  FAQArticleView.prototype.render = function(topicId, articleId) {
    var data, errorCb, successCallack;
    this.searchId = "" + topicId + articleId;
    data = this.getArticleHash();
    if (this.checkArticleId(articleId, data)) {
      return this.constructArticlePage(data);
    } else {
      successCallack = (function(_this) {
        return function(response) {
          return _this.constructArticlePage(response);
        };
      })(this);
      errorCb = (function(_this) {
        return function(data) {
          if (data == null) {
            data = {};
          }
          return _this.errorCallback(data);
        };
      })(this);
      return this.contentModel.fetchContent({
        topicId: topicId,
        articleId: articleId,
        searchId: this.searchId,
        category: "article"
      }, successCallack, errorCb);
    }
  };

  FAQArticleView.prototype.errorText = function() {
    if (Groupon.FAQ.ViewManager.isV2View()) {
      return I18n.t('js.modules.faq.refresh_browser');
    } else {
      return I18n.t('js.modules.faq.not_found');
    }
  };

  FAQArticleView.prototype.checkArticleId = function(articleId, data) {
    if ((data != null ? data.article : void 0) != null) {
      return data.article.id === articleId;
    } else {
      return false;
    }
  };

  FAQArticleView.prototype.getArticleHash = function() {
    var data;
    data = this.contentModel.attributes;
    if ((data != null ? data.article : void 0) != null) {
      return data;
    } else {
      return null;
    }
  };

  FAQArticleView.prototype.constructArticlePage = function(response) {
    var articleHash, ref, ref1, topicHash;
    if ((response != null) && (response.article != null) && (response.topic != null)) {
      topicHash = {
        searchId: response.topic.searchId,
        text: (ref = response.topic.text) != null ? ref.replace(/(<([^>]+)>)/ig, "") : void 0
      };
      this.breadCrumbView.addCrumbs(topicHash);
      articleHash = {
        searchId: response.article.searchId,
        text: (ref1 = response.article.heading) != null ? ref1.replace(/(<([^>]+)>)/ig, "") : void 0
      };
      this.breadCrumbView.addCrumbs(articleHash);
      return this.toHtml(response);
    } else {
      return this.invalidResponseCallback({
        searchId: this.searchId
      });
    }
  };

  FAQArticleView.prototype.toHtml = function(response) {
    var hash;
    if (response.article != null) {
      if (response.article.heading != null) {
        response.article.heading = response.article.heading.replace(/(<([^>]+)>)/ig, "");
      }
      this.temporaryArticleTemplate = Hogan.compile(response.article.text);
      response.article.text = toHtml(this.temporaryArticleTemplate, window.currentUser, this.I18nScope);
      if (this.summarized) {
        return this.constructSummarizedArticle(response);
      } else {
        hash = $.extend(true, {}, response.article, window.currentUser);
        this.$el.html(toHtml(this.deatiledArticleTemplate, hash, this.I18nScope));
        this.breadCrumbView.render();
        return this.container.html(this.el);
      }
    }
  };

  FAQArticleView.prototype.constructSummarizedArticle = function(response) {
    var hash, indexOfSpace, orgContent, ref, truncatedContent;
    hash = $.extend(true, {}, response.article, window.currentUser);
    this.$el.html(toHtml(this.summarizedArticleTemplate, hash, this.I18nScope));
    this.$('.article-text-container').dotdotdot({
      height: 60
    });
    orgContent = this.$('.article-text-container').triggerHandler("originalContent");
    orgContent = orgContent != null ? (ref = orgContent.text()) != null ? ref.trim() : void 0 : void 0;
    if ((orgContent != null ? orgContent.length : void 0) > this.truncationLimit) {
      indexOfSpace = orgContent.indexOf(' ', this.truncationLimit);
      if (indexOfSpace > -1) {
        truncatedContent = orgContent.substring(0, indexOfSpace);
      } else {
        truncatedContent = orgContent;
      }
      truncatedContent = truncatedContent + "...<a class='read-more' searchId='" + response.article.searchId + "' href='#" + response.article.searchId + "'>" + (I18n.t("js.modules.faq.readmore")) + "</a>";
      this.$('.truncated-article-container').html(truncatedContent);
    } else {
      this.$('.article-text-container').show();
    }
    return this.container.append(this.el);
  };

  FAQArticleView.prototype.handleRatingClicked = function(event) {
    var $target;
    $target = $(event.target);
    if ($target.is("a")) {
      propagateEventBeforeReplacingElements((function(_this) {
        return function() {
          $(".ratings", _this.$el).hide();
          return $(".thanks", _this.$el).show();
        };
      })(this));
    }
    return true;
  };

  FAQArticleView.prototype.errorCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-articles-api-failure' class='noResults'>" + (this.errorText()) + "</div>"
    });
  };

  FAQArticleView.prototype.invalidResponseCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-articles-api-invalid' class='noResults'>" + (I18n.t('js.modules.faq.not_found')) + "</div>"
    });
  };

  return FAQArticleView;

})(Backbone.View);

module.exports = FAQArticleView;



},{"../../../../node_modules/hogan.js/web/builds/2.0.0/hogan-2.0.0":73,"../../../shared/frontend/helpers/utils":36,"../../detailedarticle.html.mustache":8,"../../summarizedarticle.html.mustache":27,"backbone":68}],15:[function(require,module,exports){
var Backbone, FAQAutoCompleteItemView, FAQAutoCompleteView, FAQAutoSuggestionListView, FAQSearchModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQSearchModel = require('../models/search');

FAQAutoCompleteItemView = require('./autocompleteItem');

Backbone = require('backbone');

Backbone.$ = $;

FAQAutoSuggestionListView = require('./autosuggestionlist');

FAQAutoCompleteView = (function(superClass) {
  extend(FAQAutoCompleteView, superClass);

  function FAQAutoCompleteView() {
    return FAQAutoCompleteView.__super__.constructor.apply(this, arguments);
  }

  FAQAutoCompleteView.prototype.tagName = "ul";

  FAQAutoCompleteView.prototype.className = "autocomplete";

  FAQAutoCompleteView.prototype.initialize = function(options) {
    this.options = options || {};
    this.wait = 500;
    this.searchModel = new FAQSearchModel();
    this.container = this.options.container;
    this.input = $("#searchFormInput");
    this.input.focus();
    this.numberOfSiblings = 1;
    return this.currentText = null;
  };

  FAQAutoCompleteView.prototype.render = function() {
    this.keyup = _.debounce(this.keyup, this.wait);
    $('#searchContent', this.container).append(this.el);
    return this.bindEvents();
  };

  FAQAutoCompleteView.prototype.invalidate = function() {
    this.reset();
    return this.input.val('');
  };

  FAQAutoCompleteView.prototype.bindEvents = function() {
    this.input.keyup((function(_this) {
      return function(event) {
        _this.keyup(event);
        return true;
      };
    })(this));
    this.input.keydown((function(_this) {
      return function(event) {
        _this.keydown(event);
        return true;
      };
    })(this));
    $('#btn-search').on('click', (function(_this) {
      return function() {
        _this.onEnter();
        return true;
      };
    })(this));
    return $(document).on('click', (function(_this) {
      return function(event) {
        var $target, autocomplete;
        $target = $(event.target);
        autocomplete = $target.closest(".autocomplate-form");
        if (autocomplete.length === 0 && _this.$el.is(":visible")) {
          return _this.invalidate();
        }
      };
    })(this));
  };

  FAQAutoCompleteView.prototype.keydown = function(event) {
    switch (event.keyCode) {
      case 38:
        return this.move(-1);
      case 40:
        return this.move(+1);
      case 13:
        return this.onEnter();
      case 27:
        return this.invalidate();
      default:
        return true;
    }
  };

  FAQAutoCompleteView.prototype.keyup = function() {
    var keyword, ref;
    keyword = (ref = this.input.val()) != null ? ref.trim() : void 0;
    if (!this.isValid(keyword)) {
      return this.reset();
    }
    if (this.isChanged(keyword)) {
      return this.getItems(keyword);
    }
    return true;
  };

  FAQAutoCompleteView.prototype.move = function(position) {
    var current, index, siblings;
    current = this.$el.children(".active");
    siblings = this.$el.children(".siblings");
    if ((current != null ? current.length : void 0) > 0 && (siblings != null ? siblings.length : void 0) > 0 && (position != null)) {
      index = (Number(current.attr("index")) + position + this.numberOfSiblings) % this.numberOfSiblings;
      if ((siblings.eq(index).length)) {
        current.removeClass("active");
        siblings.eq(index).addClass("active");
        return false;
      }
    }
    if ((siblings != null ? siblings.length : void 0) > 0) {
      if (current != null) {
        current.removeClass("active");
      }
      siblings.eq(0).addClass("active");
    }
    return false;
  };

  FAQAutoCompleteView.prototype.onEnter = function() {
    var activeLnk, href, keyword, ref;
    activeLnk = this.$el.children(".active");
    if ((activeLnk != null ? activeLnk.length : void 0) > 0) {
      href = $('a', activeLnk).attr('href');
      if ((href != null ? href.length : void 0) > 0) {
        Backbone.history.navigate("" + href, {
          trigger: true,
          replace: true
        });
      }
    } else {
      keyword = (ref = this.input.val()) != null ? ref.trim() : void 0;
      if (this.isValid(keyword)) {
        href = encodeURIComponent(keyword);
        href = "" + FAQAutoSuggestionListView.VIEWNAME + window.ID_seperator + href;
        Backbone.history.navigate("" + href, {
          trigger: true,
          replace: true
        });
      }
    }
    return false;
  };

  FAQAutoCompleteView.prototype.reset = function() {
    this.currentText = null;
    this.numberOfSiblings = 1;
    this.hide();
    return false;
  };

  FAQAutoCompleteView.prototype.isChanged = function(keyword) {
    return (this.currentText === null) || (this.currentText !== keyword);
  };

  FAQAutoCompleteView.prototype.isValid = function(keyword) {
    return (keyword != null) && keyword.length > 0;
  };

  FAQAutoCompleteView.prototype.hide = function() {
    this.$el.empty();
    this.$el.hide();
    return this.container.hide();
  };

  FAQAutoCompleteView.prototype.show = function() {
    this.container.show();
    return this.$el.show();
  };

  FAQAutoCompleteView.prototype.getItems = function(keyword) {
    this.searchModel.setUrl(keyword);
    this.currentText = keyword;
    this.searchModel.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          stopTimer("t_fa");
          return _this.renderItems(response);
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          stopTimer("t_fa");
          return _this.reset();
        };
      })(this)
    });
    return startTimer("t_fa");
  };

  FAQAutoCompleteView.prototype.renderItems = function(response) {
    var ref;
    if (this.currentText === (response != null ? response.query : void 0)) {
      if ((response != null ? (ref = response.docs) != null ? ref.length : void 0 : void 0) > 0) {
        this.reset();
        this.currentText = response.query;
        this.numberOfSiblings = response.docs.length;
        this.show();
        return _.each(response.docs, (function(_this) {
          return function(item, index) {
            var autoCompleteItem, hash;
            autoCompleteItem = new FAQAutoCompleteItemView();
            hash = {
              item: item,
              keyword: _this.currentText,
              index: index
            };
            autoCompleteItem.render(hash);
            return _this.$el.append(autoCompleteItem.el);
          };
        })(this));
      } else {
        return this.reset();
      }
    }
  };

  return FAQAutoCompleteView;

})(Backbone.View);

module.exports = FAQAutoCompleteView;



},{"../models/search":13,"./autocompleteItem":16,"./autosuggestionlist":17,"backbone":68}],16:[function(require,module,exports){
var Backbone, FAQAutoCompleteItemView, FaqAutocompleteItemTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqAutocompleteItemTemplate = require('../../autocompleteItem.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

FAQAutoCompleteItemView = (function(superClass) {
  extend(FAQAutoCompleteItemView, superClass);

  function FAQAutoCompleteItemView() {
    return FAQAutoCompleteItemView.__super__.constructor.apply(this, arguments);
  }

  FAQAutoCompleteItemView.prototype.tagName = 'li';

  FAQAutoCompleteItemView.prototype.className = 'siblings';

  FAQAutoCompleteItemView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    return this.template = FaqAutocompleteItemTemplate;
  };

  FAQAutoCompleteItemView.prototype.render = function(hash) {
    if (hash == null) {
      hash = {};
    }
    this.$el.html(toHtml(this.template, this.toHash(hash), this.I18nScope));
    return this.$el.attr("index", "" + hash.index);
  };

  FAQAutoCompleteItemView.prototype.toHash = function(hash) {
    var ref;
    if ((hash != null ? (ref = hash.item) != null ? ref.type : void 0 : void 0) != null) {
      switch (hash.item.type) {
        case 0:
          hash.item.text = this.highlightText(hash.keyword, hash.item.topic_text);
          break;
        case 1:
          hash.item.text = this.highlightText(hash.keyword, hash.item.article_heading);
      }
      return hash;
    } else {
      return hash;
    }
  };

  FAQAutoCompleteItemView.prototype.highlightText = function(keyword, text) {
    var keywords;
    if ((keyword != null) && text) {
      text = text.replace(/(<([^>]+)>)/ig, "");
      keywords = keyword.split(/\s+/);
      _.each(keywords, function(word, index) {
        var searchPattern;
        if (!(word === 'b' && index > 0)) {
          searchPattern = new RegExp('(' + word + ')', 'ig');
          return text = text.replace(searchPattern, "<b>$1</b>");
        }
      });
      return text;
    } else {
      return text;
    }
  };

  return FAQAutoCompleteItemView;

})(Backbone.View);

module.exports = FAQAutoCompleteItemView;



},{"../../autocompleteItem.html.mustache":5,"backbone":68}],17:[function(require,module,exports){
var Backbone, FAQAutoCompleteItemView, FAQAutoSuggestionListView, FAQSearchModel, FaqAutosuggestionlistTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQSearchModel = require('../models/search');

FAQAutoCompleteItemView = require('./autocompleteItem');

Backbone = require('backbone');

Backbone.$ = $;

FaqAutosuggestionlistTemplate = require('../../autosuggestionlist.html.mustache');

FAQAutoSuggestionListView = (function(superClass) {
  extend(FAQAutoSuggestionListView, superClass);

  function FAQAutoSuggestionListView() {
    return FAQAutoSuggestionListView.__super__.constructor.apply(this, arguments);
  }

  FAQAutoSuggestionListView.VIEWID = 3;

  FAQAutoSuggestionListView.VIEWNAME = "autosuggest";

  FAQAutoSuggestionListView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.template = FaqAutosuggestionlistTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.container = this.options.container;
    this.spinner = this.options.spinner;
    this.errorContainer = this.options.errorContainer;
    return this.searchModel = new FAQSearchModel();
  };

  FAQAutoSuggestionListView.prototype.render = function(searchText) {
    this.container.empty();
    this.errorContainer.empty();
    this.spinner.show();
    return this.getSuggestions(searchText);
  };

  FAQAutoSuggestionListView.prototype.getSuggestions = function(keyword) {
    if (this.isValid(keyword)) {
      this.searchModel.setUrl(keyword);
      this.searchModel.fetch({
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_fa");
            _this.spinner.hide();
            return _this.renderSuggestions(response);
          };
        })(this),
        error: (function(_this) {
          return function(model, xhr, options) {
            stopTimer("t_fa");
            _this.spinner.hide();
            return _this.renderNoSuggestions(keyword, 'failure');
          };
        })(this)
      });
      return startTimer("t_fa");
    }
  };

  FAQAutoSuggestionListView.prototype.isValid = function(keyword) {
    return (keyword != null) && keyword.length > 0;
  };

  FAQAutoSuggestionListView.prototype.renderBreadCrumbs = function(keyword, text) {
    var leveldata;
    leveldata = {
      searchId: keyword,
      text: text
    };
    this.breadCrumbView.addCrumbs(leveldata);
    return this.breadCrumbView.render();
  };

  FAQAutoSuggestionListView.prototype.renderSuggestionElements = function(response) {
    var $autoSuggestionList;
    $autoSuggestionList = $("#suggestion-list", this.$el);
    return _.each(response.docs, (function(_this) {
      return function(item, index) {
        var autoCompleteItem, hash;
        autoCompleteItem = new FAQAutoCompleteItemView();
        hash = {
          item: item,
          keyword: response.query,
          index: index
        };
        autoCompleteItem.render(hash);
        return $autoSuggestionList.append(autoCompleteItem.el);
      };
    })(this));
  };

  FAQAutoSuggestionListView.prototype.toHtml = function(data, template) {
    if (data == null) {
      data = {};
    }
    if (template == null) {
      template = this.template;
    }
    this.$el.html(toHtml(template, data, this.I18nScope));
    return this.container.html(this.el);
  };

  return FAQAutoSuggestionListView;

})(Backbone.View);

module.exports = FAQAutoSuggestionListView;



},{"../../autosuggestionlist.html.mustache":6,"../models/search":13,"./autocompleteItem":16,"backbone":68}],18:[function(require,module,exports){
var Backbone, FAQBreadCrumbView, FAQMainView, FaqBreadcrumbTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqBreadcrumbTemplate = require('../../breadcrumb.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

FAQMainView = require('./main');

FAQBreadCrumbView = (function(superClass) {
  extend(FAQBreadCrumbView, superClass);

  function FAQBreadCrumbView() {
    return FAQBreadCrumbView.__super__.constructor.apply(this, arguments);
  }

  FAQBreadCrumbView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    this.template = FaqBreadcrumbTemplate;
    this.container = $('#breadcrumb');
    return this.invalidate();
  };

  FAQBreadCrumbView.prototype.invalidate = function() {
    this.container.empty();
    return this.searchHistory = new Array(this.constructFaqMainbreadCrumb());
  };

  FAQBreadCrumbView.prototype.addCrumbs = function(levelResponse) {
    if ((levelResponse != null) && (levelResponse.searchId != null) && (levelResponse.text != null)) {
      this.searchHistory.push(levelResponse);
      return true;
    } else {
      return false;
    }
  };

  FAQBreadCrumbView.prototype.render = function() {
    return this.toHtml();
  };

  FAQBreadCrumbView.prototype.toHtml = function() {
    this.$el.html(toHtml(this.template, this.toHash(this.searchHistory), this.I18nScope));
    return this.container.html(this.el);
  };

  FAQBreadCrumbView.prototype.toHash = function(history) {
    var breadCrumbs;
    if ((history != null ? history.length : void 0) > 0) {
      breadCrumbs = history;
      breadCrumbs[breadCrumbs.length - 1].isCurrentLevel = true;
      return {
        levels: breadCrumbs,
        show: (breadCrumbs != null ? breadCrumbs.length : void 0) > 1 ? true : false
      };
    } else {
      return null;
    }
  };

  FAQBreadCrumbView.prototype.constructFaqMainbreadCrumb = function() {
    var hash;
    hash = {
      searchId: FAQMainView.VIEWNAME,
      text: I18n.t('js.modules.faq.faq_main')
    };
    return hash;
  };

  return FAQBreadCrumbView;

})(Backbone.View);

module.exports = FAQBreadCrumbView;



},{"../../breadcrumb.html.mustache":7,"./main":19,"backbone":68}],19:[function(require,module,exports){
var Backbone, FAQMainView, FaqMainpageTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqMainpageTemplate = require('../../mainpage.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

FAQMainView = (function(superClass) {
  extend(FAQMainView, superClass);

  function FAQMainView() {
    return FAQMainView.__super__.constructor.apply(this, arguments);
  }

  FAQMainView.VIEWID = 0;

  FAQMainView.VIEWNAME = "home";

  FAQMainView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.template = FaqMainpageTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.container = this.options.container;
    this.homeModel = this.options.homeModel;
    this.errorView = this.options.errorView;
    this.spinner = this.options.spinner;
    return this.errorContainer = this.options.errorContainer;
  };

  FAQMainView.prototype.events = function() {
    return {
      'click .topic-header': 'toggleArticleSection'
    };
  };

  FAQMainView.prototype.render = function() {
    var data;
    data = this.getFAQMainData();
    if (data != null) {
      return this.constructFaqHomePage(data);
    } else {
      this.container.empty();
      this.spinner.show();
      this.homeModel.fetch({
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_fh");
            _this.spinner.hide();
            return _this.constructFaqHomePage(response);
          };
        })(this),
        error: (function(_this) {
          return function(model, xhr, options) {
            stopTimer("t_fh");
            _this.spinner.hide();
            return _this.renderErrorPage();
          };
        })(this)
      });
      return startTimer("t_fh");
    }
  };

  FAQMainView.prototype.toggleArticleSection = function(event) {
    var $target, id;
    $target = $(event.target).closest('.topic-header');
    id = $target.find('.topic-heading').attr('topicId');
    return this.toggleArticleList(id);
  };

  FAQMainView.prototype.getFAQMainData = function() {
    var data;
    data = this.homeModel.attributes;
    if ((data != null ? data.faqMain : void 0) != null) {
      return data;
    } else {
      return null;
    }
  };

  FAQMainView.prototype.constructFaqHomePage = function(response) {
    if ((response != null ? response.faqMain : void 0) != null) {
      this.toHtml(response);
      return this.scrollToTopic(this.options.topic);
    } else {
      return this.renderErrorPage();
    }
  };

  FAQMainView.prototype.renderErrorPage = function() {
    return this.errorView.render({
      container: this.container
    });
  };

  FAQMainView.prototype.toHtml = function(response) {
    this.$el.html(toHtml(this.template, this.toHash(response), this.I18nScope));
    this.breadCrumbView.render();
    return this.container.html(this.el);
  };

  FAQMainView.prototype.toggleArticleList = function(topic) {
    var $container;
    $("#" + topic).toggle();
    $container = $("#" + topic).closest('.faq-topic');
    $container.find('.icon-arrow-right').toggle();
    $container.find('.icon-arrow-down').toggle();
    return scrollTo($container);
  };

  FAQMainView.prototype.scrollToTopic = function(topic) {
    if (topic) {
      return this.toggleArticleList(topic);
    }
  };

  FAQMainView.prototype.toHash = function(response) {
    var columnSize, extra, faqMain, hash, help_topics_column1, help_topics_column2, help_topics_column3, index, ref, ref1;
    hash = {
      hasTrendingQuestions: false,
      hasHelpTopics: false,
      hasTopicArticleMappings: false
    };
    if ((response != null ? response.faqMain : void 0) != null) {
      faqMain = response.faqMain;
      if (evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showVerticalPageFlow : void 0)) {
        hash.hasTopicArticleMappings = ((ref = faqMain.topic_article_mappings) != null ? ref.length : void 0) > 0 ? true : false;
        hash.topicArticleMappings = faqMain.topic_article_mappings;
      } else {
        help_topics_column1 = [];
        help_topics_column2 = [];
        help_topics_column3 = [];
        hash.hasTrendingQuestions = ((ref1 = faqMain.trending_question) != null ? ref1.length : void 0) > 0 ? true : false;
        if ((faqMain.help_topics != null) && faqMain.help_topics.length > 0) {
          _.each(faqMain.help_topics, function(helpTopic) {
            if (helpTopic.text != null) {
              return helpTopic.text = helpTopic.text.replace(/(<([^>]+)>)/ig, "");
            }
          });
          hash.hasHelpTopics = true;
          columnSize = Math.floor(faqMain.help_topics.length / 3);
          extra = faqMain.help_topics.length % 3;
          if (columnSize > 0) {
            help_topics_column1 = faqMain.help_topics.slice(0, columnSize);
            help_topics_column2 = faqMain.help_topics.slice(columnSize, 2 * columnSize);
            help_topics_column3 = faqMain.help_topics.slice(2 * columnSize, 3 * columnSize);
          }
          if (extra > 0) {
            index = 3 * columnSize;
            while (extra > 0) {
              help_topics_column1.push(faqMain.help_topics[index++]);
              extra--;
              if (extra > 0) {
                help_topics_column2.push(faqMain.help_topics[index++]);
              }
              extra--;
            }
          }
        }
        if (hash.hasTrendingQuestions) {
          _.each(faqMain.trending_question, function(trendingQn) {
            if (trendingQn.text != null) {
              return trendingQn.text = trendingQn.text.replace(/(<([^>]+)>)/ig, "");
            } else if (trendingQn.heading != null) {
              return trendingQn.heading = trendingQn.heading.replace(/(<([^>]+)>)/ig, "");
            }
          });
        }
        hash.trending_question = faqMain.trending_question;
        hash.help_topics_column1 = help_topics_column1;
        hash.help_topics_column2 = help_topics_column2;
        hash.help_topics_column3 = help_topics_column3;
      }
    }
    return hash;
  };

  return FAQMainView;

})(Backbone.View);

module.exports = FAQMainView;



},{"../../mainpage.html.mustache":25,"backbone":68}],20:[function(require,module,exports){
var Backbone, FAQArticleView, FAQTopicView, FaqTopicpageTemplate, dotdotdot,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqTopicpageTemplate = require('../../topicpage.html.mustache');

FAQArticleView = require('./article');

dotdotdot = require('../../../../core/frontend/vendor_modules/jQuery/jquery.dotdotdot');

Backbone = require('backbone');

Backbone.$ = $;

FAQTopicView = (function(superClass) {
  extend(FAQTopicView, superClass);

  function FAQTopicView() {
    return FAQTopicView.__super__.constructor.apply(this, arguments);
  }

  FAQTopicView.VIEWID = 1;

  FAQTopicView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.template = FaqTopicpageTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.container = this.options.container;
    this.contentModel = this.options.contentModel;
    return this.errorContainer = this.options.errorContainer;
  };

  FAQTopicView.prototype.events = {
    "click #topic_explanation": "handleTopicReadMoreClicked"
  };

  FAQTopicView.prototype.render = function(topicId) {
    var data, errorCb, successCallack;
    this.searchId = topicId;
    data = this.getTopicHash();
    if (this.checkTopicId(topicId, data)) {
      return this.constructTopicpage(data);
    } else {
      successCallack = (function(_this) {
        return function(response) {
          return _this.constructTopicpage(response);
        };
      })(this);
      errorCb = (function(_this) {
        return function(data) {
          return _this.errorCallback(data);
        };
      })(this);
      return this.contentModel.fetchContent({
        topicId: topicId,
        searchId: this.searchId,
        category: "topic"
      }, successCallack, errorCb);
    }
  };

  FAQTopicView.prototype.checkTopicId = function(topicId, data) {
    if ((data != null ? data.topic : void 0) != null) {
      return data.topic.id === topicId;
    } else {
      return false;
    }
  };

  FAQTopicView.prototype.getTopicHash = function() {
    var data;
    data = this.contentModel.attributes;
    if ((data != null ? data.topic : void 0) != null) {
      return data;
    } else {
      return null;
    }
  };

  FAQTopicView.prototype.constructTopicpage = function(response) {
    var ref, topicHash;
    if ((response != null ? response.topic : void 0) != null) {
      topicHash = {
        searchId: response.topic.searchId,
        text: (ref = response.topic.text) != null ? ref.replace(/(<([^>]+)>)/ig, "") : void 0
      };
      this.breadCrumbView.addCrumbs(topicHash);
      return this.toHtml(response);
    } else {
      return this.invalidResponseCallback({
        searchId: this.searchId
      });
    }
  };

  FAQTopicView.prototype.toHtml = function(response) {
    var hash, ref;
    if ((response != null ? (ref = response.topic) != null ? ref.text : void 0 : void 0) != null) {
      response.topic.text = response.topic.text.replace(/(<([^>]+)>)/ig, "");
    }
    hash = $.extend(true, {}, response.topic, window.currentUser, {
      showVerticalPageFlow: typeof experiments !== "undefined" && experiments !== null ? experiments.showVerticalPageFlow : void 0
    });
    this.$el.html(toHtml(this.template, hash, this.I18nScope));
    this.breadCrumbView.render();
    this.container.html(this.el);
    return this.renderSummarizedArticle(response);
  };

  FAQTopicView.prototype.renderSummarizedArticle = function(response) {
    var ref, ref1;
    if (((ref = response.topic) != null ? (ref1 = ref.articles) != null ? ref1.length : void 0 : void 0) > 0) {
      return _.each(response.topic.articles, function(article) {
        var articleView;
        articleView = new FAQArticleView({
          'breadCrumbView': this.breadCrumbView,
          'summarized': true,
          'container': $('#topic_explanation', this.el)
        });
        return articleView.toHtml({
          article: article
        });
      });
    }
  };

  FAQTopicView.prototype.handleTopicReadMoreClicked = function(event) {
    var $target, article, data, ref, searchId;
    $target = $(event.target);
    if ($target.is("a.article") || $target.is("a.read-more")) {
      searchId = $target.attr("searchId");
      data = this.getTopicHash();
      if ((searchId != null) && ((data != null ? (ref = data.topic) != null ? ref.articles : void 0 : void 0) != null)) {
        article = _.find(data.topic.articles, function(article) {
          return article.searchId === searchId;
        });
        if (article != null) {
          return this.contentModel.set('article', article, {
            silent: true
          });
        }
      }
    }
  };

  FAQTopicView.prototype.errorCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-topics-api-failure' class='noResults'>" + (this.errorText()) + "</div>"
    });
  };

  FAQTopicView.prototype.errorText = function() {
    if (Groupon.FAQ.ViewManager.isV2View()) {
      return I18n.t('js.modules.faq.refresh_browser');
    } else {
      return I18n.t('js.modules.faq.not_found');
    }
  };

  FAQTopicView.prototype.invalidResponseCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-topics-api-invalid' class='noResults'>" + (I18n.t('js.modules.faq.not_found')) + "</div>"
    });
  };

  return FAQTopicView;

})(Backbone.View);

module.exports = FAQTopicView;



},{"../../../../core/frontend/vendor_modules/jQuery/jquery.dotdotdot":3,"../../topicpage.html.mustache":28,"./article":14,"backbone":68}],21:[function(require,module,exports){
var Backbone, FAQTrendingArticlesView, FaqTrendingArticlesTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

FaqTrendingArticlesTemplate = require('../../trending_articles.html.mustache');

FAQTrendingArticlesView = (function(superClass) {
  extend(FAQTrendingArticlesView, superClass);

  function FAQTrendingArticlesView() {
    return FAQTrendingArticlesView.__super__.constructor.apply(this, arguments);
  }

  FAQTrendingArticlesView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    this.template = FaqTrendingArticlesTemplate;
    return this.container = $('#trending-articles');
  };

  FAQTrendingArticlesView.prototype.events = {
    "click .article-header": "toggleArticleSummary",
    "click .rating": "handleRatingClicked"
  };

  FAQTrendingArticlesView.prototype.toggleArticleSummary = function(event) {
    var $target, id;
    $target = $(event.target).closest('.article-header');
    id = $target.find('.article').attr('articleId');
    this.resetAllArticlesExceptTarget(id);
    $("#" + id).toggle();
    $target.find('.icon-arrow-right').toggle();
    $target.find('.icon-arrow-down').toggle();
    return scrollTo($target);
  };

  FAQTrendingArticlesView.prototype.resetAllArticlesExceptTarget = function(targetId) {
    return _.each($('.article'), (function(_this) {
      return function(article) {
        var $target, id;
        id = $(article).attr('articleId');
        if (id !== targetId) {
          $target = $(article).closest('.article-header');
          $("#" + id).hide();
          $target.find('.icon-arrow-right').show();
          return $target.find('.icon-arrow-down').hide();
        }
      };
    })(this));
  };

  FAQTrendingArticlesView.prototype.render = function() {
    return this.toHtml();
  };

  FAQTrendingArticlesView.prototype.handleRatingClicked = function(event) {
    var $target;
    $target = $(event.target).closest('.rating');
    $target.find('.ratings').hide();
    $target.find('.thanks').show();
    return true;
  };

  FAQTrendingArticlesView.prototype.toHtml = function() {
    var ref;
    this.$el.html(toHtml(this.template, {
      trendingArticleList: (ref = this.model.get('faqMain')) != null ? ref.trending_articles : void 0
    }, this.I18nScope));
    return this.container.html(this.el);
  };

  return FAQTrendingArticlesView;

})(Backbone.View);

module.exports = FAQTrendingArticlesView;



},{"../../trending_articles.html.mustache":29,"backbone":68}],22:[function(require,module,exports){
var FAQAutoSuggestionListView, FAQV1AutoSuggestionListView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQAutoSuggestionListView = require('./autosuggestionlist');

FAQV1AutoSuggestionListView = (function(superClass) {
  extend(FAQV1AutoSuggestionListView, superClass);

  function FAQV1AutoSuggestionListView() {
    return FAQV1AutoSuggestionListView.__super__.constructor.apply(this, arguments);
  }

  FAQV1AutoSuggestionListView.prototype.initialize = function() {
    return FAQAutoSuggestionListView.prototype.initialize.apply(this, arguments);
  };

  FAQV1AutoSuggestionListView.prototype.renderNoSuggestions = function(keyword, status) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: keyword,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(keyword)) + "___no-results-displayed-for-autocomplete-api-" + status + "' class='noResults'>" + (I18n.t('js.modules.faq.not_found')) + "</div>"
    });
  };

  FAQV1AutoSuggestionListView.prototype.renderSuggestions = function(response) {
    var ref;
    this.renderBreadCrumbs(response.query, (I18n.t('js.modules.faq.search_result')) + "'" + response.query + "'");
    if ((response != null ? (ref = response.docs) != null ? ref.length : void 0 : void 0) > 0) {
      this.toHtml();
      return this.renderSuggestionElements(response);
    } else {
      return this.renderNoSuggestions(response.query, 'success');
    }
  };

  return FAQV1AutoSuggestionListView;

})(FAQAutoSuggestionListView);

module.exports = FAQV1AutoSuggestionListView;



},{"./autosuggestionlist":17}],23:[function(require,module,exports){
var FAQAutoSuggestionListView, FAQV2AutoSuggestionListView, FaqNoSearchResultsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQAutoSuggestionListView = require('./autosuggestionlist');

FaqNoSearchResultsTemplate = require('../../no_search_results.html.mustache');

FAQV2AutoSuggestionListView = (function(superClass) {
  extend(FAQV2AutoSuggestionListView, superClass);

  function FAQV2AutoSuggestionListView() {
    return FAQV2AutoSuggestionListView.__super__.constructor.apply(this, arguments);
  }

  FAQV2AutoSuggestionListView.prototype.initialize = function() {
    this.noResultTemplate = FaqNoSearchResultsTemplate;
    return FAQAutoSuggestionListView.prototype.initialize.apply(this, arguments);
  };

  FAQV2AutoSuggestionListView.prototype.renderNoSuggestions = function(keyword, status) {
    this.renderBreadCrumbs(keyword, (I18n.t('js.modules.faq.search_result')) + "'" + keyword + "'");
    return this.toHtml({}, this.noResultTemplate);
  };

  FAQV2AutoSuggestionListView.prototype.renderSuggestions = function(response) {
    var ref;
    if ((response != null ? (ref = response.docs) != null ? ref.length : void 0 : void 0) > 0) {
      this.renderBreadCrumbs(response.query, I18n.t('js.modules.faq.search_result_level'));
      this.toHtml({
        searchQuery: (I18n.t('js.modules.faq.search_result')) + "'" + response.query + "'",
        isV2: true
      });
      return this.renderSuggestionElements(response);
    } else {
      return this.renderNoSuggestions(response.query, 'success');
    }
  };

  return FAQV2AutoSuggestionListView;

})(FAQAutoSuggestionListView);

module.exports = FAQV2AutoSuggestionListView;



},{"../../no_search_results.html.mustache":26,"./autosuggestionlist":17}],24:[function(require,module,exports){
var Backbone, FAQArticleView, FAQAutoCompleteView, FAQAutoSuggestionListView, FAQBreadCrumbView, FAQContentModel, FAQHomeModel, FAQMainView, FAQTopicView, FAQTrendingArticlesView, FAQV1AutoSuggestionListView, FAQV2AutoSuggestionListView, FAQViewManagerView, SharedAjaxErrorView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQMainView = require('./main');

FAQArticleView = require('./article');

FAQBreadCrumbView = require('./breadcrumb');

FAQTopicView = require('./topic');

FAQAutoCompleteView = require('./autocomplete');

SharedAjaxErrorView = require('../../../shared/frontend/views/ajax_error_view');

FAQV1AutoSuggestionListView = require('./v1_autosuggestionlist');

FAQV2AutoSuggestionListView = require('./v2_autosuggestionlist');

FAQContentModel = require('../models/content');

FAQHomeModel = require('../models/home');

FAQAutoSuggestionListView = require('./autosuggestionlist');

FAQTrendingArticlesView = require('./trendingArticles');

Backbone = require('backbone');

Backbone.$ = $;

FAQViewManagerView = (function(superClass) {
  extend(FAQViewManagerView, superClass);

  function FAQViewManagerView() {
    return FAQViewManagerView.__super__.constructor.apply(this, arguments);
  }

  FAQViewManagerView.prototype.initialize = function() {
    _.bind(this.renderErrorHtml, this);
    this.faqContentContainer = $('#content-container');
    this.errorContainer = $('#error-container');
    this.spinner = $('.g-spinner');
    this.contentModel = new FAQContentModel();
    this.homeModel = new FAQHomeModel();
    this.breadCrumbView = new FAQBreadCrumbView();
    this.errorView = new SharedAjaxErrorView();
    this.autoCompleteView = new FAQAutoCompleteView({
      'container': $('#auto-complete-container')
    });
    this.autoCompleteView.render();
    if (this.isV2View()) {
      return this.renderTrendingArticles();
    }
  };

  FAQViewManagerView.prototype.render = function(requestId) {
    var splitIds, viewId;
    $(window).scrollTop(0);
    splitIds = this.splitRequestId(requestId);
    viewId = this.findViewID(splitIds);
    this.autoCompleteView.invalidate();
    this.breadCrumbView.invalidate();
    this.renderFooter();
    if (viewId != null) {
      if (this.currentView != null) {
        this.currentView.remove();
      }
      switch (viewId) {
        case FAQMainView.VIEWID:
          return this.constructFaqMainView();
        case FAQTopicView.VIEWID:
          return this.constructTopicView(splitIds[0]);
        case FAQArticleView.VIEWID:
          return this.constructArticleView(splitIds[0], splitIds[1]);
        case FAQAutoSuggestionListView.VIEWID:
          return this.constructAutoSuggestionListView(splitIds[1]);
      }
    } else {
      return this.renderErrorHtml({
        query: requestId
      });
    }
  };

  FAQViewManagerView.prototype.splitRequestId = function(requestId) {
    return requestId.split(window.ID_seperator);
  };

  FAQViewManagerView.prototype.findViewID = function(splitIds) {
    var baseId;
    if (!((splitIds != null ? splitIds.length : void 0) > 0)) {
      return null;
    }
    baseId = splitIds[0];
    if (splitIds.length === 1) {
      if (baseId === FAQMainView.VIEWNAME) {
        return FAQMainView.VIEWID;
      } else {
        return FAQTopicView.VIEWID;
      }
    } else {
      if (baseId === FAQAutoSuggestionListView.VIEWNAME) {
        return FAQAutoSuggestionListView.VIEWID;
      }
      return FAQArticleView.VIEWID;
    }
  };

  FAQViewManagerView.prototype.constructFaqMainView = function(topicId) {
    if (topicId == null) {
      topicId = null;
    }
    this.currentView = new FAQMainView({
      'breadCrumbView': this.breadCrumbView,
      'container': this.faqContentContainer,
      'errorContainer': this.errorContainer,
      'spinner': this.spinner,
      'homeModel': this.homeModel,
      'errorView': this.errorView,
      'topic': topicId
    });
    this.currentView.render();
    if (this.isV2View()) {
      this.hideFooter();
      if (topicId == null) {
        return scrollTo($('.contact-us'));
      }
    }
  };

  FAQViewManagerView.prototype.renderTrendingArticles = function() {
    return this.homeModel.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          var trendingArticlesView;
          stopTimer("t_fh");
          $('.trending-articles-container').show();
          trendingArticlesView = new FAQTrendingArticlesView({
            model: _this.homeModel
          });
          return trendingArticlesView.render();
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          $('.trending-articles-container').hide();
          return stopTimer("t_fh");
        };
      })(this)
    });
  };

  FAQViewManagerView.prototype.renderFooter = function() {
    return $('.faq-footer').show();
  };

  FAQViewManagerView.prototype.hideFooter = function() {
    return $('.faq-footer').hide();
  };

  FAQViewManagerView.prototype.constructTopicView = function(topicId) {
    if (this.isV2View()) {
      return this.constructFaqMainView(topicId);
    } else {
      this.currentView = new FAQTopicView({
        'breadCrumbView': this.breadCrumbView,
        'contentModel': this.contentModel,
        'container': this.faqContentContainer,
        'errorContainer': this.errorContainer,
        'spinner': this.spinner
      });
      return this.currentView.render(topicId);
    }
  };

  FAQViewManagerView.prototype.constructArticleView = function(topicId, articleId) {
    this.currentView = new FAQArticleView({
      'breadCrumbView': this.breadCrumbView,
      'contentModel': this.contentModel,
      'summarized': false,
      'container': this.faqContentContainer,
      'errorContainer': this.errorContainer,
      'spinner': this.spinner
    });
    this.currentView.render(topicId, articleId);
    if (this.isV2View()) {
      return scrollTo($('.tabs-container'));
    }
  };

  FAQViewManagerView.prototype.constructAutoSuggestionListView = function(searchText) {
    var options;
    options = {
      'breadCrumbView': this.breadCrumbView,
      'container': this.faqContentContainer,
      'errorContainer': this.errorContainer,
      'spinner': this.spinner
    };
    if (this.isV2View()) {
      this.currentView = new FAQV2AutoSuggestionListView(options);
    } else {
      this.currentView = new FAQV1AutoSuggestionListView(options);
    }
    return this.currentView.render(searchText);
  };

  FAQViewManagerView.prototype.isV2View = function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showVerticalPageFlow : void 0);
  };

  FAQViewManagerView.prototype.scrollToFAQSearch = function() {
    return scrollTo($('#faqs'));
  };

  FAQViewManagerView.prototype.renderErrorHtml = function(hash) {
    var data;
    if (hash == null) {
      hash = {};
    }
    this.breadCrumbView.invalidate();
    if (hash.query != null) {
      data = {
        searchId: hash.query,
        text: (I18n.t('js.modules.faq.search_result')) + "'" + hash.query + "'"
      };
      this.breadCrumbView.addCrumbs(data);
    }
    this.breadCrumbView.render();
    this.errorView.render(hash);
    this.constructFaqMainView();
    return this.scrollToFAQSearch();
  };

  return FAQViewManagerView;

})(Backbone.View);

module.exports = FAQViewManagerView;



},{"../../../shared/frontend/views/ajax_error_view":37,"../models/content":11,"../models/home":12,"./article":14,"./autocomplete":15,"./autosuggestionlist":17,"./breadcrumb":18,"./main":19,"./topic":20,"./trendingArticles":21,"./v1_autosuggestionlist":22,"./v2_autosuggestionlist":23,"backbone":68}],25:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<!-- FAQ: New HTML Code -->");t.b("\n" + i);t.b("    <!-- Trending Questions -->");t.b("\n" + i);if(t.s(t.f("hasTrendingQuestions",c,p,1),c,p,0,89,562,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div id=\"pushContents\" class=\"faq-list\">");t.b("\n" + i);t.b("      <h2>");if(t.s(t.f("translate",c,p,1),c,p,0,159,192,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.trending_questions");});c.pop();}t.b("</h2>");t.b("\n" + i);t.b("      <ul>");t.b("\n" + i);if(t.s(t.f("trending_question",c,p,1),c,p,0,253,512,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("          <a class=\"trending-questions link\" levelId=");t.b(t.v(t.f("level",c,p,0)));t.b(" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b("\n" + i);t.b("            ");if(t.s(t.f("heading",c,p,1),c,p,0,398,413,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" ");t.b(t.t(t.f("heading",c,p,0)));t.b(" ");});c.pop();}t.b("\n" + i);t.b("            ");if(!t.s(t.f("heading",c,p,1),c,p,1,0,0,"")){t.b(" ");t.b(t.t(t.f("text",c,p,0)));t.b(" ");};t.b("\n" + i);t.b("          </a>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("    <!-- Trending Questions -->");t.b("\n");t.b("\n" + i);t.b("    <!-- Help Topics -->");t.b("\n" + i);if(t.s(t.f("hasHelpTopics",c,p,1),c,p,0,668,1488,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"help-topics\" id=\"help_topics\">");t.b("\n" + i);t.b("      <h2>");if(t.s(t.f("translate",c,p,1),c,p,0,740,766,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.help_topics");});c.pop();}t.b("</h2>");t.b("\n" + i);t.b("      <ul class=\"four columns\">");t.b("\n" + i);if(t.s(t.f("help_topics_column1",c,p,1),c,p,0,850,978,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("          <a  class=\"topics link\" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b(t.t(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("      </ul>");t.b("\n");t.b("\n" + i);t.b("      <ul class=\"four columns\">");t.b("\n" + i);if(t.s(t.f("help_topics_column2",c,p,1),c,p,0,1080,1207,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("          <a class=\"topics link\" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b(t.t(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("      </ul>");t.b("\n");t.b("\n" + i);t.b("      <ul class=\"four columns\">");t.b("\n" + i);if(t.s(t.f("help_topics_column3",c,p,1),c,p,0,1309,1436,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("          <a class=\"topics link\" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b(t.t(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("      </ul>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}if(t.s(t.f("hasTopicArticleMappings",c,p,1),c,p,0,1539,2676,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"v2-topic-list\">");t.b("\n" + i);t.b("        <div class=\"faq-topic-header\">");if(t.s(t.f("translate",c,p,1),c,p,0,1626,1651,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.faq_topics");});c.pop();}t.b("</div>");t.b("\n" + i);if(t.s(t.f("topicArticleMappings",c,p,1),c,p,0,1705,2633,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <div class=\"faq-topic\">");t.b("\n" + i);if(t.s(t.f("topic",c,p,1),c,p,0,1762,2597,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("              <div class=\"topic-header\">");t.b("\n" + i);t.b("                <div class=\"icon-arrow-right\"></div>");t.b("\n" + i);t.b("                <div class=\"icon-arrow-down\" style=\"display:none\"></div>");t.b("\n" + i);t.b("                <span class=\"topic-heading\" topicId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b(t.t(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("              </div>");t.b("\n" + i);t.b("              <div class=\"answer article-summary\" id=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" style=\"display:none\">");t.b("\n" + i);t.b("                <ul class=\"unstyled\">");t.b("\n" + i);if(t.s(t.f("articles",c,p,1),c,p,0,2234,2528,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                    <li>");t.b("\n" + i);if(t.s(t.f("article",c,p,1),c,p,0,2294,2471,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                        <a class=\"article\" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b("\n" + i);t.b("                          ");t.b(t.v(t.f("heading",c,p,0)));t.b("\n" + i);t.b("                        </a>");t.b("\n" + i);});c.pop();}t.b("                    </li>");t.b("\n" + i);});c.pop();}t.b("                </ul>");t.b("\n" + i);t.b("              </div>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);});c.pop();}t.b("      </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "<!-- FAQ: New HTML Code -->\n    <!-- Trending Questions -->\n    {{#hasTrendingQuestions}}\n    <div id=\"pushContents\" class=\"faq-list\">\n      <h2>{{#translate}}js.modules.faq.trending_questions{{/translate}}</h2>\n      <ul>\n        {{#trending_question}}\n        <li>\n          <a class=\"trending-questions link\" levelId={{level}} searchId={{searchId}} href=\"#{{searchId}}\">\n            {{#heading}} {{{heading}}} {{/heading}}\n            {{^heading}} {{{text}}} {{/heading}}\n          </a>\n        </li>\n        {{/trending_question}}\n      </ul>\n    </div>\n    {{/hasTrendingQuestions}}\n    <!-- Trending Questions -->\n\n    <!-- Help Topics -->\n    {{#hasHelpTopics}}\n    <div class=\"help-topics\" id=\"help_topics\">\n      <h2>{{#translate}}js.modules.faq.help_topics{{/translate}}</h2>\n      <ul class=\"four columns\">\n        {{#help_topics_column1}}\n        <li>\n          <a  class=\"topics link\" searchId={{searchId}} href=\"#{{searchId}}\">{{{text}}}</a>\n        </li>\n        {{/help_topics_column1}}\n      </ul>\n\n      <ul class=\"four columns\">\n        {{#help_topics_column2}}\n        <li>\n          <a class=\"topics link\" searchId={{searchId}} href=\"#{{searchId}}\">{{{text}}}</a>\n        </li>\n        {{/help_topics_column2}}\n      </ul>\n\n      <ul class=\"four columns\">\n        {{#help_topics_column3}}\n        <li>\n          <a class=\"topics link\" searchId={{searchId}} href=\"#{{searchId}}\">{{{text}}}</a>\n        </li>\n        {{/help_topics_column3}}\n      </ul>\n    </div>\n    {{/hasHelpTopics}}\n    {{#hasTopicArticleMappings}}\n      <div class=\"v2-topic-list\">\n        <div class=\"faq-topic-header\">{{#translate}}js.modules.faq.faq_topics{{/translate}}</div>\n        {{#topicArticleMappings}}\n          <div class=\"faq-topic\">\n            {{#topic}}\n              <div class=\"topic-header\">\n                <div class=\"icon-arrow-right\"></div>\n                <div class=\"icon-arrow-down\" style=\"display:none\"></div>\n                <span class=\"topic-heading\" topicId={{searchId}} searchId={{searchId}} href=\"#{{searchId}}\">{{{text}}}</span>\n              </div>\n              <div class=\"answer article-summary\" id={{searchId}} style=\"display:none\">\n                <ul class=\"unstyled\">\n                  {{#articles}}\n                    <li>\n                      {{#article}}\n                        <a class=\"article\" searchId={{searchId}} href=\"#{{searchId}}\">\n                          {{heading}}\n                        </a>\n                      {{/article}}\n                    </li>\n                  {{/articles}}\n                </ul>\n              </div>\n            {{/topic}}\n          </div>\n        {{/topicArticleMappings}}\n      </div>\n    {{/hasTopicArticleMappings}}", Hogan);
},{"hogan.js":71}],26:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"no-search-results\">");t.b("\n" + i);t.b("  <div class=\"search-result-header\">");if(t.s(t.f("translate",c,p,1),c,p,0,82,113,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.search_not_found");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("  <div class=\"suggestions-header\">");if(t.s(t.f("translate",c,p,1),c,p,0,182,213,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.some_suggestions");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("  <ul id=\"suggestion-list\">");t.b("\n" + i);t.b("    <li>");if(t.s(t.f("translate",c,p,1),c,p,0,284,315,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.general_keywords");});c.pop();}t.b("</li>");t.b("\n" + i);t.b("    <li>");if(t.s(t.f("translate",c,p,1),c,p,0,357,390,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.different_keywords");});c.pop();}t.b("</li>");t.b("\n" + i);t.b("    <li>");if(t.s(t.f("translate",c,p,1),c,p,0,432,461,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.check_spelling");});c.pop();}t.b("</li>");t.b("\n" + i);t.b("  </ul>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"no-search-results\">\n  <div class=\"search-result-header\">{{#translate}}js.modules.faq.search_not_found{{/translate}}</div>\n  <div class=\"suggestions-header\">{{#translate}}js.modules.faq.some_suggestions{{/translate}}</div>\n  <ul id=\"suggestion-list\">\n    <li>{{#translate}}js.modules.faq.general_keywords{{/translate}}</li>\n    <li>{{#translate}}js.modules.faq.different_keywords{{/translate}}</li>\n    <li>{{#translate}}js.modules.faq.check_spelling{{/translate}}</li>\n  </ul>\n</div>", Hogan);
},{"hogan.js":71}],27:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"result\">");t.b("\n" + i);t.b("  <h4>");t.b("\n" + i);t.b("    <a class=\"article\" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b(t.t(t.f("heading",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("  </h4>");t.b("\n" + i);t.b("  <div class=\"answer article-summary\">");t.b("\n" + i);t.b("    <span class=\"article-text-container\" style=\"display:none\">");t.b("\n" + i);t.b("        ");t.b(t.t(t.f("text",c,p,0)));t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("    <span class=\"truncated-article-container\">");t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("    <span class");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"result\">\n  <h4>\n    <a class=\"article\" searchId={{searchId}} href=\"#{{searchId}}\">{{{heading}}}</a>\n  </h4>\n  <div class=\"answer article-summary\">\n    <span class=\"article-text-container\" style=\"display:none\">\n        {{{text}}}\n    </span>\n    <span class=\"truncated-article-container\">\n    </span>\n    <span class\n  </div>\n</div>\n", Hogan);
},{"hogan.js":71}],28:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("showVerticalPageFlow",c,p,1),c,p,1,0,0,"")){t.b("  <div id=\"topic_explanation\" class=\"help-topics-faq\">");t.b("\n" + i);t.b("      <h2>");t.b(t.t(t.f("text",c,p,0)));t.b("</h2>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};if(t.s(t.f("showVerticalPageFlow",c,p,1),c,p,0,167,636,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=\"topic-header\">");t.b("\n" + i);t.b("    <div class=\"icon-arrow-right\"></div>");t.b("\n" + i);t.b("    <div class=\"icon-arrow-down\" style=\"display:none\"></div>");t.b("\n" + i);t.b("    <span class=\"topic-heading\" topicId=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b(t.t(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("  <div class=\"answer article-summary\">");t.b("\n" + i);t.b("    <ul class=\"unstyled\">");t.b("\n" + i);if(t.s(t.f("articles",c,p,1),c,p,0,457,603,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("          <a class=\"article\" searchId=");t.b(t.v(t.f("searchId",c,p,0)));t.b(" href=\"#");t.b(t.v(t.f("searchId",c,p,0)));t.b("\">");t.b("\n" + i);t.b("            ");t.b(t.v(t.f("heading",c,p,0)));t.b("\n" + i);t.b("          </a>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("    </ul>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{^showVerticalPageFlow}}\n  <div id=\"topic_explanation\" class=\"help-topics-faq\">\n      <h2>{{{text}}}</h2>\n  </div>\n{{/showVerticalPageFlow}}\n{{#showVerticalPageFlow}}\n  <div class=\"topic-header\">\n    <div class=\"icon-arrow-right\"></div>\n    <div class=\"icon-arrow-down\" style=\"display:none\"></div>\n    <span class=\"topic-heading\" topicId={{id}}>{{{text}}}</span>\n  </div>\n  <div class=\"answer article-summary\">\n    <ul class=\"unstyled\">\n      {{#articles}}\n        <li>\n          <a class=\"article\" searchId={{searchId}} href=\"#{{searchId}}\">\n            {{heading}}\n          </a>\n        </li>\n      {{/articles}}\n    </ul>\n  </div>\n{{/showVerticalPageFlow}}\n\n", Hogan);
},{"hogan.js":71}],29:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("trendingArticleList",c,p,1),c,p,0,24,938,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("trendingArticle",c,p,1),c,p,0,49,917,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"article-header\">");t.b("\n" + i);t.b("      <div class=\"icon-arrow-right\"></div>");t.b("\n" + i);t.b("      <div class=\"icon-arrow-down\" style=\"display:none\"></div>");t.b("\n" + i);t.b("      <div class=\"article\" articleId=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b(t.t(t.f("heading",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"answer article-summary\" id=");t.b(t.v(t.f("id",c,p,0)));t.b(" style=\"display:none\">");t.b("\n" + i);t.b("      <span class=\"article-text-container\" >");t.b("\n" + i);t.b("          ");t.b(t.t(t.f("text",c,p,0)));t.b("\n" + i);t.b("      </span>");t.b("\n" + i);t.b("      <div class=\"rating\">");t.b("\n" + i);t.b("        <div class=\"ratings\" id=");t.b(t.v(t.f("id",c,p,0)));t.b(">");t.b("\n" + i);t.b("          <span>");if(t.s(t.f("translate",c,p,1),c,p,0,513,536,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.helptext");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            <a data-bhw=\"article___");t.b(t.v(t.f("id",c,p,0)));t.b("___yes\" >");if(t.s(t.f("translate",c,p,1),c,p,0,622,640,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.yes");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            |");t.b("\n" + i);t.b("            <a data-bhw=\"article___");t.b(t.v(t.f("id",c,p,0)));t.b("___no\">");if(t.s(t.f("translate",c,p,1),c,p,0,735,752,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.no");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"thanks\" style=\"display:none\">");if(t.s(t.f("translate",c,p,1),c,p,0,849,870,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.faq.thanks");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#trendingArticleList}}  \n  {{#trendingArticle}}\n    <div class=\"article-header\">\n      <div class=\"icon-arrow-right\"></div>\n      <div class=\"icon-arrow-down\" style=\"display:none\"></div>\n      <div class=\"article\" articleId={{id}}>{{{heading}}}</div>\n    </div>\n    <div class=\"answer article-summary\" id={{id}} style=\"display:none\">\n      <span class=\"article-text-container\" >\n          {{{text}}}\n      </span>\n      <div class=\"rating\">\n        <div class=\"ratings\" id={{id}}>\n          <span>{{#translate}}js.modules.faq.helptext{{/translate}}</span>\n            <a data-bhw=\"article___{{id}}___yes\" >{{#translate}}js.modules.faq.yes{{/translate}}</a>\n            |\n            <a data-bhw=\"article___{{id}}___no\">{{#translate}}js.modules.faq.no{{/translate}}</a>\n        </div>\n        <div class=\"thanks\" style=\"display:none\">{{#translate}}js.modules.faq.thanks{{/translate}}</div>\n      </div>\n    </div>\n  {{/trendingArticle}}\n{{/trendingArticleList}} ", Hogan);
},{"hogan.js":71}],30:[function(require,module,exports){
var GrouponValidate;

GrouponValidate = {
  email: function(value) {
    var emailInvalidRegex, emailValidRegex, invalidMatch, validMatch;
    if (value.length > 100) {
      return false;
    }
    emailValidRegex = "^((\\\"[^\\\"\\f\\n\\r\\t\\v\\b]+\\\")|([\\.\\w=\\!\\#\\$\\%\\&\\'\\*\\+\\-\\~\\/\\^\\`\\|\\{\\}]+))@((\\[(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))\\])|(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))|((([A-Za-z0-9\\-])+\\.)+[A-Za-z\\-]+))$";
    validMatch = new RegExp(emailValidRegex);
    emailInvalidRegex = "<|`";
    invalidMatch = new RegExp(emailInvalidRegex);
    return validMatch.test(value) && !invalidMatch.test(value);
  },
  zip: function(value) {
    var regexp, zip;
    if (value === '' || value === 'undefined') {
      return false;
    }
    zip = $.trim(value);
    regexp = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/;
    return regexp.test(zip);
  },
  phone: function(value) {
    var phone, regExp;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^(?:\d{3}|\(\d{3}\))(?: *|-?)\d{3}(?: *|-?)\d{4}$/;
    return regExp.test(phone);
  },
  phoneInternational: function(value) {
    var phone, regExp, regExp1;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^[0-9]+$/;
    if (regExp.test(phone)) {
      return true;
    }
    regExp = /(?=^[\( *\-*\) *0-9+]*$)(?=^(?!\-+))(?=\((\d{1,} *\d{0,})\)|\((\d{1,}\-*\d{0,})\)|\((\d{1,})\))/m;
    regExp1 = /^[ *\-* *0-9+]*$/;
    if (regExp.test(phone)) {
      return true;
    } else {
      return regExp1.test(phone);
    }
  },
  creditCard: function(value) {
    var description, regExp;
    if (value.length === 0) {
      return false;
    }
    description = $.trim(value);
    regExp = /(cc#\s|credit\scard\s|Visa\s|visa\s|mastercard\s|Mastercard\sAmerican\s|american\sJCB\s|jcb\s|Discover\s|discover\s)((?:(?:4\d{3})|(?:5[1-5]\d{2})|6(?:011|5[0-9]{2}))(?:-?|\s*)(?:\d{4}(?:-?|\s*)){3}|(?:3[4,7]\d{2})(?:-?|\s*)\d{6}(?:-?|\s*)\d{5}|(?:2131|1800|3088|3337|3096\d{11})|((35\d{2}-?\s?)(\d{4}(-?\s?))))/;
    return regExp.test(description);
  }
};

module.exports = GrouponValidate;



},{}],31:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("isVertical",c,p,1),c,p,1,0,0,"")){t.b("  <div class=\"content\">");t.b("\n" + i);t.b("      <div class=\"page-error error text-center\">");t.b("\n" + i);if(t.s(t.f("errorHtmlText",c,p,1),c,p,0,117,156,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          ");t.b(t.t(t.f("errorHtmlText",c,p,0)));t.b("\n" + i);});c.pop();}t.b("\n" + i);if(!t.s(t.f("errorHtmlText",c,p,1),c,p,1,0,0,"")){t.b("        <h1>");if(t.s(t.f("translate",c,p,1),c,p,0,229,252,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.oops");});c.pop();}t.b("</h1>");t.b("\n" + i);t.b("        <div class=\"error-content\">");t.b("\n" + i);t.b("            <p>");if(t.s(t.f("translate",c,p,1),c,p,0,337,369,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.error_happend");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"error_reload\" href=\"javascript:;\">");if(t.s(t.f("translate",c,p,1),c,p,0,476,501,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.reload");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("                ");if(t.s(t.f("translate",c,p,1),c,p,0,550,580,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.reload_text");});c.pop();}t.b("\n" + i);t.b("            </p>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);};t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};if(t.s(t.f("isVertical",c,p,1),c,p,0,708,819,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div class=page-error>");t.b("\n" + i);t.b("    <h3>");if(t.s(t.f("translate",c,p,1),c,p,0,756,790,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.ticket_error");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{^isVertical}}  \n  <div class=\"content\">\n      <div class=\"page-error error text-center\">\n        {{#errorHtmlText}}\n          {{{errorHtmlText}}}\n        {{/errorHtmlText}}\n\n        {{^errorHtmlText}}\n        <h1>{{#translate}}js.modules.support.oops{{/translate}}</h1>\n        <div class=\"error-content\">\n            <p>{{#translate}}js.modules.support.error_happend{{/translate}}</p>\n            <p>\n              <a class=\"error_reload\" href=\"javascript:;\">{{#translate}}js.modules.support.reload{{/translate}}</a>\n                {{#translate}}js.modules.support.reload_text{{/translate}}\n            </p>\n        </div>\n        {{/errorHtmlText}}\n\n      </div>\n  </div>\n{{/isVertical}}\n{{#isVertical}}\n  <div class=page-error>\n    <h3>{{#translate}}js.modules.support.v2.ticket_error{{/translate}}</h3>\n  </div>\n{{/isVertical}}\n", Hogan);
},{"hogan.js":71}],32:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"footer_dynamic_links\" class='hide'>");t.b("\n" + i);t.b("  <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,65,105,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.more_ways_to_get_help");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("  <div class=\"help_text\" style=\"font-size: 13px\">");t.b("\n" + i);t.b("    <div>");t.b("\n" + i);t.b("      <div>");t.b("\n" + i);t.b("        <span class=\"lnk-email-us lnk\" style=\"display:none\" data-bhw=\"email_us\">");if(t.s(t.f("translate",c,p,1),c,p,0,291,317,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.emailus");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("      <div>");t.b("\n" + i);t.b("        <span class=\"lnk-call-us\" id=\"normal\">");if(t.s(t.f("translate",c,p,1),c,p,0,424,449,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.callus");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"footer_dynamic_links\" class='hide'>\n  <h5>{{#translate}}js.modules.support.more_ways_to_get_help{{/translate}}</h5>\n  <div class=\"help_text\" style=\"font-size: 13px\">\n    <div>\n      <div>\n        <span class=\"lnk-email-us lnk\" style=\"display:none\" data-bhw=\"email_us\">{{#translate}}js.modules.support.emailus{{/translate}}</span>\n      </div>\n      <div>\n        <span class=\"lnk-call-us\" id=\"normal\">{{#translate}}js.modules.support.callus{{/translate}}</span>\n      </div>\n    </div>\n  </div>\n</div>", Hogan);
},{"hogan.js":71}],33:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"support-info-wrapper\">");t.b("\n" + i);t.b("  <section class=\"main row support-info\">");t.b("\n" + i);t.b("    <div class=\"twelve columns\">");t.b("\n" + i);t.b("      <section class=\"module\" >");t.b("\n" + i);t.b("        <div class=\"module-body\" id=\"content\" >");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,295,331,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.enhance_your_exper");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,395,431,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.get_relevant_deals");});c.pop();}t.b("\n" + i);t.b("              <a class=\"location-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/profile/edit\">");if(t.s(t.f("translate",c,p,1),c,p,0,532,559,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.locations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,626,655,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.let_us_know");});c.pop();}t.b("\n" + i);t.b("              <a class=\"preference-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/profile/edit\">");if(t.s(t.f("translate",c,p,1),c,p,0,758,792,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.deal_preferences");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,903,1474,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,934,972,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.access_your_groupons");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"groupons-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/groupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1090,1119,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"gift-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/gift_cards\">");if(t.s(t.f("translate",c,p,1),c,p,0,1238,1264,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_gifts");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"reservations-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/reservations\">");if(t.s(t.f("translate",c,p,1),c,p,0,1393,1426,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_reservations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,1584,1621,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.account_quick_links");});c.pop();}t.b("</h5>");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1723,1756,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_your_email");});c.pop();}t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/account\">");if(t.s(t.f("translate",c,p,1),c,p,0,1853,1881,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_account");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1948,1983,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.manage_and_access");});c.pop();}t.b("\n" + i);t.b("              <a class=\"mygroupon-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/groupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,2081,2110,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,2198,2227,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_your");});c.pop();}t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,2326,2363,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,2496,3037,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"credit-lnk\" href=\"/mybillingrecords\">");if(t.s(t.f("translate",c,p,1),c,p,0,2588,2627,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_credit_card_info");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,2771,2813,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/users/");t.b(t.v(t.f("id",c,p,0)));t.b("/account\">");if(t.s(t.f("translate",c,p,1),c,p,0,2956,2989,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_password");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns support_help\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,3160,3199,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.more_ways_to_get_help");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <div class=\"help_text\" style=\"font-size: 13px\"></div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </section>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </section>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"support-info-wrapper\">\n  <section class=\"main row support-info\">\n    <div class=\"twelve columns\">\n      <section class=\"module\" >\n        <div class=\"module-body\" id=\"content\" >\n          <div class=\"four columns\">\n            {{^faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.enhance_your_exper{{/translate}}</h5>\n            <p>\n              {{#translate}}js.modules.shared.get_relevant_deals{{/translate}}\n              <a class=\"location-lnk\" href=\"/users/{{id}}/profile/edit\">{{#translate}}js.modules.shared.locations{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.let_us_know{{/translate}}\n              <a class=\"preference-lnk\" href=\"/users/{{id}}/profile/edit\">{{#translate}}js.modules.shared.deal_preferences{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.access_your_groupons{{/translate}}</h5>\n            <p>\n              <a class=\"groupons-lnk\" href=\"/users/{{id}}/groupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              <a class=\"gift-lnk\" href=\"/users/{{id}}/gift_cards\">{{#translate}}js.modules.shared.my_gifts{{/translate}}</a>\n              <br/>\n              <a class=\"reservations-lnk\" href=\"/users/{{id}}/reservations\">{{#translate}}js.modules.shared.my_reservations{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns\">\n            <h5>{{#translate}}js.modules.shared.account_quick_links{{/translate}}</h5>\n            {{^faqInsteadHelpWizard}}\n            <p>\n              {{#translate}}js.modules.shared.edit_your_email{{/translate}}\n              <a class=\"myaccount-lnk\" href=\"/users/{{id}}/account\">{{#translate}}js.modules.shared.my_account{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.manage_and_access{{/translate}}\n              <a class=\"mygroupon-lnk\" href=\"/users/{{id}}/groupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              <span>\n              {{#translate}}js.modules.shared.change_your{{/translate}}\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.email_subscriptions{{/translate}}</a>\n              </span>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <p>\n              <a class=\"credit-lnk\" href=\"/mybillingrecords\">{{#translate}}js.modules.shared.edit_credit_card_info{{/translate}}</a>\n              <br/>\n              <span>\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.edit_email_subscriptions{{/translate}}</a>\n              </span>\n              <br/>\n              <a class=\"myaccount-lnk\" href=\"/users/{{id}}/account\">{{#translate}}js.modules.shared.change_password{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns support_help\">\n            <h5>{{#translate}}js.modules.shared.more_ways_to_get_help{{/translate}}</h5>\n            <div class=\"help_text\" style=\"font-size: 13px\"></div>\n          </div>\n        </div>\n      </section>\n    </div>\n  </section>\n</div>", Hogan);
},{"hogan.js":71}],34:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"support-info-wrapper\">");t.b("\n" + i);t.b("  <section class=\"main row support-info\">");t.b("\n" + i);t.b("    <div class=\"twelve columns\">");t.b("\n" + i);t.b("      <section class=\"module\" >");t.b("\n" + i);t.b("        <div class=\"module-body\" id=\"content\" >");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,295,331,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.enhance_your_exper");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,395,431,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.get_relevant_deals");});c.pop();}t.b("\n" + i);t.b("              <a class=\"location-lnk\" href=\"/myprofile\">");if(t.s(t.f("translate",c,p,1),c,p,0,516,543,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.locations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,610,639,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.let_us_know");});c.pop();}t.b("\n" + i);t.b("              <a class=\"preference-lnk\" href=\"/myprofile\">");if(t.s(t.f("translate",c,p,1),c,p,0,726,760,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.deal_preferences");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,871,1402,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,902,940,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.access_your_groupons");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1048,1077,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"gifts-lnk\" href=\"/mygifts\">");if(t.s(t.f("translate",c,p,1),c,p,0,1181,1207,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_gifts");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"reservations-lnk\" href=\"/mygroupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1321,1354,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_reservations");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,1512,1549,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.account_quick_links");});c.pop();}t.b("</h5>");t.b("\n" + i);if(!t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,1,0,0,"")){t.b("            <p>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1651,1686,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.manage_and_access");});c.pop();}t.b("\n" + i);t.b("              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">");if(t.s(t.f("translate",c,p,1),c,p,0,1773,1802,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.my_groupons");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              ");if(t.s(t.f("translate",c,p,1),c,p,0,1869,1898,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_your");});c.pop();}t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1997,2034,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);};if(t.s(t.f("faqInsteadHelpWizard",c,p,1),c,p,0,2145,2678,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p>");t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/mybillingrecords\">");if(t.s(t.f("translate",c,p,1),c,p,0,2240,2279,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_credit_card_info");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <span>");t.b("\n" + i);t.b("              <a class=\"subscription-lnk\" href=\"/subscription_center\">");if(t.s(t.f("translate",c,p,1),c,p,0,2423,2465,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.edit_email_subscriptions");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("              </span>");t.b("\n" + i);t.b("              <br/>");t.b("\n" + i);t.b("              <a class=\"myaccount-lnk\" href=\"/myaccount\">");if(t.s(t.f("translate",c,p,1),c,p,0,2597,2630,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.change_password");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("            </p>");t.b("\n" + i);});c.pop();}t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"four columns support_help\">");t.b("\n" + i);t.b("            <h5>");if(t.s(t.f("translate",c,p,1),c,p,0,2801,2840,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.shared.more_ways_to_get_help");});c.pop();}t.b("</h5>");t.b("\n" + i);t.b("            <div class=\"help_text\" style=\"font-size: 13px\"></div>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </section>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </section>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"support-info-wrapper\">\n  <section class=\"main row support-info\">\n    <div class=\"twelve columns\">\n      <section class=\"module\" >\n        <div class=\"module-body\" id=\"content\" >\n          <div class=\"four columns\">\n            {{^faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.enhance_your_exper{{/translate}}</h5>\n            <p>\n              {{#translate}}js.modules.shared.get_relevant_deals{{/translate}}\n              <a class=\"location-lnk\" href=\"/myprofile\">{{#translate}}js.modules.shared.locations{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.let_us_know{{/translate}}\n              <a class=\"preference-lnk\" href=\"/myprofile\">{{#translate}}js.modules.shared.deal_preferences{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <h5>{{#translate}}js.modules.shared.access_your_groupons{{/translate}}</h5>\n            <p>\n              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              <a class=\"gifts-lnk\" href=\"/mygifts\">{{#translate}}js.modules.shared.my_gifts{{/translate}}</a>\n              <br/>\n              <a class=\"reservations-lnk\" href=\"/mygroupons\">{{#translate}}js.modules.shared.my_reservations{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns\">\n            <h5>{{#translate}}js.modules.shared.account_quick_links{{/translate}}</h5>\n            {{^faqInsteadHelpWizard}}\n            <p>\n              {{#translate}}js.modules.shared.manage_and_access{{/translate}}\n              <a class=\"mygroupon-lnk\" href=\"/mygroupons\">{{#translate}}js.modules.shared.my_groupons{{/translate}}</a>\n              <br/>\n              {{#translate}}js.modules.shared.change_your{{/translate}}\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.email_subscriptions{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n            {{#faqInsteadHelpWizard}}\n            <p>\n              <a class=\"myaccount-lnk\" href=\"/mybillingrecords\">{{#translate}}js.modules.shared.edit_credit_card_info{{/translate}}</a>\n              <br/>\n              <span>\n              <a class=\"subscription-lnk\" href=\"/subscription_center\">{{#translate}}js.modules.shared.edit_email_subscriptions{{/translate}}</a>\n              </span>\n              <br/>\n              <a class=\"myaccount-lnk\" href=\"/myaccount\">{{#translate}}js.modules.shared.change_password{{/translate}}</a>\n            </p>\n            {{/faqInsteadHelpWizard}}\n          </div>\n          <div class=\"four columns support_help\">\n            <h5>{{#translate}}js.modules.shared.more_ways_to_get_help{{/translate}}</h5>\n            <div class=\"help_text\" style=\"font-size: 13px\"></div>\n          </div>\n        </div>\n      </section>\n    </div>\n  </section>\n</div>", Hogan);
},{"hogan.js":71}],35:[function(require,module,exports){
var SharedUser;

SharedUser = {
  setGrpnUsrHeader: function(options) {
    if ((options != null ? options.headers : void 0) != null) {
      options.headers['x-csrf-token'] = $('meta[name="csrf-token"]').attr('content');
    }
    if (((options != null ? options.data : void 0) != null) && (options != null ? options.type : void 0) === 'POST') {
      return options.data._csrf = $('meta[name="csrf-token"]').attr('content');
    }
  }
};

module.exports = SharedUser;



},{}],36:[function(require,module,exports){
var PresentersBase, SharedUtilsHelper, SupportAPIHelper, SupportUtilsHelper;

PresentersBase = require('../../../backbone_base/frontend/presenters/base');

SupportUtilsHelper = require('../../../support/frontend/helpers/utils');

SupportAPIHelper = require('../../../support/frontend/helpers/API');

SharedUtilsHelper = {
  toHtml: (function(_this) {
    return function(template, hash, scope) {
      return template.render(PresentersBase.toHashWithHelpers(hash, scope));
    };
  })(this),
  redirectToFaq: function() {
    return window.location.href = "" + window.FAQBASEURL;
  },
  redirectToHelpWizard: function() {
    return window.location.href = "" + window.SUPPORTBASEURL;
  },
  scrollTo: function($container) {
    var hash, ref;
    if ($container) {
      hash = {
        scrollTop: (ref = $container.offset()) != null ? ref.top : void 0
      };
      return $('html, body').animate(hash, 1000);
    }
  },
  toggleCallUs: function(id) {
    var experiment;
    addWrapperLinkOverCallUs();
    experiment = $('span.lnk-call-us').attr('id');
    $('span.lnk-call-us').removeAttr('data-bhw-path');
    $('span.lnk-call-us').removeAttr('data-bhw');
    $('span.lnk-call-us').attr("data-bhw", "phone-number-" + experiment + "-" + id);
    return $('span.lnk-call-us').data("bhw", "phone-number-" + experiment + "-" + id);
  },
  addWrapperLinkOverCallUs: function() {
    $('.contact-number').addClass('hide');
    return $('span.lnk-call-us').addClass('lnk');
  },
  propagateEventBeforeReplacingElements: function(cb) {
    setTimeout(cb);
    return true;
  },
  removeSpecificParamFromUrl: function(url, parameter) {
    var hash, hashPresent, i, pars, prefix, queryString, urlBase, urlparts;
    if (url.indexOf('#') > 0) {
      hashPresent = true;
      hash = url.substr(url.indexOf('#') + 1);
    }
    urlparts = url.split("?");
    if (urlparts.length >= 2) {
      urlBase = urlparts.shift();
      queryString = urlparts.join("?");
      prefix = encodeURIComponent(parameter) + "=";
      pars = queryString.split(/[&;]/g);
      i = pars.length;
      while (i-- > 0) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      url = urlBase + "?" + pars.join("&");
    }
    if (url.indexOf('#') === -1 && hashPresent) {
      url = url + '#' + hash;
    }
    return url;
  },
  abortAjaxRequests: function(requests) {
    _.each(requests, function(req) {
      return req.abort();
    });
    return null;
  },
  startTimer: function(timer) {},
  stopTimer: function(timer) {},
  isIntl: function() {
    var ref;
    return checkIfIsEMEAByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isUS: function() {
    var ref;
    return checkIfIsUSByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  isNeedish: function() {
    var ref;
    return checkIfIsNEEDISHByCountryCluster((ref = window.country) != null ? ref.cluster : void 0);
  },
  checkIfIsUSByCountry: function(country) {
    return getCountryCluster(country) === 'US';
  },
  checkIfIsEMEAByCountry: function(country) {
    return getCountryCluster(country) === 'EMEA';
  },
  checkIfIsNEEDISHByCountry: function(country) {
    return getCountryCluster(country) === 'NEEDISH';
  },
  checkIfIsUSByCountryCluster: function(countryCluster) {
    return countryCluster === 'US';
  },
  checkIfIsEMEAByCountryCluster: function(countryCluster) {
    return countryCluster === 'EMEA';
  },
  checkIfIsNEEDISHByCountryCluster: function(countryCluster) {
    return countryCluster === 'NEEDISH';
  },
  getCountryCluster: function(country) {
    if (country != null) {
      country = country.toUpperCase();
    }
    if (country === 'US' || country === 'IN') {
      return country;
    }
    if (country === 'PH' || country === 'TH') {
      return 'ASIA';
    }
    if (country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
      return 'NEEDISH';
    }
    return 'EMEA';
  },
  getCallUsMsg: function() {
    var customPhoneNumber;
    customPhoneNumber = getCustomPhoneNumber();
    if (customPhoneNumber != null) {
      return I18n.translate('js.modules.shared.call_us_message_with_custom_phone_number', {
        custom_phone_number: customPhoneNumber
      });
    } else {
      return I18n.translate('js.modules.shared.call_us_message');
    }
  },
  getCustomPhoneNumber: function() {
    var dealType, ref;
    dealType = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if ((typeof phoneNumbers !== "undefined" && phoneNumbers !== null ? phoneNumbers[dealType] : void 0) != null) {
      return phoneNumbers[dealType].custom;
    }
  },
  evaluate: function(key) {
    return (key != null) && (key === true || key === "true");
  },
  isCMSEnabled: function() {
    return (typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCMSContentForUS : void 0) || !isUS();
  },
  showDOMElems: function(DOMElems) {
    addShowClass(DOMElems);
    return removeHideClass(DOMElems);
  },
  showDOMElemsInline: function(DOMElems) {
    removeHideClass(DOMElems);
    return addInlineClass(DOMElems);
  },
  hideDOMElems: function(DOMElems) {
    removeShowClass(DOMElems);
    return addHideClass(DOMElems);
  },
  addShowClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'show');
  },
  addInlineClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'display-inline');
  },
  removeDOMElemsInline: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'display-inline');
  },
  removeHideClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'hide');
  },
  removeShowClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'show');
  },
  addHideClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'hide');
  },
  addBtnPrimaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-primary');
  },
  addBtnSecondaryClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'btn-invert');
  },
  addPreferredContactClass: function(DOMElems) {
    return addClassToDOMElems(DOMElems, 'preferred-contact-channel');
  },
  removeBtnPrimaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-primary');
  },
  removeBtnSecondaryClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'btn-invert');
  },
  removePreferredContactClass: function(DOMElems) {
    return removeClassFromDOMElems(DOMElems, 'preferred-contact-channel');
  },
  addBloodHoundTagToDOMElems: function(DOMElems, tagName) {
    return manipulateDOMElems(DOMElems, window.addBloodHoundTagToDOMElem, tagName);
  },
  addClassToDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.addClassToDOMElem, className);
  },
  removeClassFromDOMElems: function(DOMElems, className) {
    return manipulateDOMElems(DOMElems, window.removeClassFromDOMElem, className);
  },
  manipulateDOMElems: function(DOMElems, manipulateDOMElem, CSSSelector) {
    DOMElems = getInArrayFormat(DOMElems);
    return _.each(DOMElems, (function(_this) {
      return function(DOMElem, index) {
        return manipulateDOMElem(DOMElem, CSSSelector);
      };
    })(this));
  },
  addClassToDOMElem: function(DOMElem, className) {
    return DOMElem.addClass(className);
  },
  addBloodHoundTagToDOMElem: function(DOMElem, tagName) {
    DOMElem.removeAttr('data-bhw-path');
    DOMElem.removeAttr('data-bhw');
    DOMElem.attr("data-bhw", tagName);
    return DOMElem.data("bhw", tagName);
  },
  removeClassFromDOMElem: function(DOMElem, className) {
    return DOMElem.removeClass(className);
  },
  getInArrayFormat: function(elements) {
    if (_.isArray(elements)) {
      return elements;
    } else {
      return [elements];
    }
  },
  createTicket: (function(_this) {
    return function(data, successCb, errorCb, loadElem, loadingElemHeight) {
      return propagateEventBeforeReplacingElements(function() {
        var method, ref, tHubData, url;
        SupportUtilsHelper.showLoading(loadElem, loadingElemHeight);
        url = window.SUPPORTBASEURL + "/ticket/create";
        method = "POST";
        tHubData = {
          ticketParams: data,
          user: (ref = window.currentUser) != null ? ref.id : void 0
        };
        TrackingHub.add('ticket-create-params', {
          params: tHubData
        });
        return SupportAPIHelper.call(url, method, data, successCb, errorCb, false);
      });
    };
  })(this)
};

module.exports = SharedUtilsHelper;



},{"../../../backbone_base/frontend/presenters/base":4,"../../../support/frontend/helpers/API":47,"../../../support/frontend/helpers/utils":48}],37:[function(require,module,exports){
var Backbone, SharedAjaxErrorTemplate, SharedAjaxErrorView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedAjaxErrorTemplate = require('../../ajax_error.html.mustache');

SharedAjaxErrorView = (function(superClass) {
  extend(SharedAjaxErrorView, superClass);

  function SharedAjaxErrorView() {
    return SharedAjaxErrorView.__super__.constructor.apply(this, arguments);
  }

  SharedAjaxErrorView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedAjaxErrorTemplate;
  };

  SharedAjaxErrorView.prototype.render = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$container.html(toHtml(this.template, hash, this.I18nScope));
      this.bindEvents();
      return this.$container;
    }
  };

  SharedAjaxErrorView.prototype.bindEvents = function() {
    return $(".error_reload", this.$container).on("click", function() {
      return window.location.reload();
    });
  };

  return SharedAjaxErrorView;

})(Backbone.View);

module.exports = SharedAjaxErrorView;



},{"../../ajax_error.html.mustache":31,"backbone":68}],38:[function(require,module,exports){
var Backbone, SharedFooterLinksTemplate, SharedFooterLoggedTemplate, SharedFooterNotLoggedTemplate, SharedFooterUSMainView, SharedFooterUSPhoneNumberView, SupportPhoneNumberCallBackView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedFooterUSPhoneNumberView = require('./phone_number_view');

SupportPhoneNumberCallBackView = require('../../../../../support/frontend/views/email_form/US/phone_number_call_back_view');

Backbone = require('backbone');

Backbone.$ = $;

SharedFooterLoggedTemplate = require('../../../../footer_logged.html.mustache');

SharedFooterNotLoggedTemplate = require('../../../../footer_not_logged.html.mustache');

SharedFooterLinksTemplate = require('../../../../footer_links.html.mustache');

SharedFooterUSMainView = (function(superClass) {
  extend(SharedFooterUSMainView, superClass);

  function SharedFooterUSMainView() {
    return SharedFooterUSMainView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSMainView.prototype["class"] = 'box support-footer';

  SharedFooterUSMainView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    this.user = window.currentUser;
    this.template = this.user != null ? SharedFooterLoggedTemplate : SharedFooterNotLoggedTemplate;
    return this.footerLinkTemplate = SharedFooterLinksTemplate;
  };

  SharedFooterUSMainView.prototype.render = function() {
    var ref;
    this.$el.append(toHtml(this.template, {
      id: (ref = this.user) != null ? ref.id : void 0,
      faqInsteadHelpWizard: window.faqInsteadHelpWizard
    }, this.I18nScope));
    return this.$el.find('.support_help').html(toHtml(this.footerLinkTemplate, this.user, this.I18nScope));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberView = function() {
    if (experiments.shouldDisplayCallBackOption && !window.isFAQ) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SharedFooterUSMainView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterUSPhoneNumberView();
        return phoneNumberView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.events = {
    "click span.lnk-call-us": "renderPhoneNumberView"
  };

  return SharedFooterUSMainView;

})(Backbone.View);

module.exports = SharedFooterUSMainView;



},{"../../../../../support/frontend/views/email_form/US/phone_number_call_back_view":63,"../../../../footer_links.html.mustache":32,"../../../../footer_logged.html.mustache":33,"../../../../footer_not_logged.html.mustache":34,"./phone_number_view":39,"backbone":68}],39:[function(require,module,exports){
var Backbone, SharedFooterUSPhoneNumberView, SharedPhoneNumberTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedPhoneNumberTemplate = require('../../../../phone_number.html.mustache');

SharedFooterUSPhoneNumberView = (function(superClass) {
  extend(SharedFooterUSPhoneNumberView, superClass);

  function SharedFooterUSPhoneNumberView() {
    return SharedFooterUSPhoneNumberView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSPhoneNumberView.prototype["class"] = 'support';

  SharedFooterUSPhoneNumberView.prototype.initialize = function(options) {
    if (options == null) {
      options = {};
    }
    this.I18nScope = 'modules.support';
    this.template = SharedPhoneNumberTemplate;
    return this.popupContainer = $("#popup");
  };

  SharedFooterUSPhoneNumberView.prototype.render = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    return this.popupContainer.html(this.el);
  };

  SharedFooterUSPhoneNumberView.prototype.toHash = function() {
    var deal, hash, ref, ref1;
    deal = ((ref = Groupon.Support) != null ? (ref1 = ref.currentOrder) != null ? ref1.DEAL_TYPE : void 0 : void 0) || null;
    hash = {
      showMRDealPhoneNumbers: deal === "GETAWAYS_MARKET_RATE"
    };
    if (deal === "GETAWAYS_MARKET_RATE") {
      TrackingHub.add("SUPPORT-APP-MARKET-RATE-CALL-US", {
        data: window.currentUser
      });
    }
    return hash;
  };

  SharedFooterUSPhoneNumberView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SharedFooterUSPhoneNumberView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal"
  };

  return SharedFooterUSPhoneNumberView;

})(Backbone.View);

module.exports = SharedFooterUSPhoneNumberView;



},{"../../../../phone_number.html.mustache":41,"backbone":68}],40:[function(require,module,exports){
var Backbone, SharedSpinnerTemplate, SharedSpinnerView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedSpinnerTemplate = require('../../spinner.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SharedSpinnerView = (function(superClass) {
  extend(SharedSpinnerView, superClass);

  function SharedSpinnerView() {
    return SharedSpinnerView.__super__.constructor.apply(this, arguments);
  }

  SharedSpinnerView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedSpinnerTemplate;
  };

  SharedSpinnerView.prototype.show = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$el.html(toHtml(this.template, hash, this.I18nScope));
      if (hash.append) {
        this.$container.append(this.$el);
      } else {
        this.$container.html(this.$el);
      }
      if (hash.height) {
        this.$el.css('height', hash.height);
        $('.g-spinner', this.$el).css('height', hash.height);
      }
      if (hash.id) {
        return this.$el.attr('id', hash.id);
      }
    }
  };

  SharedSpinnerView.prototype.hide = function() {
    return this.$el.empty();
  };

  SharedSpinnerView.prototype.remove = function() {
    return this.$el.remove();
  };

  return SharedSpinnerView;

})(Backbone.View);

module.exports = SharedSpinnerView;



},{"../../spinner.html.mustache":42,"backbone":68}],41:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div  class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body phone-number\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,209,245,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_popup_header");});c.pop();}t.b("\n" + i);t.b("    </h3>");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);t.b("      <div class=\"twelve columns callUsPopupData p20\">");t.b("\n" + i);t.b("        <div>");t.b("\n" + i);t.b("          <span class = \"high_volume_msg_warning\">");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,438,479,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_msg_1");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("          <span>");t.b("\n" + i);t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,555,596,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_msg_2");});c.pop();}t.b("\n" + i);t.b("          </span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class=\"normal-phone-hours\">");t.b("\n" + i);t.b("          <span>");t.b("\n" + i);if(!t.s(t.f("showMRDealPhoneNumbers",c,p,1),c,p,1,0,0,"")){t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,768,816,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_phone_number");});c.pop();}t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showMRDealPhoneNumbers",c,p,1),c,p,0,911,1016,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            ");if(t.s(t.f("translate",c,p,1),c,p,0,938,989,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.high_call_volume_phone_number_mr");});c.pop();}t.b("\n" + i);});c.pop();}t.b("          </span>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <div class=\"modal-footer\">");t.b("\n" + i);t.b("      <a class=\"close-modal\">");t.b("\n" + i);t.b("        ");if(t.s(t.f("translate",c,p,1),c,p,0,1184,1224,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.return_to_help_wizard");});c.pop();}t.b("\n" + i);t.b("      </a>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div  class=\"modal show-modal\">\n  <div class=\"modal-body phone-number\">\n    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">\n      {{#translate}}js.modules.support.call_popup_header{{/translate}}\n    </h3>\n    <div class=\"row\">\n      <div class=\"twelve columns callUsPopupData p20\">\n        <div>\n          <span class = \"high_volume_msg_warning\">\n            {{#translate}}js.modules.support.high_call_volume_msg_1{{/translate}}\n          </span>\n          <span>\n            {{#translate}}js.modules.support.high_call_volume_msg_2{{/translate}}\n          </span>\n        </div>\n        <div class=\"normal-phone-hours\">\n          <span>\n            {{^showMRDealPhoneNumbers}}\n            {{#translate}}js.modules.support.high_call_volume_phone_number{{/translate}}\n            {{/showMRDealPhoneNumbers}}\n\n            {{#showMRDealPhoneNumbers}}\n            {{#translate}}js.modules.support.high_call_volume_phone_number_mr{{/translate}}\n            {{/showMRDealPhoneNumbers}}\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <a class=\"close-modal\">\n        {{#translate}}js.modules.support.return_to_help_wizard{{/translate}}\n      </a>\n    </div>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":71}],42:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"icon-g-loader g-spinner\"></div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"icon-g-loader g-spinner\"></div>\n", Hogan);
},{"hogan.js":71}],43:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"ajaxshim\" style=\"position: fixed; top: 0px; right: 0px; bottom: 0px; left: 0px; opacity: 0.0; z-index: 9999;\"\"></div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"ajaxshim\" style=\"position: fixed; top: 0px; right: 0px; bottom: 0px; left: 0px; opacity: 0.0; z-index: 9999;\"\"></div>", Hogan);
},{"hogan.js":71}],44:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("email_input_template",c,p,1),c,p,0,25,654,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <strong><div class='call-me-back-option-labels call-back-email'>");t.b(t.v(t.f("label",c,p,0)));t.b("</div></strong>");t.b("\n" + i);if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"inputField email_input call-back-inputs call-back-email-input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactEmail\" placeholder=\"Required\" data-bhw='call-me-back-option-email' aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);t.b("    <span class=\"validateEmailInput invalid-input call-back-option-error initially-hidden\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,478,520,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_invalid_email");});c.pop();}t.b("\n" + i);t.b("    </span>");t.b("\n" + i);};if(t.s(t.f("isLoggedIn",c,p,1),c,p,0,582,638,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <p class=\"call-back-email-value\">");t.b(t.v(t.f("value",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n" + i);if(t.s(t.f("user_name_input_template",c,p,1),c,p,0,710,1178,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <strong><div class='call-me-back-option-labels call-back-user-name'>");t.b(t.v(t.f("label",c,p,0)));t.b("</div></strong>");t.b("\n" + i);if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("    <input class=\"inputField user_name_input call-back-inputs call-back-user-name-input\" size=\"40\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactUserName\" data-bhw='call-me-back-option-user-name' placeholder=\"Required\" aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b(">");t.b("\n" + i);};if(t.s(t.f("isLoggedIn",c,p,1),c,p,0,1104,1162,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <p class=\"call-back-user-name-value\">");t.b(t.v(t.f("value",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("\n" + i);if(t.s(t.f("phone_input_template",c,p,1),c,p,0,1234,1773,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <strong><div class='call-me-back-option-labels call-back-phone-number-label'>");t.b(t.v(t.f("label",c,p,0)));t.b("</div></strong>");t.b("\n" + i);t.b("  <input class=\"inputField phone_number_input call-back-inputs call-back-phone-number-input\" maxLength=");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" type=\"text\" name=\"contactPhone\" data-bhw='call-me-back-option-phone-number' placeholder=\"(XXX) XXX-XXXX\" aria-label=");t.b(t.v(t.f("label",c,p,0)));t.b("><br>");t.b("\n" + i);t.b("  <span class=\"validatePhoneNumberInput invalid-input initially-hidden call-back-option-error\"> ");if(t.s(t.f("translate",c,p,1),c,p,0,1697,1739,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_invalid_phone");});c.pop();}t.b("\n" + i);t.b("    <br>");t.b("\n" + i);t.b("  </span>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#email_input_template}}\n  <strong><div class='call-me-back-option-labels call-back-email'>{{label}}</div></strong>\n  {{^isLoggedIn}}  \n    <input class=\"inputField email_input call-back-inputs call-back-email-input\" size=\"40\" maxLength={{maxLength}} type=\"text\" name=\"contactEmail\" placeholder=\"Required\" data-bhw='call-me-back-option-email' aria-label={{label}}>\n    <span class=\"validateEmailInput invalid-input call-back-option-error initially-hidden\">\n      {{#translate}}js.modules.support.call_back_invalid_email{{/translate}}\n    </span>\n  {{/isLoggedIn}}\n  {{#isLoggedIn}}  \n    <p class=\"call-back-email-value\">{{value}}</p>\n  {{/isLoggedIn}}\n{{/email_input_template}}\n\n{{#user_name_input_template}}\n  <strong><div class='call-me-back-option-labels call-back-user-name'>{{label}}</div></strong>\n  {{^isLoggedIn}} \n    <input class=\"inputField user_name_input call-back-inputs call-back-user-name-input\" size=\"40\" maxLength={{maxLength}} type=\"text\" name=\"contactUserName\" data-bhw='call-me-back-option-user-name' placeholder=\"Required\" aria-label={{label}}>\n  {{/isLoggedIn}}\n  {{#isLoggedIn}}\n    <p class=\"call-back-user-name-value\">{{value}}</p>\n  {{/isLoggedIn}}\n{{/user_name_input_template}}\n\n{{#phone_input_template}}\n  <strong><div class='call-me-back-option-labels call-back-phone-number-label'>{{label}}</div></strong>\n  <input class=\"inputField phone_number_input call-back-inputs call-back-phone-number-input\" maxLength={{maxLength}} type=\"text\" name=\"contactPhone\" data-bhw='call-me-back-option-phone-number' placeholder=\"(XXX) XXX-XXXX\" aria-label={{label}}><br>\n  <span class=\"validatePhoneNumberInput invalid-input initially-hidden call-back-option-error\"> {{#translate}}js.modules.support.call_back_invalid_phone{{/translate}}\n    <br>\n  </span>\n{{/phone_input_template}}", Hogan);
},{"hogan.js":71}],45:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"popupContent\" class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");if(t.s(t.f("translate",c,p,1),c,p,0,206,227,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.fp");});c.pop();}t.b("</h3>");t.b("\n");t.b("\n" + i);t.b("    <div class=\"row\">");t.b("\n" + i);t.b("      <div class=\"twelve columns orderPopupData border-bottom p20\">");t.b("\n" + i);t.b("        <p>");t.b(t.t(t.f("fine_print",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"popupContent\" class=\"modal show-modal\">\n  <div class=\"modal-body\">\n    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">{{#translate}}js.modules.support.fp{{/translate}}</h3>\n\n    <div class=\"row\">\n      <div class=\"twelve columns orderPopupData border-bottom p20\">\n        <p>{{{fine_print}}}</p>\n      </div>\n    </div>\n\n  </div>\n</div>", Hogan);
},{"hogan.js":71}],46:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"content\">");t.b(t.v(t.f("content",c,p,0)));t.b("</div><div class=\"close\">x</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"content\">{{content}}</div><div class=\"close\">x</div>", Hogan);
},{"hogan.js":71}],47:[function(require,module,exports){
var SharedUser, SupportAPIHelper, SupportAjaxShimTemplate, async, callWasInterrupted;

async = require('../../../../core/frontend/vendor_modules/async');

SharedUser = require('../../../shared/frontend/helpers/user');

SupportAjaxShimTemplate = require('../../ajax_shim.html.mustache');

callWasInterrupted = function(status, errorMessage) {
  return status === 'abort' || (errorMessage == null) || (errorMessage != null ? errorMessage.length : void 0) === 0;
};

SupportAPIHelper = {
  httpErrorHandler: (function(_this) {
    return function(response, status, errorMessage) {
      if (callWasInterrupted(status, errorMessage)) {
        return;
      }
      flash('error', 'Sorry something went wrong');
      return $('#g-spinner').hide();
    };
  })(this),
  errorHandler: function(errorMessage) {
    return flash('error', errorMessage);
  },
  parallel: function(urls, datas, responseCallback, blockUI, timer, timeout, methods) {
    var callbacks, errorCb, requests, successCb;
    if (methods == null) {
      methods = [];
    }
    successCb = function(cb) {
      return (function(_this) {
        return function(response) {
          return cb(null, response);
        };
      })(this);
    };
    errorCb = function(cb) {
      return (function(_this) {
        return function(errorMessage) {
          return cb(null, null);
        };
      })(this);
    };
    requests = [];
    callbacks = [];
    _.each(urls, (function(_this) {
      return function(url, index) {
        return callbacks.push(function(cb) {
          var req;
          if (methods[index] != null) {
            req = _this.call(url, methods[index], datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          } else {
            req = _this.get(url, datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          }
          return requests.push(req);
        });
      };
    })(this));
    async.parallel(callbacks, (function(_this) {
      return function(err, results) {
        if (err != null) {
          return responseCallback(null);
        }
        return responseCallback(results);
      };
    })(this));
    return requests;
  },
  get: function(url, data, success, error, blockUI, timer, timeout) {
    var args;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    args = Array.prototype.slice.call(arguments);
    switch (args.length) {
      case 2:
        success = data;
        data = void 0;
        break;
      case 3:
        if (typeof args[1] === 'function') {
          error = success;
          success = data;
          data = void 0;
        }
    }
    return this.call(url, 'GET', data, success, error, blockUI, timer, timeout);
  },
  call: function(url, method, data, successHandler, customErrorHandler, blockUI, timer, timeout) {
    var ajaxShimTemplate, options, request;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    data || (data = {});
    switch (method) {
      case 'PUT':
        method = 'POST';
        data._method = 'PUT';
        break;
      case 'DELETE':
        method = 'POST';
        data._method = 'DELETE';
    }
    if (blockUI) {
      ajaxShimTemplate = SupportAjaxShimTemplate.render({});
      $('body').append(ajaxShimTemplate);
    }
    options = {
      url: url,
      type: method,
      dataType: 'json',
      headers: {},
      timeout: timeout,
      data: data,
      error: (function(_this) {
        return function(err, status, errorMessage) {
          if (timer != null) {
            stopTimer(timer);
          }
          if (blockUI) {
            $('.ajaxshim').remove();
          }
          if (customErrorHandler) {
            return customErrorHandler(errorMessage);
          } else {
            return _this.httpErrorHandler(err, status, errorMessage);
          }
        };
      })(this),
      success: (function(_this) {
        return function(response) {
          if (timer != null) {
            stopTimer(timer);
          }
          $('.ajaxshim').remove();
          if (!response || response.length === 0 || (response.error != null)) {
            if (customErrorHandler != null) {
              return customErrorHandler(response);
            } else {
              return _this.errorHandler(null);
            }
          } else {
            return successHandler(response);
          }
        };
      })(this)
    };
    SharedUser.setGrpnUsrHeader(options);
    if (timer != null) {
      startTimer(timer);
    }
    request = $.ajax(options);
    return request;
  }
};

module.exports = SupportAPIHelper;



},{"../../../../core/frontend/vendor_modules/async":2,"../../../shared/frontend/helpers/user":35,"../../ajax_shim.html.mustache":43}],48:[function(require,module,exports){
var SharedSpinnerView, SupportCMSModel, SupportFinePrintView, SupportFlashView, SupportInbentaModel, SupportUtilsHelper;

SupportFlashView = require('../views/flash_view');

SupportFinePrintView = require('../views/order_related/fine_print_view');

SupportCMSModel = require('../models/CMS');

SupportInbentaModel = require('../models/Inbenta');

SharedSpinnerView = require('../../../shared/frontend/views/spinner_view');

SupportUtilsHelper = {
  delay: function(ms, func) {
    return setTimeout(func, ms);
  },
  flash: function(type, content, sticky) {
    var view;
    if (sticky == null) {
      sticky = false;
    }
    view = new SupportFlashView({
      type: type,
      content: content,
      sticky: sticky
    });
    view.render();
    return $('#flash_container').html(view.$el);
  },
  highlight: function($element, callback, className) {
    if (className == null) {
      className = 'flash_highlight';
    }
    $element.addClass(className);
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass(className);
      if (callback) {
        return callback();
      }
    });
  },
  highlightText: function($element, callback) {
    $element.addClass('flash_text');
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass('flash_text');
      if (callback) {
        return callback();
      }
    });
  },
  openLocation: function(url) {
    return window.open(url);
  },
  isFileUploadSupported: function() {
    return window.FileReader != null;
  },
  showLoading: function(div, height) {
    var hash, spinner;
    if (height == null) {
      height = "250px";
    }
    if ($(".g-spinner", div).length === 0) {
      div.empty();
      spinner = new SharedSpinnerView();
      hash = {
        container: div,
        id: "g-spinner",
        height: height
      };
      return spinner.show(hash);
    }
  },
  openLinksInNewTab: function(div_links) {
    return div_links.attr("target", "_blank");
  },
  replaceNewLineWithBreak: function(text) {
    return text != null ? text.replace(/\n|\\x0a/gi, '<br />') : void 0;
  },
  renderFinePrint: function() {
    var finePrintView;
    finePrintView = new SupportFinePrintView();
    return finePrintView.render();
  },
  textOverflowEllipsis: function(length) {
    return function() {
      return function(text, render) {
        var content, delimitedContent;
        content = render(text);
        content = content.trim();
        if (content.length > length) {
          delimitedContent = content.substring(0, length - 3) + '...';
          return '<span title="' + content + '">' + delimitedContent + '</span>';
        } else {
          return content;
        }
      };
    };
  },
  addToTrackingHub: function(c, sc) {
    var data;
    data = {
      category: c,
      subcategory: sc
    };
    return TrackingHub.add("support-app-user-dropdown-change", {
      data: data
    });
  },
  activateieHacks: function() {
    ieISODateStringHack();
    return ieStringTrimHack();
  },
  ieISODateStringHack: function() {
    if (!Date.prototype.toISOString) {
      if (!Date.prototype.toJSON) {
        Date.prototype.toJSON = function(key) {
          var f;
          f = function(n) {};
          if (n < 10) {
            "0" + n;
          } else {
            n;
          }
          return this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z";
        };
      }
      return Date.prototype.toISOString = Date.prototype.toJSON;
    }
  },
  ieStringTrimHack: function() {
    if (typeof String.prototype.trim !== 'function') {
      return String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }
  },
  isUserLogged: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return true;
    } else {
      return false;
    }
  },
  match: function(arg1, arg2) {
    var diff, split1, split2;
    split1 = arg1 != null ? arg1.split(";") : void 0;
    split2 = arg2 != null ? arg2.split(";") : void 0;
    diff = _.difference(split1, split2);
    return diff.length === 0;
  },
  addParameterToUrlConsideringTheHash: function(url, parameterName, parameterValue, atStart) {
    var cl, i, newQueryString, parameterParts, parameters, replaceDuplicates, sourceUrl, urlParts, urlhash;
    replaceDuplicates = true;
    if (url.indexOf("#") > 0) {
      cl = url.indexOf("#");
      urlhash = url.substring(url.indexOf("#"), url.length);
    } else {
      urlhash = "";
      cl = url.length;
    }
    sourceUrl = url.substring(0, cl);
    urlParts = sourceUrl.split("?");
    newQueryString = "";
    if (urlParts.length > 1) {
      parameters = urlParts[1].split("&");
      i = 0;
      while (i < parameters.length) {
        parameterParts = parameters[i].split("=");
        if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
          if (newQueryString === "") {
            newQueryString = "?";
          } else {
            newQueryString += "&";
          }
          newQueryString += parameterParts[0] + "=" + (parameterParts[1] ? parameterParts[1] : "");
        }
        i++;
      }
    }
    if (newQueryString === "") {
      newQueryString = "?";
    }
    if (atStart) {
      newQueryString = "?" + parameterName + "=" + parameterValue + (newQueryString.length > 1 ? "&" + newQueryString.substring(1) : "");
    } else {
      if (newQueryString !== "" && newQueryString !== "?") {
        newQueryString += "&";
      }
      newQueryString += parameterName + "=" + (parameterValue ? parameterValue : "");
    }
    return urlParts[0] + newQueryString + urlhash;
  },
  getURLParameter: function(name) {
    return decodeURI((RegExp(name + "=" + "(.+?)(&|$)").exec(location.search) || [null, null])[1]);
  },
  isCurrentOrderMarketRateDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_MARKET_RATE");
  },
  isCurrentOrderGetawaysTonightDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_TONIGHT");
  },
  isCurrentOrderGetawaysBookingDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_BOOKING");
  },
  isCurrentOrderGoodsDeal: function() {
    return this.isCurrentOrderGoodsShippingDeal() || this.isCurrentOrderGoodsVoucherDeal();
  },
  isCurrentOrderGoodsShippingDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_SHIPPING");
  },
  isCurrentOrderGoodsVoucherDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_VOUCHER");
  },
  isCurrentOrderLiveDeal: function() {
    return this.isCurrentOrderOfDealType("LIVE");
  },
  isCurrentOrderLocalDeal: function() {
    return this.isCurrentOrderOfDealType("LOCAL");
  },
  isCurrentOrderOfDealType: function(deal_type) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0) === deal_type;
  },
  isCurrentOrderEditable: function() {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.editable : void 0) === true;
  },
  isOrderPurchasedWithinHours: function(specifiedHours) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.hoursAfterPurchase : void 0) < specifiedHours;
  },
  isCurrentOrderGetawaysDeal: function() {
    return isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || isCurrentOrderGetawaysBookingDeal();
  },
  checkIfCategoryIsAboutEditingOrCancelling: function() {
    return checkIfCategoryIdMatches("editing_or_canceling_an_order");
  },
  checkIfCategoryIdMatches: function(categoryId) {
    var ref;
    return ((ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0) === categoryId;
  },
  getCurrentUserFullName: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return (($.trim(currentUser.firstName)) + " " + ($.trim(currentUser.lastName))).trim();
    }
  },
  setTrackingInformation: function(type, url) {
    TrackingHub.page.metadata.type = type;
    return OptimizeSuite.treatAsNewPage(url);
  },
  getMillisecondsOfUTCDateFromISOStringDate: function(ISOStringDate) {
    var base;
    base = 10;
    return Date.UTC(parseInt(ISOStringDate.substring(0, 4), base), parseInt(ISOStringDate.substring(5, 7), base) - 1, parseInt(ISOStringDate.substring(8, 10), base), parseInt(ISOStringDate.substring(11, 13), base), parseInt(ISOStringDate.substring(14, 16), base));
  },
  redirectToFaqHack: function() {
    var hash;
    hash = window.location.hash;
    if (hash.indexOf("#faqs:") > -1) {
      return window.location.assign("/faq" + hash);
    }
  },
  hideFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.hide();
      return floatingChatElement.children().hide();
    }
  },
  showFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.show();
      return floatingChatElement.children().show();
    }
  },
  getDealMerchantName: function() {
    var ref, ref1, reservationSource;
    if (isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || (isCurrentOrderGetawaysBookingDeal() && isIntl())) {
      reservationSource = this.getReservationSource(Groupon.Support.currentOrder);
      return reservationSource != null ? reservationSource.hotelName : void 0;
    } else {
      return (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0;
    }
  },
  isStaticLiveChat: function(mode) {
    return mode === 'static';
  },
  isBothLiveChats: function(mode) {
    return mode === 'both';
  },
  isFloatingLiveChat: function(mode) {
    return mode === 'floating';
  },
  getOrderInfoForBH: function(order) {
    var hash, ref;
    hash = {
      id: order != null ? order.id : void 0,
      country: window.country.name,
      dealId: order != null ? (ref = order.deal) != null ? ref.id : void 0 : void 0,
      channel: order != null ? order.DEAL_TYPE : void 0
    };
    if (window.showRedesign()) {
      hash.showActionButtonAsLinks = true;
    }
    return hash;
  },
  showRedesign: function() {
    var ref;
    return Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled() || window.evaluate((ref = window.experiments) != null ? ref.showVerticalPageFlow : void 0);
  },
  priorityViewsEnabled: function() {
    var ref, ref1;
    return ((ref = Groupon.Support.ContentModel) != null ? ref.isRefundEligible : void 0) || ((ref1 = Groupon.Support.ContentModel) != null ? ref1.escalateToMerchant : void 0);
  },
  liveChatVisible: function(liveChatDOMElem) {
    var clearImgurl;
    clearImgurl = /images.boldchat.com\/images\/clear/;
    return (liveChatDOMElem != null) && !(_.isEmpty(liveChatDOMElem.attr('src'))) && !clearImgurl.test(liveChatDOMElem.attr('src'));
  },
  setLiveChatDisplayCallBack: function(liveChatDOMElem, liveChatDisplayCallback) {
    if (((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) != null) && !window.liveChatCallBackSet) {
      window.liveChatCallBackSet = true;
      return liveChatDOMElem.on('load', function() {
        return liveChatDisplayCallback();
      });
    } else if ((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) == null) {
      return window.liveChatCallBackSet = false;
    }
  },
  liveChatLinkVisible: function() {
    var liveChatImageElem;
    liveChatImageElem = $("#live-chat-link-container div a div");
    return !_.isEmpty(liveChatImageElem.text());
  },
  getReservationSource: function(currentOrder) {
    var ref;
    return (currentOrder != null ? currentOrder.reservation : void 0) || (currentOrder != null ? (ref = currentOrder.travelBookingInfo) != null ? ref.reservation : void 0 : void 0);
  },
  findGrouponQuantity: function(groupons) {
    var quantity;
    quantity = 0;
    if (groupons != null) {
      _.each(groupons, function(groupon) {
        if (groupon.availability) {
          if (groupon.availability.toLowerCase() !== 'refunded') {
            return quantity++;
          }
        }
      });
    }
    return quantity;
  },
  shouldShowOptimizedChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0) && !window.priorityViewsEnabled();
  },
  shouldShowFlexibleChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showFlexibleContactChannels : void 0) && !window.priorityViewsEnabled();
  },
  hideFooterLinks: function() {
    return window.hideDOMElems($("#footer_dynamic_links"));
  },
  showFooterLinks: function() {
    return window.showDOMElems($("#footer_dynamic_links"));
  }
};

module.exports = SupportUtilsHelper;



},{"../../../shared/frontend/views/spinner_view":40,"../models/CMS":49,"../models/Inbenta":50,"../views/flash_view":64,"../views/order_related/fine_print_view":65}],49:[function(require,module,exports){
var SupportCMSModel, SupportDropDownCombinationsModel, SupportDropDownModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportCMSModel = (function() {
  function SupportCMSModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportCMSModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.CMS = {
      Category: null,
      SubCategory: null,
      SearchInputIssue: null,
      Content: null
    };
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    this.externalDealNotes = null;
    this.isRefundEligible = false;
    return this.escalateToMerchant = false;
  };

  SupportCMSModel.prototype.getContentObject = function() {
    return window.Groupon.Support.CMS;
  };

  SupportCMSModel.prototype.getCategory = function() {
    return Groupon.Support.CMS.Category;
  };

  SupportCMSModel.prototype.getSubCategory = function() {
    return Groupon.Support.CMS.SubCategory;
  };

  SupportCMSModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.CMS.SearchInputIssue;
  };

  SupportCMSModel.prototype.getContent = function() {
    return Groupon.Support.CMS.Content;
  };

  SupportCMSModel.prototype.getContentId = function() {
    var ref;
    return (ref = Groupon.Support.CMS.Content) != null ? ref.id : void 0;
  };

  SupportCMSModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.CMS.SubCategory = subCategory;
  };

  SupportCMSModel.prototype.setCategory = function(category) {
    return Groupon.Support.CMS.Category = category;
  };

  SupportCMSModel.prototype.setContent = function(content) {
    return Groupon.Support.CMS.Content = content;
  };

  SupportCMSModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.CMS.SearchInputIssue = searchInputIssue;
  };

  SupportCMSModel.prototype.onUnloadStepOne = function() {};

  SupportCMSModel.prototype.onInitStepTwo = function() {};

  SupportCMSModel.prototype.onInitStepThree = function() {};

  SupportCMSModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.CMS, params);
  };

  return SupportCMSModel;

})();

module.exports = SupportCMSModel;



},{"./dropdown_combinations":53,"./dropdowns":54}],50:[function(require,module,exports){
var SupportDropDownCombinationsModel, SupportDropDownModel, SupportInbentaModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportInbentaModel = (function() {
  function SupportInbentaModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportInbentaModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.Inbenta = {};
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    return this.externalDealNotes = null;
  };

  SupportInbentaModel.prototype.getCategory = function() {
    return Groupon.Support.Inbenta.Category;
  };

  SupportInbentaModel.prototype.getSubCategory = function() {
    return Groupon.Support.Inbenta.SubCategory;
  };

  SupportInbentaModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.Inbenta.searchInputIssue;
  };

  SupportInbentaModel.prototype.getContentId = function() {
    return Groupon.Support.Inbenta.ContentId;
  };

  SupportInbentaModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.Inbenta.SubCategory = subCategory;
  };

  SupportInbentaModel.prototype.setCategory = function(category) {
    return Groupon.Support.Inbenta.Category = category;
  };

  SupportInbentaModel.prototype.setContentId = function(contentId) {
    return Groupon.Support.Inbenta.ContentId = contentId;
  };

  SupportInbentaModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.Inbenta.searchInputIssue = searchInputIssue;
  };

  SupportInbentaModel.prototype.onUnloadStepOne = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('inbenta-help-wizard-step1-completed');
    }
  };

  SupportInbentaModel.prototype.onInitStepTwo = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step2');
    }
  };

  SupportInbentaModel.prototype.onInitStepThree = function() {
    if (Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()) {
      return $.event.trigger('initiate-inbenta-help-wizard-step3');
    } else if (window.shouldShowOptimizedChannel() || window.shouldShowFlexibleChannel()) {
      return $.event.trigger('inbenta-hash-change', ['#contact-us', '#contact-us']);
    }
  };

  SupportInbentaModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.Inbenta, params);
  };

  return SupportInbentaModel;

})();

module.exports = SupportInbentaModel;



},{"./dropdown_combinations":53,"./dropdowns":54}],51:[function(require,module,exports){
var Backbone, SupportBaseTicketModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportBaseTicketModel = (function(superClass) {
  extend(SupportBaseTicketModel, superClass);

  function SupportBaseTicketModel() {
    return SupportBaseTicketModel.__super__.constructor.apply(this, arguments);
  }

  SupportBaseTicketModel.prototype.initialize = function() {
    return this.setReasonText();
  };

  SupportBaseTicketModel.prototype.setReasonText = function() {
    var SubCategory, category;
    category = Groupon.Support.ContentModel.getCategory();
    SubCategory = Groupon.Support.ContentModel.getSubCategory();
    if ((category != null) && (SubCategory != null)) {
      this.reasonId = SubCategory.id;
      this.reasonText = SubCategory.text;
      this.reasonGroup = SubCategory.group;
      this.parentCategoryId = category.id;
      this.parentCategoryText = category.text;
      return this.isDummyCategory = false;
    } else {
      this.reasonId = "direct_email_ticket_subcategory";
      this.reasonText = I18n.translate('js.modules.support.default_reason');
      this.parentCategoryId = "direct_email_ticket";
      this.parentCategoryText = I18n.translate('js.modules.support.default_parent_category');
      return this.isDummyCategory = true;
    }
  };

  SupportBaseTicketModel.prototype.populateOrderListInfo = function(emailBasicData) {
    if ((window.currentUser != null) && Groupon.Support.currentOrdersFilter.isOrdersInfoValid()) {
      return emailBasicData.orderListInfo = {
        hasOrders: Groupon.Support.OrdersCollection.hasOrders(),
        hasSingleOrder: Groupon.Support.OrdersCollection.getNumberOfOrdersFetched() === 1
      };
    }
  };

  SupportBaseTicketModel.prototype.getBasicTicketData = function() {
    var currentUserFullName, emailBasicData;
    currentUserFullName = window.getCurrentUserFullName();
    emailBasicData = {
      support_id: "",
      reason: this.reasonId,
      reason_text: this.reasonText,
      reason_group: this.reasonGroup,
      parent_category: this.parentCategoryId,
      parent_category_text: this.parentCategoryText,
      currentOrder: Groupon.Support.currentOrder,
      description: "",
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible,
      user_name: !_.isEmpty(currentUserFullName) ? currentUserFullName : void 0,
      user_email: typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0
    };
    this.populateOrderListInfo(emailBasicData);
    return emailBasicData;
  };

  return SupportBaseTicketModel;

})(Backbone.Model);

module.exports = SupportBaseTicketModel;



},{"backbone":68}],52:[function(require,module,exports){
var SupportBaseTicketModel, SupportCallBackPhoneNumberModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBaseTicketModel = require('./base_ticket_model');

SupportUtilsHelper = require('../helpers/utils');

SupportCallBackPhoneNumberModel = (function(superClass) {
  extend(SupportCallBackPhoneNumberModel, superClass);

  function SupportCallBackPhoneNumberModel() {
    return SupportCallBackPhoneNumberModel.__super__.constructor.apply(this, arguments);
  }

  SupportCallBackPhoneNumberModel.prototype.initialize = function() {
    var ref;
    SupportBaseTicketModel.prototype.initialize.apply(this, arguments);
    this.getDefaultPhoneForm();
    this.userName = SupportUtilsHelper.getCurrentUserFullName() || null;
    this.userEmail = ((ref = window.currentUser) != null ? ref.email : void 0) || null;
    return this.phoneNumber = null;
  };

  SupportCallBackPhoneNumberModel.prototype.toJSON = function() {
    return {
      isLoggedIn: window.currentUser != null
    };
  };

  SupportCallBackPhoneNumberModel.prototype.getDefaultPhoneForm = function() {
    return this.phoneForm = {
      method_of_contact: "callMeBackOption",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.call_me_back_user_label'),
          required: this.getRequired(),
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          },
          value: this.userName
        }, {
          type: "email_address",
          label: I18n.translate('js.modules.support.call_me_back_email_label'),
          required: this.getRequired(),
          value: this.userEmail
        }, {
          type: "phone_number",
          label: I18n.translate('js.modules.support.call_me_back_your_number'),
          required: "true"
        }
      ]
    };
  };

  SupportCallBackPhoneNumberModel.prototype.getRequired = function() {
    if (window.currentUser != null) {
      return false;
    } else {
      return true;
    }
  };

  return SupportCallBackPhoneNumberModel;

})(SupportBaseTicketModel);

module.exports = SupportCallBackPhoneNumberModel;



},{"../helpers/utils":48,"./base_ticket_model":51}],53:[function(require,module,exports){
var Backbone, SupportDropDownCombinationsModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportDropDownCombinationsModel = (function(superClass) {
  extend(SupportDropDownCombinationsModel, superClass);

  function SupportDropDownCombinationsModel() {
    return SupportDropDownCombinationsModel.__super__.constructor.apply(this, arguments);
  }

  SupportDropDownCombinationsModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=dropdown_combinations_for_flex_step_three&type=dropdown_combinations_for_flex_step_three";
  };

  return SupportDropDownCombinationsModel;

})(Backbone.Model);

module.exports = SupportDropDownCombinationsModel;



},{"backbone":68}],54:[function(require,module,exports){
var Backbone, SupportDropDownModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportDropDownModel = (function(superClass) {
  extend(SupportDropDownModel, superClass);

  function SupportDropDownModel() {
    return SupportDropDownModel.__super__.constructor.apply(this, arguments);
  }

  SupportDropDownModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=dropdowns&type=dropdowns&should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return SupportDropDownModel;

})(Backbone.Model);

module.exports = SupportDropDownModel;



},{"backbone":68}],55:[function(require,module,exports){
var Backbone, SupportAPIHelper, SupportHoldTimeModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../helpers/API');

Backbone = require('backbone');

SupportHoldTimeModel = (function(superClass) {
  extend(SupportHoldTimeModel, superClass);

  function SupportHoldTimeModel() {
    return SupportHoldTimeModel.__super__.constructor.apply(this, arguments);
  }

  SupportHoldTimeModel.prototype.initialize = function() {
    return this.mainView = this.attributes.mainView;
  };

  SupportHoldTimeModel.prototype.getCallMeBackFlag = function() {
    var url;
    url = this.getHoldTimeUrlToFetchCallMeBackFlag();
    return SupportAPIHelper.get(url, null, this.mainView.callMeBackFlagCb, this.mainView.callMeBackFlagCb, false);
  };

  SupportHoldTimeModel.prototype.postToHoldTime = function(data) {
    var url;
    url = this.getHoldTimeUrlToPostInHoldTime();
    return SupportAPIHelper.call(url, 'POST', data, this.mainView.renderHoldTimePostSuccess, this.mainView.renderHoldTimePostError, false);
  };

  SupportHoldTimeModel.prototype.getHoldTimeUrlToFetchCallMeBackFlag = function() {
    var channel, url;
    channel = this.getHoldTimeQueueChannel();
    return url = window.SUPPORTBASEURL + "/hold_time/fetch?channel=" + channel;
  };

  SupportHoldTimeModel.prototype.getHoldTimeUrlToPostInHoldTime = function() {
    var channel, url;
    channel = this.getHoldTimeQueueChannel();
    return url = window.SUPPORTBASEURL + "/hold_time/create?channel=" + channel;
  };

  SupportHoldTimeModel.prototype.getHoldTimeQueueChannel = function() {
    var channel, getawaysRegex, goodsRegex, holdTimeQueueChannel, ref;
    channel = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    goodsRegex = /goods/;
    getawaysRegex = /getaways/;
    holdTimeQueueChannel = 'local';
    if (channel != null) {
      holdTimeQueueChannel = goodsRegex.test(channel.toLowerCase()) ? 'goods' : getawaysRegex.test(channel.toLowerCase()) ? 'travel' : 'local';
    }
    return holdTimeQueueChannel;
  };

  return SupportHoldTimeModel;

})(Backbone.Model);

module.exports = SupportHoldTimeModel;



},{"../helpers/API":47,"backbone":68}],56:[function(require,module,exports){
var SupportFinePrintPresenterPresentation, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportFinePrintPresenterPresentation = (function() {
  function SupportFinePrintPresenterPresentation() {}

  SupportFinePrintPresenterPresentation.prototype.present = function(order) {
    var text;
    return text = (function() {
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_MARKET_RATE':
          return this.marketRateFinePrintConstructor(order);
        default:
          return this.v1FinePrintConstructor(order);
      }
    }).call(this);
  };

  SupportFinePrintPresenterPresentation.prototype.v1FinePrintConstructor = function(order) {
    var ref;
    if (order == null) {
      return "";
    }
    return replaceNewLineWithBreak((ref = order.deal) != null ? ref.finePrint : void 0);
  };

  SupportFinePrintPresenterPresentation.prototype.marketRateFinePrintConstructor = function(order) {
    var cancellationPolicies, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (reservationSource == null) {
      return "";
    }
    cancellationPolicies = _.reduce(reservationSource.cancellationPolicies, (function(memo, policy) {
      return "" + memo + policy.descriptionHtml + " <br />";
    }), "");
    return reservationSource.crsPolicyHtml + " <br />Cancellation Policies <br /><br /> " + cancellationPolicies;
  };

  return SupportFinePrintPresenterPresentation;

})();

module.exports = SupportFinePrintPresenterPresentation;



},{"../helpers/utils":48}],57:[function(require,module,exports){
var SupportCommonBaseInputsView, SupportCommonBaseView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportCommonBaseView = require('./common_base_view');

SupportCommonBaseInputsView = (function(superClass) {
  extend(SupportCommonBaseInputsView, superClass);

  function SupportCommonBaseInputsView() {
    this.validateEmailForm = bind(this.validateEmailForm, this);
    return SupportCommonBaseInputsView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseInputsView.prototype.initialize = function(options) {
    this.options = options || {};
    return this.inputViews = [];
  };

  SupportCommonBaseInputsView.prototype.renderInputViews = function(objects, componentListElement) {
    var i, len, obj, results, view;
    results = [];
    for (i = 0, len = objects.length; i < len; i++) {
      obj = objects[i];
      view = this.getViewByObjectType(obj);
      if (!view) {
        continue;
      }
      this.inputViews.push(view);
      view.render();
      results.push(this.$el.find(componentListElement).append(view.el));
    }
    return results;
  };

  SupportCommonBaseInputsView.prototype.isInputValid = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (!view.isInputValid()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.collectInputFromComponents = function(data) {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      view.populateInput(data);
    }
    return data;
  };

  SupportCommonBaseInputsView.prototype.isRequiredInputGiven = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (view.isInputCompulsory && !view.isInputGiven()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.validateEmailForm = function() {
    if (this.isRequiredInputGiven()) {
      return this.enableSubmit();
    } else {
      return this.disableSubmit();
    }
  };

  SupportCommonBaseInputsView.prototype.onSubmitClick = function() {
    var data;
    this.disableSubmit();
    if (this.isInputValid()) {
      data = this.getFormData();
      return this.submitForm(data);
    } else {
      return this.validateEmailForm();
    }
  };

  SupportCommonBaseInputsView.prototype.getFormData = function() {
    var data;
    data = this.model.getBasicTicketData();
    this.collectInputFromComponents(data);
    return data;
  };

  SupportCommonBaseInputsView.prototype.enableSubmit = function() {
    $('.submit-button', this.$el).removeClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', false);
  };

  SupportCommonBaseInputsView.prototype.disableSubmit = function() {
    $('.submit-button', this.$el).addClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', true);
  };

  SupportCommonBaseInputsView.prototype.getViewByObjectType = function() {};

  return SupportCommonBaseInputsView;

})(SupportCommonBaseView);

module.exports = SupportCommonBaseInputsView;



},{"./common_base_view":58}],58:[function(require,module,exports){
var Backbone, SupportCommonBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportCommonBaseView = (function(superClass) {
  extend(SupportCommonBaseView, superClass);

  function SupportCommonBaseView() {
    return SupportCommonBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCommonBaseView.prototype.toHash = function() {
    var ref;
    return ((ref = this.model) != null ? ref.toJSON() : void 0) || {};
  };

  return SupportCommonBaseView;

})(Backbone.View);

module.exports = SupportCommonBaseView;



},{"backbone":68}],59:[function(require,module,exports){
var EmailFormPhoneNumberInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormPhoneNumberInputView = (function(superClass) {
  extend(EmailFormPhoneNumberInputView, superClass);

  function EmailFormPhoneNumberInputView() {
    return EmailFormPhoneNumberInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormPhoneNumberInputView.prototype.tagName = 'li';

  EmailFormPhoneNumberInputView.prototype.events = {
    'keyup .phone_number_input': 'checkPhoneNumber'
  };

  EmailFormPhoneNumberInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".phone_number_input";
    this.errorElementID = '.validatePhoneNumberInput';
    return this.template = {
      phone_input_template: true
    };
  };

  EmailFormPhoneNumberInputView.prototype.isInputValid = function(hideErrorMsg) {
    var isValidPhoneNumber, phoneNumber;
    phoneNumber = this.getInputHtmlElement().val();
    isValidPhoneNumber = true;
    if (phoneNumber !== "") {
      isValidPhoneNumber = window.isUS() ? GrouponValidate.phone(phoneNumber) : GrouponValidate.phoneInternational(phoneNumber);
      if (isValidPhoneNumber) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.call-back-phone-number-input').addClass('call-back-inputs-error-border');
      }
    }
    return isValidPhoneNumber;
  };

  EmailFormPhoneNumberInputView.prototype.checkPhoneNumber = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormPhoneNumberInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_given_phone = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.apply(this, arguments);
    }
  };

  return EmailFormPhoneNumberInputView;

})(EmailFormTextInputView);

module.exports = EmailFormPhoneNumberInputView;



},{"../../../../../groupon/frontend/validate":30,"./text_input_view":60}],60:[function(require,module,exports){
var Backbone, EmailFormTextInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormTextInputView = (function(superClass) {
  extend(EmailFormTextInputView, superClass);

  function EmailFormTextInputView() {
    return EmailFormTextInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextInputView.prototype.initialize = function(options) {
    var ref, ref1;
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.value = this.model.value;
    this.base_template = this.options.template;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    if (((ref = this.options.model.additional_attributes) != null ? (ref1 = ref.maximum_number_of_characters_or_digits) != null ? ref1.length : void 0 : void 0) > 0) {
      return this.maxLength = parseInt(this.options.model.additional_attributes.maximum_number_of_characters_or_digits);
    }
  };

  EmailFormTextInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.base_template, this.toHash()));
  };

  EmailFormTextInputView.prototype.toHash = function() {
    var hash;
    hash = {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      counter: this.model.counter,
      isLoggedIn: window.isLoggedIn,
      value: this.value
    };
    return _.extend(this.template, hash);
  };

  EmailFormTextInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormTextInputView.prototype.isInputGiven = function() {
    var ref, ref1, ref2;
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormTextInputView.prototype.readInput = function() {
    var ref, ref1;
    return (ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
  };

  EmailFormTextInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormTextInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormTextInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  return EmailFormTextInputView;

})(Backbone.View);

module.exports = EmailFormTextInputView;



},{"backbone":68}],61:[function(require,module,exports){
var EmailFormTextInputView, EmailFormUserNameInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require("../../common/views/text_input_view");

EmailFormUserNameInputView = (function(superClass) {
  extend(EmailFormUserNameInputView, superClass);

  function EmailFormUserNameInputView() {
    return EmailFormUserNameInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUserNameInputView.prototype.tagName = 'li';

  EmailFormUserNameInputView.prototype.events = {
    'keyup .user_name_input': 'validateUserName'
  };

  EmailFormUserNameInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".user_name_input";
    return this.template = {
      user_name_input_template: true
    };
  };

  EmailFormUserNameInputView.prototype.isInputValid = function() {
    var ref, ref1, ref2;
    if (!this.isInputElementPresent()) {
      return true;
    }
    return ((ref = this.getInputHtmlElement()) != null ? (ref1 = ref.val()) != null ? (ref2 = ref1.trim()) != null ? ref2.length : void 0 : void 0 : void 0) > 0;
  };

  EmailFormUserNameInputView.prototype.isInputElementPresent = function() {
    var ref;
    return ((ref = this.getInputHtmlElement()) != null ? ref.length : void 0) > 0;
  };

  EmailFormUserNameInputView.prototype.validateUserName = function() {
    this.isInputValid();
    return this.validateEmailForm();
  };

  EmailFormUserNameInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_name = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.call(this, data);
    }
  };

  return EmailFormUserNameInputView;

})(EmailFormTextInputView);

module.exports = EmailFormUserNameInputView;



},{"../../common/views/text_input_view":60}],62:[function(require,module,exports){
var CallBackOptionSuccessView, CommonBaseView, SupportThanksForContactingTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportThanksForContactingTemplate = require('../../../../thanks_for_contacting.html.mustache');

CommonBaseView = require("../../common/views/common_base_view");

CallBackOptionSuccessView = (function(superClass) {
  extend(CallBackOptionSuccessView, superClass);

  function CallBackOptionSuccessView() {
    return CallBackOptionSuccessView.__super__.constructor.apply(this, arguments);
  }

  CallBackOptionSuccessView.prototype.template = SupportThanksForContactingTemplate;

  CallBackOptionSuccessView.prototype.render = function(params) {
    if (params == null) {
      params = {};
    }
    return this.$el.append(toHtml(this.template, this.toHash(params.waitTime), this.I18nScope));
  };

  CallBackOptionSuccessView.prototype.toHash = function(waitTime) {
    if (waitTime == null) {
      waitTime = 30;
    }
    return {
      phoneCallReceivemsg: I18n.translate('js.modules.support.call_me_back_phone_call_receive_msg', {
        display_wait_time: this.getWaitTimeDisplayUnits(waitTime)
      }),
      isCallMeBackFlow: true,
      showCallBackThankYouMsg: true
    };
  };

  CallBackOptionSuccessView.prototype.getWaitTimeDisplayUnits = function(waitTime) {
    var displayWaitTime;
    if (waitTime <= 20) {
      displayWaitTime = 'half an hour';
    } else if (waitTime <= 45) {
      displayWaitTime = 'one hour';
    } else if (waitTime <= 105) {
      displayWaitTime = '2 hours';
    } else {
      displayWaitTime = 'shortly';
    }
    return displayWaitTime;
  };

  return CallBackOptionSuccessView;

})(CommonBaseView);

module.exports = CallBackOptionSuccessView;



},{"../../../../thanks_for_contacting.html.mustache":67,"../../common/views/common_base_view":58}],63:[function(require,module,exports){
var CallBackOptionSuccessView, CallBackPhoneNumberModel, CommonBaseInputsView, EmailFormEmailInputView, EmailFormPhoneNumberInputView, EmailFormUserNameInputView, HoldTimeModel, PhoneNumberCallBackView, SharedSpinnerView, SupportCallMeBackPhoneNumberObjectsTemplate, SupportPhoneNumberWithCallBackTemplate, SupportUtils,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportUtils = require("../../../helpers/utils");

CommonBaseInputsView = require("../../common/views/common_base_inputs_view");

CallBackPhoneNumberModel = require("../../../models/call_back_phone_number_model");

HoldTimeModel = require("../../../models/hold_time_model");

SharedSpinnerView = require("../../../../../shared/frontend/views/spinner_view");

CallBackOptionSuccessView = require("./call_me_back_success_view");

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormEmailInputView = require("../../common/views/phone_number_input");

EmailFormUserNameInputView = require("../INTL/user_name_input_view");

SupportPhoneNumberWithCallBackTemplate = require('../../../../phone_number_with_call_back.html.mustache');

SupportCallMeBackPhoneNumberObjectsTemplate = require('../../../../call_me_back_phone_number_objects.html.mustache');

PhoneNumberCallBackView = (function(superClass) {
  extend(PhoneNumberCallBackView, superClass);

  function PhoneNumberCallBackView() {
    this.renderHoldTimePostError = bind(this.renderHoldTimePostError, this);
    this.renderHoldTimePostSuccess = bind(this.renderHoldTimePostSuccess, this);
    this.callMeBackFlagCb = bind(this.callMeBackFlagCb, this);
    return PhoneNumberCallBackView.__super__.constructor.apply(this, arguments);
  }

  PhoneNumberCallBackView.prototype.initialize = function() {
    CommonBaseInputsView.prototype.initialize.apply(this, arguments);
    this.template = SupportPhoneNumberWithCallBackTemplate;
    this.mainView = this.options.mainView;
    this.model = new CallBackPhoneNumberModel();
    this.holdTimeModel = new HoldTimeModel({
      mainView: this
    });
    this.popupContainer = $('#popup');
    this.spinnerView = new SharedSpinnerView();
    this.inputObjects = this.model.getDefaultPhoneForm().objects;
    return this.callBackSuccessView = new CallBackOptionSuccessView();
  };

  PhoneNumberCallBackView.prototype.render = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popupContainer.html(this.el);
    this.showLoadingSpinner();
    return this.holdTimeModel.getCallMeBackFlag();
  };

  PhoneNumberCallBackView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      template: SupportCallMeBackPhoneNumberObjectsTemplate
    };
    switch (obj.type) {
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'email_address':
        return new EmailFormEmailInputView(options);
      case 'user_name':
        return new EmailFormUserNameInputView(options);
    }
  };

  PhoneNumberCallBackView.prototype.callMeBackFlagCb = function(response) {
    this.hideLoadingSpinner();
    if (evaluate(response != null ? response.showCallMeOption : void 0)) {
      window.showDOMElems([$('.call-me-back-option'), $('#call-back-content-container')]);
      return this.renderInputViews(this.inputObjects, "#call-me-back-inputs");
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  PhoneNumberCallBackView.prototype.renderNormalPhoneNumberView = function() {
    this.closeModal();
    return this.mainView.renderNormalPhoneNumberView();
  };

  PhoneNumberCallBackView.prototype.onSubmitClick = function() {
    return CommonBaseInputsView.prototype.onSubmitClick.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.submitForm = function(data) {
    window.hideDOMElems($('.call-me-back-option'));
    this.showLoadingSpinner();
    return this.holdTimeModel.postToHoldTime(data);
  };

  PhoneNumberCallBackView.prototype.enableSubmit = function() {
    $('.call-back-submit-button', this.$el).removeClass('opacity-half');
    return CommonBaseInputsView.prototype.enableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.disableSubmit = function() {
    $('.call-back-submit-button', this.$el).addClass('opacity-half');
    return CommonBaseInputsView.prototype.disableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostSuccess = function(response) {
    this.holdTimeModel.set({
      'estWaitTime': response.est_wait_time
    });
    this.hideLoadingSpinner();
    this.closeModal();
    window.hideDOMElems([$('.help-wizard-content form'), $('.step-three #results'), $('.step-actions'), $('.contact-channels-v2-header')]);
    this.removeCallBackStepThree();
    propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.callBackSuccessView.render({
          waitTime: _this.holdTimeModel.get("estWaitTime")
        });
        return $('#help-wizard').append(_this.callBackSuccessView.el);
      };
    })(this));
    return window.hideFooterLinks();
  };

  PhoneNumberCallBackView.prototype.removeCallBackStepThree = function() {
    var ref;
    return (ref = $('#help-wizard .horizontal')) != null ? ref.remove() : void 0;
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostError = function() {
    this.hideLoadingSpinner();
    window.hideDOMElems($('.call-me-back-option'));
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.$el.find('#call-back-spinner').empty();
        return window.showDOMElems($('.no-call-me-back-option'));
      };
    })(this));
  };

  PhoneNumberCallBackView.prototype.hideLoadingSpinner = function() {
    this.$el.find('#call-back-spinner').empty();
    return window.hideDOMElems(this.$el.find('#call-back-spinner'));
  };

  PhoneNumberCallBackView.prototype.showLoadingSpinner = function() {
    window.showDOMElems($('#call-back-spinner'));
    return SupportUtils.showLoading($('#call-back-spinner'), '150px');
  };

  PhoneNumberCallBackView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  PhoneNumberCallBackView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal",
    'click .submit-button': 'onSubmitClick'
  };

  return PhoneNumberCallBackView;

})(CommonBaseInputsView);

module.exports = PhoneNumberCallBackView;



},{"../../../../../shared/frontend/views/spinner_view":40,"../../../../call_me_back_phone_number_objects.html.mustache":44,"../../../../phone_number_with_call_back.html.mustache":66,"../../../helpers/utils":48,"../../../models/call_back_phone_number_model":52,"../../../models/hold_time_model":55,"../../common/views/common_base_inputs_view":57,"../../common/views/phone_number_input":59,"../INTL/user_name_input_view":61,"./call_me_back_success_view":62}],64:[function(require,module,exports){
var Backbone, SupportFlashTemplate, SupportFlashView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlashTemplate = require('../../flash.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportFlashView = (function(superClass) {
  extend(SupportFlashView, superClass);

  function SupportFlashView() {
    return SupportFlashView.__super__.constructor.apply(this, arguments);
  }

  SupportFlashView.prototype.className = 'flash';

  SupportFlashView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportFlashTemplate;
    this.type = this.options.type;
    if (this.type == null) {
      this.type = 'info';
    }
    this.content = this.options.content;
    if (!this.options.sticky) {
      return delay(20000, (function(_this) {
        return function() {
          return _this.remove();
        };
      })(this));
    }
  };

  SupportFlashView.prototype.render = function() {
    this.$el.addClass(this.type);
    return this.$el.html(toHtml(this.template, this.toHash(), this.template));
  };

  SupportFlashView.prototype.events = function() {
    return {
      'click .close': 'remove'
    };
  };

  SupportFlashView.prototype.toHash = function() {
    return {
      content: this.content
    };
  };

  SupportFlashView.prototype.close = function() {};

  return SupportFlashView;

})(Backbone.View);

module.exports = SupportFlashView;



},{"../../flash.html.mustache":46,"backbone":68}],65:[function(require,module,exports){
var Backbone, SupportFinePrintPresenterPresentation, SupportFinePrintTemplate, SupportFinePrintView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFinePrintPresenterPresentation = require('../../presenters/fine_print_presenter');

Backbone = require('backbone');

Backbone.$ = $;

SupportFinePrintTemplate = require('../../../fine_print.html.mustache');

SupportFinePrintView = (function(superClass) {
  extend(SupportFinePrintView, superClass);

  function SupportFinePrintView() {
    return SupportFinePrintView.__super__.constructor.apply(this, arguments);
  }

  SupportFinePrintView.prototype.id = 'popupContent';

  SupportFinePrintView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportFinePrintTemplate;
  };

  SupportFinePrintView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popup.html(this.el);
    return openLinksInNewTab($('#popupContent a'));
  };

  SupportFinePrintView.prototype.toHash = function() {
    var ref;
    return {
      fine_print: Groupon.Support.currentOrder.finePrintText || ((ref = Groupon.Support.currentOrder.deal) != null ? ref.finePrintText : void 0)
    };
  };

  SupportFinePrintView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportFinePrintView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportFinePrintView;

})(Backbone.View);

module.exports = SupportFinePrintView;



},{"../../../fine_print.html.mustache":45,"../../presenters/fine_print_presenter":56,"backbone":68}],66:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div  class=\"modal show-modal\">");t.b("\n" + i);t.b("  <div class=\"modal-body phone-number call-back-phone-number\">");t.b("\n" + i);t.b("    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("    <h3 class=\"modal-title\">");t.b("\n" + i);t.b("      ");if(t.s(t.f("translate",c,p,1),c,p,0,232,266,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.talk_to_groupon");});c.pop();}t.b("\n" + i);t.b("    </h3>");t.b("\n" + i);t.b("    <div id='call-back-container'>");t.b("\n" + i);t.b("      <div id='call-back-spinner'></div>");t.b("\n" + i);t.b("      <div id='call-back-content-container' class='hide'>");t.b("\n" + i);t.b("        <div class='no-call-me-back-option hide'>");t.b("\n" + i);t.b("           <div id=\"call-me-back-error\">");t.b("\n" + i);t.b("            <span class='call-me-error-msg'>");if(t.s(t.f("translate",c,p,1),c,p,0,574,615,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_me_back_error_msg");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("            <span class='call-me-instead'>");if(t.s(t.f("translate",c,p,1),c,p,0,693,727,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_us_instead");});c.pop();}t.b(".</span>");t.b("\n" + i);t.b("            <span class='icon-alert call-back-alert-below'> </span>");t.b("\n" + i);t.b("          </div>");t.b("\n" + i);t.b("          <div class=\"call-groupon\">");if(t.s(t.f("translate",c,p,1),c,p,0,885,926,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_call_groupon");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("          <div class=\"call-back-variant-text\">");if(t.s(t.f("translate",c,p,1),c,p,0,1007,1048,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_variant_text");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("          <div class=\"call-groupon-general-msg\">");if(t.s(t.f("translate",c,p,1),c,p,0,1131,1174,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_groupon_general_msg");});c.pop();}t.b("</div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("        <div class='call-me-back-option hide'>");t.b("\n" + i);t.b("          <div class='call-me-back'>");if(t.s(t.f("translate",c,p,1),c,p,0,1307,1333,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_me");});c.pop();}t.b("</div>");t.b("\n" + i);if(!t.s(t.f("isLoggedIn",c,p,1),c,p,1,0,0,"")){t.b("            <div class='call-me-back-provide-info-msg'>");if(t.s(t.f("translate",c,p,1),c,p,0,1449,1494,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_provide_info_msg");});c.pop();}t.b("</div>");t.b("\n" + i);};if(t.s(t.f("isLoggedIn",c,p,1),c,p,0,1566,1713,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <div class='call-me-back-provide-info-msg'>");if(t.s(t.f("translate",c,p,1),c,p,0,1636,1682,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_back_provide_phone_msg");});c.pop();}t.b("</div>");t.b("\n" + i);});c.pop();}t.b("          <div id=\"call-me-back-inputs\" class=\"unstyled\"> </div>");t.b("\n" + i);t.b("          <input class=\"submit-button btn disabled call-back-submit-button opacity-half\" disabled=\"disabled\" data-bhw=\"create-ticket__");t.b(t.v(t.f("tagline",c,p,0)));t.b("\" type=\"button\" value=\"");if(t.s(t.f("translate",c,p,1),c,p,0,1976,2011,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.call_me_btn_text");});c.pop();}t.b("\">");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("      </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div  class=\"modal show-modal\">\n  <div class=\"modal-body phone-number call-back-phone-number\">\n    <a href=\"javascript:;\" data-modal-id=\"popupContent\" class=\"close-modal icon-x\"></a>\n    <h3 class=\"modal-title\">\n      {{#translate}}js.modules.support.talk_to_groupon{{/translate}}\n    </h3>\n    <div id='call-back-container'>\n      <div id='call-back-spinner'></div>\n      <div id='call-back-content-container' class='hide'>\n        <div class='no-call-me-back-option hide'>\n           <div id=\"call-me-back-error\">\n            <span class='call-me-error-msg'>{{#translate}}js.modules.support.call_me_back_error_msg{{/translate}}</span>\n            <span class='call-me-instead'>{{#translate}}js.modules.support.call_us_instead{{/translate}}.</span>\n            <span class='icon-alert call-back-alert-below'> </span>\n          </div>\n          <div class=\"call-groupon\">{{#translate}}js.modules.support.call_back_call_groupon{{/translate}}</div>\n          <div class=\"call-back-variant-text\">{{#translate}}js.modules.support.call_back_variant_text{{/translate}}</div>\n          <div class=\"call-groupon-general-msg\">{{#translate}}js.modules.support.call_groupon_general_msg{{/translate}}</div>\n        </div>\n        <div class='call-me-back-option hide'>\n          <div class='call-me-back'>{{#translate}}js.modules.support.call_me{{/translate}}</div>\n          {{^isLoggedIn}}\n            <div class='call-me-back-provide-info-msg'>{{#translate}}js.modules.support.call_back_provide_info_msg{{/translate}}</div>\n          {{/isLoggedIn}}\n          {{#isLoggedIn}}\n            <div class='call-me-back-provide-info-msg'>{{#translate}}js.modules.support.call_back_provide_phone_msg{{/translate}}</div>\n          {{/isLoggedIn}}\n          <div id=\"call-me-back-inputs\" class=\"unstyled\"> </div>\n          <input class=\"submit-button btn disabled call-back-submit-button opacity-half\" disabled=\"disabled\" data-bhw=\"create-ticket__{{tagline}}\" type=\"button\" value=\"{{#translate}}js.modules.support.call_me_btn_text{{/translate}}\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":71}],67:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"help-wizard-content\">");t.b("\n" + i);t.b("  <div class=\"message ticket-success-message\">");t.b("\n" + i);if(t.s(t.f("showDefaultThankYouMsg",c,p,1),c,p,0,112,240,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"icon-check-circle\"> </div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-contacting\"><span>");t.b(t.v(t.f("greeting_text",c,p,0)));t.b("</span></h5>  ");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showEmailThankYouMsg",c,p,1),c,p,0,298,433,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"email-success\"></div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-emailing\">");t.b("\n" + i);t.b("        <span>");t.b(t.v(t.f("greeting_text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </h5>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showChatThankYouMsg",c,p,1),c,p,0,490,632,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div class=\"chat-icon-container\"> </div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-chatting\">");t.b("\n" + i);t.b("        <span>");t.b(t.v(t.f("greeting_text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("      </h5>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showCallBackThankYouMsg",c,p,1),c,p,0,692,927,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"call-me-back-success\">");t.b("\n" + i);t.b("      <div class=\"icon-check-circle\"> </div>");t.b("\n" + i);t.b("      <h5 class=\"thanks-for-calling\">");t.b("\n" + i);t.b("        <span>");if(t.s(t.f("translate",c,p,1),c,p,0,843,876,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.thanks_call");});c.pop();}t.b("</span>  ");t.b("\n" + i);t.b("      </h5>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("  </div> ");t.b("\n" + i);t.b("    ");t.b("\n" + i);if(t.s(t.f("isDefaultflow",c,p,1),c,p,0,991,1690,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div>");t.b("\n" + i);if(!t.s(t.f("refund_request_submitted",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("escalate_to_merchant",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("defaultGetBackmsg",c,p,1),c,p,0,1104,1235,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"thanks-for-contacting align-center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1177,1206,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.getbackmsg");});c.pop();}t.b("</p>");t.b("\n" + i);});c.pop();}if(t.s(t.f("twoHoursGetBackMsg",c,p,1),c,p,0,1291,1430,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <p class=\"thanks-for-contacting align-center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1364,1401,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.twoHoursGetBackMsg");});c.pop();}t.b("</p>");t.b("\n" + i);});c.pop();}};t.b("\n" + i);if(t.s(t.f("escalate_to_merchant",c,p,1),c,p,0,1522,1615,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("          <p class=\"thanks-for-contacting align-center\">");t.b(t.v(t.f("merchant_to_contact",c,p,0)));t.b("</p>");t.b("\n" + i);});c.pop();}};t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isChatFlow",c,p,1),c,p,0,1727,1855,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div>");t.b("\n" + i);t.b("      <p class=\"align-center\">");if(t.s(t.f("translate",c,p,1),c,p,0,1782,1823,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.transcript_to_email");});c.pop();}t.b("</p>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showNeedHelpLink",c,p,1),c,p,0,1895,2059,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"align-center\">");t.b("\n" + i);t.b("      <a id=\"needHelpAgain\" href=\"javascript:;\"> ");if(t.s(t.f("translate",c,p,1),c,p,0,1990,2027,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.v2.need_help_again");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isCallMeBackFlow",c,p,1),c,p,0,2105,2366,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"align-center call-me-back-flow\">");t.b("\n" + i);t.b("      <span class='call-back-request-sent'>");if(t.s(t.f("translate",c,p,1),c,p,0,2212,2247,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.recieved_request");});c.pop();}t.b("</span>");t.b("\n" + i);t.b("      <span class='call-back-phone-call-receive-msg'>");t.b(t.v(t.f("phoneCallReceivemsg",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");t.b("\n");t.b("\n" + i);if(t.s(t.f("showFooter",c,p,1),c,p,0,2412,2935,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<div class=\"step-actions row hint\">");t.b("\n" + i);t.b("  <h3>");if(t.s(t.f("translate",c,p,1),c,p,0,2469,2491,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.dyk");});c.pop();}t.b("</h3>");t.b("\n" + i);t.b("  In");t.b("\n" + i);t.b("  <a  href=\"");if(t.s(t.f("translate",c,p,1),c,p,0,2542,2582,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.deal_preferences_link");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,2615,2643,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.myprofile");});c.pop();}t.b("</a>");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,2678,2704,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.setyour");});c.pop();}t.b("<a href=\"");if(t.s(t.f("translate",c,p,1),c,p,0,2741,2781,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.deal_preferences_link");});c.pop();}t.b("\">");t.b("\n" + i);t.b("  ");if(t.s(t.f("translate",c,p,1),c,p,0,2814,2841,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.dealpref");});c.pop();}t.b("</a>");if(t.s(t.f("translate",c,p,1),c,p,0,2873,2913,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("js.modules.support.find_deals_fit_better");});c.pop();}t.b("\n" + i);t.b("</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "<div class=\"help-wizard-content\">\n  <div class=\"message ticket-success-message\">\n    {{#showDefaultThankYouMsg}}\n      <div class=\"icon-check-circle\"> </div>\n      <h5 class=\"thanks-for-contacting\"><span>{{greeting_text}}</span></h5>  \n    {{/showDefaultThankYouMsg}}\n\n    {{#showEmailThankYouMsg}}\n      <div class=\"email-success\"></div>\n      <h5 class=\"thanks-for-emailing\">\n        <span>{{greeting_text}}</span>\n      </h5>\n    {{/showEmailThankYouMsg}}  \n\n    {{#showChatThankYouMsg}}\n      <div class=\"chat-icon-container\"> </div>\n      <h5 class=\"thanks-for-chatting\">\n        <span>{{greeting_text}}</span>\n      </h5>\n    {{/showChatThankYouMsg}}  \n\n    {{#showCallBackThankYouMsg}}\n    <div class=\"call-me-back-success\">\n      <div class=\"icon-check-circle\"> </div>\n      <h5 class=\"thanks-for-calling\">\n        <span>{{#translate}}js.modules.support.v2.thanks_call{{/translate}}</span>  \n      </h5>\n    </div>\n    {{/showCallBackThankYouMsg}}\n  </div> \n    \n  {{#isDefaultflow}}\n    <div>\n      {{^refund_request_submitted}}\n        {{^escalate_to_merchant}}\n          {{#defaultGetBackmsg}}\n            <p class=\"thanks-for-contacting align-center\">{{#translate}}js.modules.support.getbackmsg{{/translate}}</p>\n          {{/defaultGetBackmsg}}\n          {{#twoHoursGetBackMsg}}\n            <p class=\"thanks-for-contacting align-center\">{{#translate}}js.modules.support.twoHoursGetBackMsg{{/translate}}</p>\n          {{/twoHoursGetBackMsg}}\n        {{/escalate_to_merchant}}\n\n        {{#escalate_to_merchant}}\n          <p class=\"thanks-for-contacting align-center\">{{merchant_to_contact}}</p>\n        {{/escalate_to_merchant}}\n      {{/refund_request_submitted}}\n    </div>\n  {{/isDefaultflow}}\n\n  {{#isChatFlow}}\n    <div>\n      <p class=\"align-center\">{{#translate}}js.modules.support.v2.transcript_to_email{{/translate}}</p>\n    </div>\n  {{/isChatFlow}}\n\n  {{#showNeedHelpLink}}\n    <div class=\"align-center\">\n      <a id=\"needHelpAgain\" href=\"javascript:;\"> {{#translate}}js.modules.support.v2.need_help_again{{/translate}}</a>\n    </div>\n  {{/showNeedHelpLink}}\n\n  {{#isCallMeBackFlow}}\n    <div class=\"align-center call-me-back-flow\">\n      <span class='call-back-request-sent'>{{#translate}}js.modules.support.recieved_request{{/translate}}</span>\n      <span class='call-back-phone-call-receive-msg'>{{phoneCallReceivemsg}}</span>\n    </div>\n  {{/isCallMeBackFlow}}\n</div>\n\n\n{{#showFooter}}\n<div class=\"step-actions row hint\">\n  <h3>{{#translate}}js.modules.support.dyk{{/translate}}</h3>\n  In\n  <a  href=\"{{#translate}}js.modules.support.deal_preferences_link{{/translate}}\">\n  {{#translate}}js.modules.support.myprofile{{/translate}}</a>\n  {{#translate}}js.modules.support.setyour{{/translate}}<a href=\"{{#translate}}js.modules.support.deal_preferences_link{{/translate}}\">\n  {{#translate}}js.modules.support.dealpref{{/translate}}</a>{{#translate}}js.modules.support.find_deals_fit_better{{/translate}}\n</div>\n{{/showFooter}}", Hogan);
},{"hogan.js":71}],68:[function(require,module,exports){
(function (global){
//     Backbone.js 1.1.2

//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(root, factory) {

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
    factory(root, exports, _);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(this, function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.1.2';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = void 0;
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = models[i] = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model, options);
      }
      return singular ? models[0] : models;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : _.clone(models);
      var i, l, id, model, attrs, existing, sort;
      var at = options.at;
      var targetModel = this.model;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        attrs = models[i] || {};
        if (attrs instanceof Model) {
          id = model = attrs;
        } else {
          id = attrs[targetModel.prototype.idAttribute || 'id'];
        }

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(id)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge) {
            attrs = attrs === model ? model.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
        modelMap[model.id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || (order && order.length)) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (i = 0, l = toAdd.length; i < l; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (i = 0, l = orderedModels.length; i < l; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0, l = toAdd.length; i < l; i++) {
          (model = toAdd[i]).trigger('add', model, this, options);
        }
        if (sort || (order && order.length)) this.trigger('sort', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) return attrs;
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      if (model.id != null) this._byId[model.id] = model;
      if (!model.collection) model.collection = this;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
    'lastIndexOf', 'isEmpty', 'chain', 'sample'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    options || (options = {});
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && noXhrPatch) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  var noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        router.execute(callback, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = decodeURI(this.location.pathname + this.location.search);
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          this.fragment = this.getFragment(null, true);
          this.location.replace(this.root + '#' + this.fragment);
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot() && loc.hash) {
          this.fragment = this.getHash().replace(routeStripper, '');
          this.history.replaceState({}, document.title, this.root + this.fragment);
        }

      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      var url = this.root + (fragment = this.getFragment(fragment || ''));

      // Strip the hash for matching.
      fragment = fragment.replace(pathStripper, '');

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // Don't include a trailing slash on the root.
      if (fragment === '' && url !== '/') url = url.slice(0, -1);

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],69:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canMutationObserver = typeof window !== 'undefined'
    && window.MutationObserver;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    var queue = [];

    if (canMutationObserver) {
        var hiddenDiv = document.createElement("div");
        var observer = new MutationObserver(function () {
            var queueList = queue.slice();
            queue.length = 0;
            queueList.forEach(function (fn) {
                fn();
            });
        });

        observer.observe(hiddenDiv, { attributes: true });

        return function nextTick(fn) {
            if (!queue.length) {
                hiddenDiv.setAttribute('yes', 'no');
            }
            queue.push(fn);
        };
    }

    if (canPost) {
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

},{}],70:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],71:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":70,"./template":72}],72:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],73:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */



var Hogan = {};

(function (Hogan, useArrayBuffer) {
  Hogan.Template = function (renderFunc, text, compiler, options) {
    this.r = renderFunc || this.r;
    this.c = compiler;
    this.options = options;
    this.text = text || '';
    this.buf = (useArrayBuffer) ? [] : '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // tries to find a partial in the curent scope and render it
    rp: function(name, context, partials, indent) {
      var partial = partials[name];

      if (!partial) {
        return '';
      }

      if (this.c && typeof partial == 'string') {
        partial = this.c.compile(partial, this.options);
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ls(val, ctx, partials, inverted, start, end, tags);
      }

      pass = (val === '') || !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        return ctx[ctx.length - 1];
      }

      for (var i = 1; i < names.length; i++) {
        if (val && typeof val == 'object' && names[i] in val) {
          cx = val;
          val = val[names[i]];
        } else {
          val = '';
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.lv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        if (v && typeof v == 'object' && key in v) {
          val = v[key];
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.lv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ho: function(val, cx, partials, text, tags) {
      var compiler = this.c;
      var options = this.options;
      options.delimiters = tags;
      var text = val.call(cx, text);
      text = (text == null) ? String(text) : text.toString();
      this.b(compiler.compile(text, options).render(cx, partials));
      return false;
    },

    // template result buffering
    b: (useArrayBuffer) ? function(s) { this.buf.push(s); } :
                          function(s) { this.buf += s; },
    fl: (useArrayBuffer) ? function() { var r = this.buf.join(''); this.buf = []; return r; } :
                           function() { var r = this.buf; this.buf = ''; return r; },

    // lambda replace section
    ls: function(val, ctx, partials, inverted, start, end, tags) {
      var cx = ctx[ctx.length - 1],
          t = null;

      if (!inverted && this.c && val.length > 0) {
        return this.ho(val, cx, partials, this.text.substring(start, end), tags);
      }

      t = val.call(cx);

      if (typeof t == 'function') {
        if (inverted) {
          return true;
        } else if (this.c) {
          return this.ho(t, cx, partials, this.text.substring(start, end), tags);
        }
      }

      return t;
    },

    // lambda replace variable
    lv: function(val, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = val.call(cx);

      if (typeof result == 'function') {
        result = coerceToString(result.call(cx));
        if (this.c && ~result.indexOf("{\u007B")) {
          return this.c.compile(result, this.options).render(cx, partials);
        }
      }

      return coerceToString(result);
    }

  };

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos =/\'/g,
      rQuot = /\"/g,
      hChars =/[&<>\"\']/;


  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp,'&amp;')
        .replace(rLt,'&lt;')
        .replace(rGt,'&gt;')
        .replace(rApos,'&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);




(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      tagTypes = {
        '#': 1, '^': 2, '/': 3,  '!': 4, '>': 5,
        '<': 6, '=': 7, '_v': 8, '{': 9, '&': 10
      };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push(new String(buf));
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (tokens[j].tag && tagTypes[tokens[j].tag] < tagTypes['_v']) ||
          (!tokens[j].tag && tokens[j].match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (!tokens[j].tag) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = tagTypes[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - ctag.length : i + otag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        token = null;

    while (tokens.length > 0) {
      token = tokens.shift();
      if (token.tag == '#' || token.tag == '^' || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
        instructions.push(token);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else {
        instructions.push(token);
      }
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  Hogan.generate = function (tree, text, options) {
    var code = 'var _=this;_.b(i=i||"");' + walk(tree) + 'return _.fl();';
    if (options.asString) {
      return 'function(c,p,i){' + code + ';}';
    }

    return new Hogan.Template(new Function('c', 'p', 'i', code), text, Hogan, options);
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function walk(tree) {
    var code = '';
    for (var i = 0, l = tree.length; i < l; i++) {
      var tag = tree[i].tag;
      if (tag == '#') {
        code += section(tree[i].nodes, tree[i].n, chooseMethod(tree[i].n),
                        tree[i].i, tree[i].end, tree[i].otag + " " + tree[i].ctag);
      } else if (tag == '^') {
        code += invertedSection(tree[i].nodes, tree[i].n,
                                chooseMethod(tree[i].n));
      } else if (tag == '<' || tag == '>') {
        code += partial(tree[i]);
      } else if (tag == '{' || tag == '&') {
        code += tripleStache(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag == '\n') {
        code += text('"\\n"' + (tree.length-1 == i ? '' : ' + i'));
      } else if (tag == '_v') {
        code += variable(tree[i].n, chooseMethod(tree[i].n));
      } else if (tag === undefined) {
        code += text('"' + esc(tree[i]) + '"');
      }
    }
    return code;
  }

  function section(nodes, id, method, start, end, tags) {
    return 'if(_.s(_.' + method + '("' + esc(id) + '",c,p,1),' +
           'c,p,0,' + start + ',' + end + ',"' + tags + '")){' +
           '_.rs(c,p,' +
           'function(c,p,_){' +
           walk(nodes) +
           '});c.pop();}';
  }

  function invertedSection(nodes, id, method) {
    return 'if(!_.s(_.' + method + '("' + esc(id) + '",c,p,1),c,p,1,0,0,"")){' +
           walk(nodes) +
           '};';
  }

  function partial(tok) {
    return '_.b(_.rp("' +  esc(tok.n) + '",c,p,"' + (tok.indent || '') + '"));';
  }

  function tripleStache(id, method) {
    return '_.b(_.t(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function variable(id, method) {
    return '_.b(_.v(_.' + method + '("' + esc(id) + '",c,p,0)));';
  }

  function text(id) {
    return '_.b(' + id + ');';
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  },

  Hogan.cache = {};

  Hogan.compile = function(text, options) {
    // options
    //
    // asString: false (default)
    //
    // sectionTags: [{o: '_foo', c: 'foo'}]
    // An array of object with o and c fields that indicate names for custom
    // section tags. The example above allows parsing of {{_foo}}{{/foo}}.
    //
    // delimiters: A string that overrides the default delimiters.
    // Example: "<% %>"
    //
    options = options || {};

    var key = text + '||' + !!options.asString;

    var t = this.cache[key];

    if (t) {
      return t;
    }

    t = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = t;
  };
})(typeof exports !== 'undefined' ? exports : Hogan);


},{}]},{},[1])

